import {
  AbilityCreateRequest,
  AcceptCallData,
  AcceptCallError,
  AcceptCallParams,
  AcceptCallRequest,
  AcceptShiftInvitationData,
  AcceptShiftInvitationError,
  AccessRequest,
  AddTaskNoteData,
  AddTaskNoteError,
  AddTaskNoteParams,
  AddressVerificationRequest,
  AdminCreateTimeOffRequestData,
  AdminCreateTimeOffRequestError,
  AdminCreateTimeOffRequestParams,
  AdminListAllStaffUnavailabilitiesData,
  AdminListAllStaffUnavailabilitiesError,
  AdminListAllStaffUnavailabilitiesParams,
  AdminListNewsArticlesData,
  AdminListTimeOffRequestsData,
  AdminListTimeOffRequestsError,
  AdminListTimeOffRequestsParams,
  AdminRegisterAttendeeRequest,
  AdminTimeOverrideRequest,
  AnalyzeTravelRecordsData,
  AppApisAdminActionsAppointmentUpdateRequest,
  AppApisAppointmentRequestsAppointmentRequestCreate,
  AppApisAppointmentsAppointmentRequestCreate,
  AppApisAppointmentsAppointmentUpdateRequest,
  AppApisAppointmentsIndividualCancellationRequest,
  AppApisAppointmentsIndividualRebookRequest,
  AppApisAppointmentsManualTimeOverrideRequest,
  AppApisEventsIndividualCancellationRequest,
  AppApisEventsIndividualRebookRequest,
  AppApisStaffScheduleManualTimeOverrideRequest,
  AppApisTimeTrackingEndWorkRequest,
  AppApisWorkTimeTrackingEndWorkRequest,
  ApplyBulkUpdateData,
  ApplyBulkUpdateError,
  AppointmentConfirmationRequest,
  ApprovalRequest,
  ApproveAndSyncInvoicesData,
  ApproveAndSyncInvoicesError,
  ApproveAndSyncRequest,
  ApproveAttendanceTimesData,
  ApproveAttendanceTimesError,
  ApproveBillingData,
  ApproveBillingError,
  ApproveBillingLineItemData,
  ApproveBillingLineItemError,
  ApproveBillingLineItemRequest,
  ApproveBillingRequest,
  ApproveTimeOffRequestData,
  ApproveTimeOffRequestError,
  ApproveTimeOffRequestParams,
  AssignInterestedStaffData,
  AssignInterestedStaffError,
  AssignInterestedStaffParams,
  AssignStaffRequest,
  AssignStaffToJourneyData,
  AssignStaffToJourneyError,
  AssignStaffToJourneyParams,
  AssignStaffToJourneyRequest,
  AssignVehicleRequest,
  AssignVehicleToJourneyData,
  AssignVehicleToJourneyError,
  AssignVehicleToJourneyParams,
  AssignVehicleToTransportBookingData,
  AssignVehicleToTransportBookingError,
  AssignVehicleToTransportBookingParams,
  AttendanceApprovalRequest,
  AuditAppointmentConsistencyData,
  AutoGenerateLunchBreaksData,
  AutoGenerateLunchBreaksError,
  AutoGenerateLunchBreaksRequest,
  BatchAllowancesRequest,
  BillingContactCreate,
  BillingContactUpdate,
  BillingRecordPreviewRequest,
  BodyUploadClientQualificationImage,
  BodyUploadEventImage,
  BodyUploadEventVideo,
  BodyUploadStaffProfileImage,
  BodyUploadStaffQualificationImage,
  BodyUploadVehicleImage,
  BootstrapAdminData,
  BootstrapAdminError,
  BootstrapAdminUserRolesData,
  BootstrapDevAdminData,
  BootstrapTilCacheData,
  BulkApproveTimesheetEntriesData,
  BulkApproveTimesheetEntriesError,
  BulkCalculateAndStoreTravelData,
  BulkCalculateAndStoreTravelError,
  BulkCalculateAndStoreTravelSegmentsData,
  BulkCalculateAndStoreTravelSegmentsError,
  BulkCalculateTravelRequest,
  BulkCreateTravelSegmentsRequest,
  BulkGenerateRequest,
  BulkGenerationRequest,
  BulkSyncLeaveRequestsData,
  BulkSyncLeaveRequestsError,
  BulkSyncRequest,
  BulkTimesheetApprovalRequest,
  BulkUpdateRequest,
  BulkUpdateSeriesAppointmentsData,
  BulkUpdateSeriesAppointmentsError,
  BulkUpdateSeriesAppointmentsParams,
  BulkUpdateSeriesRequest,
  BusinessDetailsUpdate,
  CalculateAndStoreTravelData,
  CalculateAndStoreTravelError,
  CalculateAndStoreTravelSegmentsData,
  CalculateAndStoreTravelSegmentsError,
  CalculateAppointmentCostData,
  CalculateAppointmentCostError,
  CalculateLegacyPricingData,
  CalculateLegacyPricingError,
  CalculateLegacyPricingParams,
  CalculatePriceData,
  CalculatePriceError,
  CalculateTravelBetweenAddressesData,
  CalculateTravelBetweenAddressesError,
  CalculateTravelData,
  CalculateTravelError,
  CalculateTravelRequest,
  CancelIndividualAttendanceAppointmentData,
  CancelIndividualAttendanceAppointmentError,
  CancelIndividualAttendanceAppointmentParams,
  CancelIndividualAttendanceEventData,
  CancelIndividualAttendanceEventError,
  CancelIndividualAttendanceEventParams,
  CancelInvitationData,
  CancelInvitationError,
  CancelInvitationParams,
  CancelJobBoardInvitationData,
  CancelJobBoardInvitationError,
  CancelJobBoardInvitationParams,
  CancelPickupRequestData,
  CancelPickupRequestError,
  CancelPickupRequestParams,
  CancelTimeOffRequestData,
  CancelTimeOffRequestError,
  CancelTimeOffRequestParams,
  UpdateTimeOffRequestData,
  UpdateTimeOffRequestError,
  UpdateTimeOffRequestParams,
  UpdateTimeOffRequestPayload,
  CategoryCreate,
  CategoryUpdate,
  CheckActiveShiftsData,
  CheckActiveUnplannedWorkData,
  CheckActiveUnplannedWorkError,
  CheckActiveUnplannedWorkParams,
  CheckApprovalStatusData,
  CheckApprovalStatusError,
  CheckApprovalStatusParams,
  CheckHealthData,
  CheckHealthMyNewApiData,
  CheckLunchBreakConflictsData,
  CheckLunchBreakConflictsError,
  CheckMigrationStatusData,
  CheckVehicleAvailabilityData,
  CheckVehicleAvailabilityError,
  CheckWorkingHoursConsistencyData,
  CleanupDuplicateTravelRecordsData,
  CleanupDuplicateTravelRecordsError,
  CleanupDuplicateTravelRecordsParams,
  CleanupProcessedEventsData,
  ClearAllNotificationsData,
  ClearAllNotificationsError,
  ClearAllNotificationsParams,
  ClearCacheData,
  CommunityEventCreate,
  CommunityEventResponse,
  CommunityEventsListResponse,
  CommunityEventUpdate,
  ClearCacheError,
  ClearCacheRequest,
  ClientAppointmentRequestCreate,
  ClientCancelAcceptedAppointmentData,
  ClientCancelAcceptedAppointmentError,
  ClientCancelAcceptedAppointmentParams,
  ClientCancelAppointmentRequestData,
  ClientCancelAppointmentRequestError,
  ClientCancelAppointmentRequestParams,
  ClientCreateAppointmentRequestData,
  ClientCreateAppointmentRequestError,
  ClientMedicalConditionsUpdate,
  ClientQualificationCreate,
  ClientQualificationUpdate,
  ClientUpdateOptional,
  ClockInData,
  ClockInError,
  ClockInParams,
  ClockInRequest,
  ClockInTravelData,
  ClockInTravelError,
  ClockOutData,
  ClockOutError,
  ClockOutParams,
  ClockOutRequest,
  ClockOutTravelData,
  ClockOutTravelError,
  CompleteSignupData,
  CompleteSignupError,
  CompleteSignupParams,
  ConfirmAppointmentData,
  ConfirmAppointmentError,
  ConfirmAppointmentParams,
  ConflictCheckRequest,
  ConsolidateAttendanceDataData,
  ConsolidateAttendanceDataError,
  ConsolidateAttendanceDataParams,
  CountActiveShiftsData,
  CountPendingAccessRequestsData,
  CountPendingInvitationsData,
  CountUnreviewedIncidentsData,
  CreateAbilityData,
  CreateAbilityError,
  CreateAppointmentNoteData,
  CreateAppointmentNoteError,
  CreateAppointmentNoteParams,
  CreateAppointmentRequestData,
  CreateAppointmentRequestError,
  CreateBillingContactData,
  CreateBillingContactError,
  CreateCallMessageData,
  CreateCallMessageError,
  CreateCallMessageRequest,
  CreateCategoryData,
  CreateCategoryError,
  CreateClientData,
  CreateClientError,
  CreateClientQualificationData,
  CreateClientQualificationError,
  CreateClientQualificationParams,
  CreateClientRequest,
  CreateEventData,
  CreateEventError,
  CreateEventTransportBookingsData,
  CreateEventTransportBookingsError,
  CreateEventTransportBookingsParams,
  CreateExpenseClaimData,
  CreateExpenseClaimError,
  CreateIncidentReportData,
  CreateIncidentReportError,
  CreateInvitationData,
  CreateInvitationError,
  CreateInvitationRequest,
  CreateJobBoardEntryData,
  CreateJobBoardEntryError,
  CreateJourneyData,
  CreateJourneyError,
  CreateJourneyParams,
  CreateJourneyRequest,
  CreateLunchBreakData,
  CreateLunchBreakError,
  CreateMedicalConditionData,
  CreateMedicalConditionError,
  CreateNewsArticleData,
  CreateNewsArticleError,
  CreateNewsRequest,
  CreateOfficeTaskData,
  CreateOfficeTaskError,
  CreateOvertimeAndTilTransactionsData,
  CreateOvertimeAndTilTransactionsError,
  CreateOvertimeTransactionRequest,
  CreatePickupRequestData,
  CreatePickupRequestError,
  CreatePickupRequestRequest,
  CreatePlaceData,
  CreatePlaceError,
  CreatePriceBookData,
  CreatePriceBookError,
  CreateScheduledAppointmentData,
  CreateScheduledAppointmentError,
  CreateServiceData,
  CreateServiceError,
  CreateStaffData,
  CreateStaffError,
  CreateStaffQualificationData,
  CreateStaffQualificationError,
  CreateStaffQualificationParams,
  CreateStaffRequest,
  CreateSupportCoordinatorData,
  CreateSupportCoordinatorError,
  CreateTaskData,
  CreateTaskError,
  CreateTaskParams,
  CreateTimeOffRequestData,
  CreateTimeOffRequestError,
  CreateTransportBookingsForEventData,
  CreateTransportBookingsForEventError,
  CreateTransportBookingsForEventParams,
  CreateTransportBookingsForEventPayload,
  CreateTravelSegmentsRequest,
  CreateUnavailabilityData,
  CreateUnavailabilityError,
  CreateVehicleData,
  CreateVehicleError,
  CronSettingsData,
  DebugAppointmentAuthorizationData,
  DebugAppointmentAuthorizationError,
  DebugAppointmentAuthorizationParams,
  DebugTravelVehiclesData,
  DebugUserInfoData,
  DebugUserInfoStaffattendanceData,
  DeclineShiftInvitationData,
  DeclineShiftInvitationError,
  DeleteAbilityData,
  DeleteAbilityError,
  DeleteAbilityParams,
  DeleteAppointmentData,
  DeleteAppointmentError,
  DeleteAppointmentParams,
  DeleteAppointmentRequest,
  DeleteAppointmentWithRequestBodyData,
  DeleteAppointmentWithRequestBodyError,
  DeleteBillingContactData,
  DeleteBillingContactError,
  DeleteBillingContactParams,
  DeleteCategoryData,
  DeleteCategoryError,
  DeleteCategoryParams,
  DeleteClientQualificationData,
  DeleteClientQualificationError,
  DeleteClientQualificationParams,
  DeleteEventData,
  DeleteEventError,
  DeleteEventParams,
  DeleteExpenseClaimData,
  DeleteExpenseClaimError,
  DeleteExpenseClaimParams,
  DeleteJourneyData,
  DeleteJourneyError,
  DeleteJourneyParams,
  DeleteLunchBreakData,
  DeleteLunchBreakError,
  DeleteLunchBreakParams,
  DeleteMedicalConditionData,
  DeleteMedicalConditionError,
  DeleteMedicalConditionParams,
  DeleteNewsArticleData,
  DeleteNewsArticleError,
  DeleteNewsArticleParams,
  DeleteOfficeTaskData,
  DeleteOfficeTaskError,
  DeleteOfficeTaskParams,
  DeletePlaceData,
  DeletePlaceError,
  DeletePlaceParams,
  DeletePriceBookData,
  DeletePriceBookError,
  DeletePriceBookParams,
  DeleteServiceData,
  DeleteServiceError,
  DeleteServiceParams,
  DeleteSignalData,
  DeleteSignalError,
  DeleteSignalParams,
  DeleteStaffQualificationData,
  DeleteStaffQualificationError,
  DeleteStaffQualificationParams,
  DeleteSupportCoordinatorData,
  DeleteSupportCoordinatorError,
  DeleteSupportCoordinatorParams,
  DeleteTaskData,
  DeleteTaskError,
  DeleteTaskParams,
  DeleteTravelRequest,
  DeleteTravelSegmentData,
  DeleteTravelSegmentError,
  DeleteTravelSegmentsForStaffDateData,
  DeleteTravelSegmentsForStaffDateError,
  DeleteTravelSegmentsForStaffDateParams,
  DeleteUnavailabilityData,
  DeleteUnavailabilityError,
  DeleteUnavailabilityParams,
  DeleteVehicleData,
  DeleteVehicleError,
  DeleteVehicleParams,
  DetectDuplicateTravelRecordsData,
  DetectDuplicateTravelRecordsError,
  DetectDuplicateTravelRecordsParams,
  DisconnectCalendarData,
  DisconnectXeroData,
  DuplicateAppointmentData,
  DuplicateAppointmentError,
  DuplicateAppointmentRequest,
  DuplicateAppointmentWithSeriesData,
  DuplicateAppointmentWithSeriesError,
  DuplicateAppointmentWithSeriesRequest,
  EndUnplannedWorkData,
  EndUnplannedWorkError,
  EndUnplannedWorkRequest,
  EndWorkData,
  EndWorkError,
  EventCreate,
  EventInterestRequest,
  EventUpdate,
  ExpenseClaimCreate,
  ExpenseClaimUpdate,
  ExpressJobInterestData,
  ExpressJobInterestError,
  ExpressJobInterestParams,
  FixAppointmentConsistencyData,
  FixAppointmentTimingData,
  FixAppointmentTimingError,
  FixAppointmentTimingParams,
  FixClientBillingData,
  FixClientBillingError,
  FixClientBillingParams,
  GenerateBulkLunchBreaksData,
  GenerateBulkLunchBreaksError,
  GenerateInvoiceRequest,
  GenerateInvoicesData,
  GenerateInvoicesError,
  GeneratePayrollEntriesData,
  GeneratePayrollEntriesError,
  GeneratePayrollEntryData,
  GeneratePayrollEntryError,
  GetActivePriceBookForServiceData,
  GetActivePriceBookForServiceError,
  GetActivePriceBookForServiceParams,
  GetActiveTravelSegmentsData,
  GetAdminUsersData,
  GetAllClientConversationsData,
  GetAllClientConversationsError,
  GetAllClientConversationsParams,
  GetAllMyNotesData,
  GetAllPriceBookChangesData,
  GetAllPriceBookChangesError,
  GetAllPriceBookChangesParams,
  GetAppointmentStatusCountData,
  GetAutoSyncStatusData,
  GetBasicUserDetailsData,
  GetBasicUserDetailsError,
  GetBasicUserDetailsParams,
  GetBatchAllowancesData,
  GetBatchAllowancesError,
  GetBillingContactData,
  GetBillingContactError,
  GetBillingContactParams,
  GetBrowserCacheStatusData,
  GetBulkStaffCalendarEventsData,
  GetBulkStaffCalendarEventsError,
  GetBulkStaffCalendarEventsParams,
  GetBusinessDetailsData,
  GetCacheStatsData,
  GetCalendarStatusData,
  GetClientDiaryAppointmentsData,
  GetClientDiaryAppointmentsError,
  GetClientDiaryAppointmentsParams,
  GetClientMedicalConditionsData,
  GetClientMedicalConditionsError,
  GetClientMedicalConditionsParams,
  GetClientMedicalRecordData,
  GetClientMedicalRecordError,
  GetClientMedicalRecordParams,
  GetClientQualificationImageData,
  GetClientQualificationImageError,
  GetClientQualificationImageParams,
  GetClientTransportBookingsData,
  GetClientTransportBookingsForStaffData,
  GetClientTransportBookingsForStaffError,
  GetClientTransportBookingsForStaffParams,
  GetCronSettingsData,
  GetDailyDiaryDataData,
  GetDailyDiaryDataError,
  GetDailyDiaryDataParams,
  GetDiaryJourneyDataData,
  GetDiaryJourneyDataError,
  GetDiaryJourneyDataParams,
  GetDocumentLogsData,
  GetDocumentLogsError,
  GetDocumentLogsParams,
  GetDuplicateStatisticsData,
  GetEarningsRateMappingsData,
  GetEventAttendeesData,
  GetEventAttendeesError,
  GetEventAttendeesParams,
  GetEventData,
  GetEventError,
  GetEventImageData,
  GetEventImageError,
  GetEventImageParams,
  GetEventParams,
  GetEventVideoData,
  GetEventVideoError,
  GetEventVideoParams,
  GetExpenseClaimData,
  GetExpenseClaimError,
  GetExpenseClaimParams,
  GetGoogleMapsApiKeyProtectedData,
  GetGoogleMapsApiKeyPublicData,
  GetInReviewItemsData,
  GetIncidentReportData,
  GetIncidentReportError,
  GetIncidentReportParams,
  GetIncompleteOfficeTaskCountData,
  GetIncompleteTaskCountData,
  GetIncompleteTaskCountError,
  GetIncompleteTaskCountParams,
  GetInvitationStatsData,
  GetInvitationStatsError,
  GetInvitationStatsParams,
  GetInvoiceData,
  GetInvoiceError,
  GetInvoiceParams,
  GetInvoiceSummaryData,
  GetInvoiceSummaryError,
  GetInvoiceSummaryParams,
  GetLeaveSyncStatusData,
  GetLeaveSyncStatusError,
  GetLeaveSyncStatusParams,
  GetLightweightDiaryDataData,
  GetLightweightDiaryDataError,
  GetLightweightDiaryDataParams,
  GetMedicalConditionCategoriesData,
  GetNewsArticleData,
  GetNewsArticleError,
  GetNewsArticleParams,
  GetNotificationPreferencesData,
  GetOauthConfigData,
  GetOvertimeSummaryData,
  GetOvertimeSummaryError,
  GetOvertimeSummaryParams,
  GetPendingInvitationsCountData,
  GetPendingLeaveCountData,
  GetPendingTilCountData,
  GetPickupRequestData,
  GetPickupRequestError,
  GetPickupRequestParams,
  GetPlaceData,
  GetPlaceError,
  GetPlaceParams,
  GetPriceBookData,
  GetPriceBookError,
  GetPriceBookHistoryData,
  GetPriceBookHistoryError,
  GetPriceBookHistoryParams,
  GetPriceBookParams,
  GetProblematicAppointmentsData,
  GetProblematicAppointmentsError,
  GetProblematicAppointmentsParams,
  GetProcessedEventsData,
  GetPublicEventData,
  GetPublicEventError,
  GetPublicEventParams,
  GetQualificationImageData,
  GetQualificationImageError,
  GetQualificationImageParams,
  GetRedirectUriInfoData,
  GetSeriesEventsData,
  GetSeriesEventsError,
  GetSeriesEventsParams,
  GetServiceData,
  GetServiceDefaultsData,
  GetServiceDefaultsError,
  GetServiceDefaultsParams,
  GetServiceError,
  GetServiceHistoryData,
  GetServiceHistoryError,
  GetServiceHistoryParams,
  GetServiceParams,
  GetShiftNotesData,
  GetShiftNotesError,
  GetShiftNotesParams,
  GetSignalsData,
  GetSignalsError,
  GetSignalsParams,
  GetSmtpSettingsData,
  GetStaffAllowancesData,
  GetStaffAllowancesError,
  GetStaffAllowancesParams,
  GetStaffCalendarEventsData,
  GetStaffCalendarEventsError,
  GetStaffCalendarEventsParams,
  GetStaffProfileImageData,
  GetStaffProfileImageError,
  GetStaffProfileImageParams,
  GetStaffTimesData,
  GetStaffTimesError,
  GetStaffTimesParams,
  GetStaffTimesheetForApprovalData,
  GetStaffTimesheetForApprovalError,
  GetStaffTimesheetForApprovalParams,
  GetStaffTravelCalculationData,
  GetStaffTravelCalculationError,
  GetStaffTravelCalculationParams,
  GetStaffWorkingHoursData,
  GetStaffWorkingHoursError,
  GetStaffWorkingHoursParams,
  GetSupportCoordinatorData,
  GetSupportCoordinatorError,
  GetSupportCoordinatorParams,
  GetSyncStatusData,
  GetSyncedEventsData,
  GetTaskData,
  GetTaskError,
  GetTaskParams,
  GetTaskTimeTrackingData,
  GetTaskTimeTrackingError,
  GetTaskTimeTrackingParams,
  GetTilBalanceWithTransactionsData,
  GetTilBalanceWithTransactionsError,
  GetTilBalanceWithTransactionsParams,
  GetTimesheetSummaryData,
  GetTimesheetSummaryError,
  GetTimesheetSummaryParams,
  GetTimesheetSummaryV2Data,
  GetTimesheetSummaryV2Error,
  GetTimesheetSummaryV2Params,
  GetTransportBookingData,
  GetTransportBookingError,
  GetTransportBookingParams,
  GetTransportBookingWithJourneysData,
  GetTransportBookingWithJourneysError,
  GetTransportBookingWithJourneysParams,
  GetTravelConfirmationDataData,
  GetTravelConfirmationDataError,
  GetTravelConfirmationDataParams,
  GetTravelSegmentsForStaffDateData,
  GetTravelSegmentsForStaffDateError,
  GetTravelSegmentsForStaffDateParams,
  GetTravelStatusData,
  GetTravelStatusError,
  GetTravelStatusParams,
  GetUnapprovedAttendanceData,
  GetUnapprovedAttendanceError,
  GetUnapprovedAttendanceParams,
  GetUserClaimsData,
  GetUserEmailsBatchData,
  GetUserEmailsBatchError,
  GetVehicleData,
  GetVehicleError,
  GetVehicleImageData,
  GetVehicleImageError,
  GetVehicleImageParams,
  GetVehicleParams,
  GetWorkStatusData,
  GetWorkStatusError,
  GetWorkStatusParams,
  GetXeroConnectionStatusData,
  GetXeroEarningsRatesData,
  GetXeroEmployeesData,
  GetXeroSyncStatusData,
  GetXeroSyncStatusError,
  GetXeroSyncStatusParams,
  HandleOauthCallbackData,
  HandleOauthCallbackError,
  HandleOauthCallbackParams,
  HandleXeroCallbackData,
  HandleXeroCallbackError,
  HandleXeroCallbackParams,
  HealthCheckData,
  IncidentReportRequest,
  InitiateCallData,
  InitiateCallError,
  InitiateCallRequest,
  InitiateXeroConnectionData,
  InternalPingStaffTestFuncData,
  InternalPingStaffTestFuncError,
  InvalidateBrowserCacheData,
  InviteStaffToJobData,
  InviteStaffToJobError,
  InviteStaffToJobParams,
  JobBoardEntryRequest,
  JobInterestRequest,
  ListAbilitiesData,
  ListAccessRequestsData,
  ListAccessRequestsError,
  ListAccessRequestsParams,
  ListAdminAppointmentsData,
  ListAdminAppointmentsError,
  ListAdminAppointmentsLightData,
  ListAdminAppointmentsLightError,
  ListAdminAppointmentsLightParams,
  ListAdminAppointmentsParams,
  ListAllAppointmentLogsData,
  ListAllAppointmentLogsError,
  ListAllAppointmentLogsParams,
  ListAppointmentNotesData,
  ListAppointmentNotesError,
  ListAppointmentNotesParams,
  ListBillingContactsData,
  ListCategoriesData,
  ListClientQualificationsData,
  ListClientQualificationsError,
  ListClientQualificationsParams,
  ListClientSideServicesData,
  ListClientsData,
  ListEventsData,
  ListEventsError,
  ListEventsParams,
  ListIncidentReportsData,
  ListInvitationsData,
  ListInvitationsError,
  ListInvitationsParams,
  ListInvoicesData,
  ListInvoicesError,
  ListInvoicesParams,
  ListJobBoardEntriesData,
  ListJobBoardEntriesError,
  ListJobBoardEntriesParams,
  ListJobBoardInvitationsData,
  ListJobBoardInvitationsError,
  ListJobBoardInvitationsParams,
  ListLunchBreaksData,
  ListLunchBreaksError,
  ListLunchBreaksParams,
  ListMedicalConditionsData,
  ListMedicalConditionsError,
  ListMedicalConditionsParams,
  ListMyExpenseClaimsData,
  ListMyExpenseClaimsError,
  ListMyExpenseClaimsParams,
  ListNewsArticlesData,
  ListNewsArticlesError,
  ListNewsArticlesParams,
  ListOfficeTasksData,
  ListOfficeTasksError,
  ListOfficeTasksParams,
  ListPayrollEntriesData,
  ListPayrollEntriesError,
  ListPayrollEntriesParams,
  ListPendingAppointmentsData,
  ListPendingInvitationsData,
  ListPlacesData,
  ListPriceBooksData,
  ListPriceBooksError,
  ListPriceBooksParams,
  ListPublicEventsData,
  ListPublicEventsError,
  ListPublicEventsParams,
  ListServicesData,
  ListStaffAttendanceData,
  ListStaffAttendanceEntriesData,
  ListStaffAttendanceEntriesError,
  ListStaffAttendanceEntriesParams,
  ListStaffAttendanceError,
  ListStaffAttendanceParams,
  ListStaffForTimesheetData,
  ListStaffMembersData,
  ListStaffQualificationsData,
  ListStaffQualificationsError,
  ListStaffQualificationsParams,
  ListStaffUnavailabilitiesData,
  ListStaffUnavailabilitiesError,
  ListStaffUnavailabilitiesParams,
  ListSupportCoordinatorsData,
  ListTaskNotesData,
  ListTaskNotesError,
  ListTaskNotesParams,
  ListTasksData,
  ListTasksError,
  ListTasksParams,
  ListTimeOffRequestsData,
  ListTimeOffRequestsError,
  ListTimeOffRequestsParams,
  ListTransportBookingsData,
  ListTransportBookingsError,
  ListTransportBookingsParams,
  ListUnassignedAppointmentsData,
  ListUnassignedAppointmentsOptimizedData,
  ListVehiclesData,
  ListVehiclesError,
  ListVehiclesParams,
  ListWeeklyLunchBreaksData,
  ListWeeklyLunchBreaksError,
  ListWeeklyLunchBreaksParams,
  LogManualChangeData,
  LogManualChangeError,
  LogManualChangeRequest,
  LunchBreakRequest,
  ManualClockTimeOverrideData,
  ManualClockTimeOverrideError,
  ManualClockTimeOverrideParams,
  ManualTimeAdjustmentLegacyData,
  ManualTimeAdjustmentLegacyError,
  ManualTimeAdjustmentRequest,
  ManualTimeOverrideData,
  ManualTimeOverrideError,
  ManualTravelTimeOverrideData,
  ManualTravelTimeOverrideError,
  ManualTravelTimeOverrideParams,
  MapStaffRequest,
  MapStaffToEmployeeData,
  MapStaffToEmployeeError,
  MarkAllNotificationsAsReadData,
  MarkAppointmentCompletedData,
  MarkAppointmentCompletedError,
  MarkAppointmentCompletedParams,
  MarkAsReadRequest,
  MarkBillingForReviewData,
  MarkBillingForReviewError,
  MarkEventProcessedData,
  MarkEventProcessedError,
  MarkEventProcessedPayload,
  MarkForReviewRequest,
  MarkIncidentReviewedData,
  MarkIncidentReviewedError,
  MarkIncidentReviewedParams,
  MarkNotificationAsReadData,
  MarkNotificationAsReadError,
  MedicalConditionCreate,
  MedicalConditionUpdate,
  MedicalRecordUpdate,
  MigrateAllImagesData,
  MigrateAppointmentNotesClientidsData,
  MigrateClientBillingStructureData,
  MigrateDenormalizedFieldsData,
  MigrateFromStorageData,
  MigrateOfficeAddressesData,
  MigrateOvertimeChoicesData,
  MigrateOvertimeChoicesError,
  MigrateOvertimeChoicesParams,
  MigrateToAbRosterData,
  MigrateTravelRecordsData,
  MigrateWorkingHoursToCollectionData,
  MoveClientBetweenJourneysData,
  MoveClientBetweenJourneysError,
  MoveClientBetweenJourneysParams,
  MoveClientBetweenJourneysRequest,
  NewScheduledAppointmentData,
  NoteCreateRequest,
  Oauth2CallbackData,
  OfficeTaskCreateRequest,
  OfficeTaskNoteRequest,
  OfficeTaskUpdateRequest,
  OptimizeJourneyRouteData,
  OptimizeJourneyRouteError,
  OptimizeJourneyRouteParams,
  OptimizeRouteRequest,
  OptimizeTransportRouteData,
  OptimizeTransportRouteError,
  OptimizeTransportRouteParams,
  OverrideAttendanceTimeData,
  OverrideAttendanceTimeError,
  OvertimeChoiceUpdate,
  PayrollEntryRequest,
  PingAdminTimesheetData,
  PingAttendanceApprovalData,
  PingMigrationData,
  PingOvertimeTransactionsData,
  PingRequest,
  PingTestStaffQualData,
  PingTimeOffApiData,
  PingTimesheetSummaryData,
  PingTimesheetSummaryV2Data,
  PingTransportJourneyManagementData,
  PingTravelTrackingData,
  PingVehiclesData,
  PlaceCreate,
  PlaceUpdate,
  PopulateLunchBreaks6MonthsData,
  PostJobToBoardData,
  PostJobToBoardError,
  PreviewAddressMigrationData,
  PreviewApprovedBillingData,
  PreviewApprovedBillingError,
  PreviewBulkUpdateData,
  PreviewBulkUpdateError,
  PreviewMigrationData,
  PriceBookCreate,
  PriceBookUpdate,
  PriceCalculationRequest,
  ProcessAccessRequestData,
  ProcessAccessRequestError,
  PushTimesheetsData,
  PushTimesheetsError,
  PushTimesheetsRequest,
  QualificationCreate,
  QualificationUpdate,
  QualificationsPingTestData,
  QualificationsPingTestError,
  QualificationsPingTestParams,
  QuickMigrateOfficeAddressData,
  ReassignClientBetweenJourneysData,
  ReassignClientBetweenJourneysError,
  ReassignClientBetweenJourneysPayload,
  RebookCancelledPickupRequestData,
  RebookCancelledPickupRequestError,
  RebookCancelledPickupRequestParams,
  RebookCancelledTransportBookingData,
  RebookCancelledTransportBookingError,
  RebookCancelledTransportBookingParams,
  RebookClientFromAppointmentData,
  RebookClientFromAppointmentError,
  RebookClientFromAppointmentParams,
  RebookClientRequest,
  RebookIndividualAttendanceAppointmentData,
  RebookIndividualAttendanceAppointmentError,
  RebookIndividualAttendanceAppointmentParams,
  RebookIndividualAttendanceEventData,
  RebookIndividualAttendanceEventError,
  RebookIndividualAttendanceEventParams,
  RecalculateTravelForAppointmentChangeData,
  RecalculateTravelForAppointmentChangeError,
  RecalculateTravelForAppointmentChangeParams,
  RefreshInvoiceStatusData,
  RefreshInvoiceStatusError,
  RefreshSpecificRecordsData,
  RefreshSpecificRecordsError,
  RefreshSpecificRecordsRequest,
  RefreshStatusRequest,
  RegisterAttendeeData,
  RegisterAttendeeError,
  RegisterAttendeeParams,
  RegisterInterestData,
  RegisterInterestError,
  RegisterInterestParams,
  RejectTimeOffRequestData,
  RejectTimeOffRequestError,
  RejectTimeOffRequestParams,
  RemoveFromJobBoardData,
  RemoveFromJobBoardError,
  RemoveFromJobBoardParams,
  RemoveLunchBreaksForTimeOffData,
  RemoveLunchBreaksForTimeOffError,
  RemoveLunchBreaksForTimeOffParams,
  RemoveStaffInvitationStatusData,
  RemoveStaffInvitationStatusError,
  RemoveStaffInvitationStatusParams,
  RemoveStaffTimeOverrideData,
  RemoveStaffTimeOverrideError,
  RemoveStaffTimeOverrideParams,
  RequestAppointmentLegacyData,
  RequestAppointmentLegacyError,
  RespondToInvitationData,
  RespondToInvitationError,
  RespondToInvitationParams,
  RespondToInvitationRequest,
  RespondToJobBoardInvitationData,
  RespondToJobBoardInvitationError,
  RespondToJobBoardInvitationRequest,
  RetryTilTransactionForApprovalData,
  RetryTilTransactionForApprovalError,
  RetryTilTransactionForApprovalParams,
  ReverseGeocodeData,
  ReverseGeocodeError,
  ReverseGeocodeRequest,
  RunAddressMigrationData,
  SMTPSettings,
  SaveAppointmentVehicleAssignmentsData,
  SaveAppointmentVehicleAssignmentsError,
  SaveAppointmentVehicleAssignmentsParams,
  SaveBillingOverrideData,
  SaveBillingOverrideError,
  SaveBillingOverrideRequest,
  SaveEarningsRateMappingsData,
  SaveEarningsRateMappingsError,
  SaveEarningsRateMappingsRequest,
  SaveVehicleAssignmentsRequest,
  Send48HAppointmentRemindersData,
  SendBulkNotificationData,
  SendBulkNotificationError,
  SendBulkNotificationRequest,
  SendChatNotificationData,
  SendChatNotificationError,
  SendChatNotificationRequest,
  SendNotificationData,
  SendNotificationError,
  SendNotificationRequest,
  SendSignalData,
  SendSignalError,
  SendSignalParams,
  SendSignalRequest,
  ServiceCreate,
  ServiceDefaultsUpdate,
  ServiceUpdateOptional,
  SetClaimRequest,
  SetClientVisibilityData,
  SetClientVisibilityError,
  SetClientVisibilityParams,
  SetClientVisibilityRequest,
  SetCustomClaimData,
  SetCustomClaimError,
  SetStaffVisibilityData,
  SetStaffVisibilityError,
  SetStaffVisibilityParams,
  SetVisibilityRequest,
  ShiftInvitationRequest,
  SimpleApprovalRequest,
  SimpleApproveAttendanceData,
  SimpleApproveAttendanceError,
  SplitBillingLineItemData,
  SplitBillingLineItemError,
  SplitBillingRequest,
  SplitTransportBookingData,
  SplitTransportBookingError,
  SplitTransportBookingParams,
  StaffInvitationRequest,
  StaffTimeUpdateRequest,
  StaffUpdateOptional,
  StartAuthData,
  StartAuthUnprotectedData,
  StartBackgroundSyncData,
  StartUnplannedWorkData,
  StartUnplannedWorkError,
  StartUnplannedWorkRequest,
  StartWorkData,
  StartWorkError,
  StartWorkRequest,
  StopBackgroundSyncData,
  SubmitAccessRequestData,
  SubmitAccessRequestError,
  SupportCoordinatorCreate,
  SupportCoordinatorUpdate,
  SyncAfterStatusChangeRequest,
  SyncBackgroundCancelData,
  SyncBackgroundData,
  SyncCalendarData,
  SyncClientRequest,
  SyncClientToXeroData,
  SyncClientToXeroError,
  SyncForAppointmentRequest,
  SyncInvoiceRequest,
  SyncInvoiceToXeroData,
  SyncInvoiceToXeroError,
  SyncLeaveRequest,
  SyncSingleLeaveRequestData,
  SyncSingleLeaveRequestError,
  SyncStaffattendanceAfterStatusChangeEndpointData,
  SyncStaffattendanceAfterStatusChangeEndpointError,
  SyncStaffattendanceForAppointmentEndpointData,
  SyncStaffattendanceForAppointmentEndpointError,
  SyncWorkingHoursForStaffData,
  SyncWorkingHoursForStaffError,
  SyncWorkingHoursForStaffParams,
  TaskCompletionRequest,
  TaskCreateRequest,
  TaskUpdateRequest,
  TestCasualStaffQueriesData,
  TestEventCostData,
  TestEventCostError,
  TestEventCostParams,
  TestSmtpSettingsData,
  TimeOffRequestCreate,
  ToggleTaskCompletionData,
  ToggleTaskCompletionError,
  ToggleTaskCompletionParams,
  TravelBetweenAddressesRequest,
  TravelCalculationRequest,
  TravelClockInRequest,
  TravelClockOutRequest,
  TravelRequest,
  TravelTimeOverrideRequest,
  Trigger48HRemindersWebhookData,
  Trigger48HRemindersWebhookError,
  TriggerManualSyncData,
  TriggerTravelCalculationData,
  TriggerTravelCalculationError,
  UnavailabilityCreateRequest,
  UnavailabilityUpdateRequest,
  UnregisterAttendeeData,
  UnregisterAttendeeError,
  UnregisterAttendeeParams,
  UnregisterInterestData,
  UnregisterInterestError,
  UnregisterInterestParams,
  UpdateAppointmentRequestDetailsData,
  UpdateAppointmentRequestDetailsError,
  UpdateAppointmentRequestDetailsParams,
  UpdateAppointmentRequestDetailsPayload,
  UpdateAppointmentStatusData,
  UpdateAppointmentStatusError,
  UpdateAppointmentStatusLegacyData,
  UpdateAppointmentStatusLegacyError,
  UpdateAppointmentStatusLegacyParams,
  UpdateAppointmentStatusParams,
  UpdateAppointmentVehicleData,
  UpdateAppointmentVehicleError,
  UpdateAppointmentVehicleParams,
  UpdateAppointmentVehicleRequest,
  UpdateBillingContactData,
  UpdateBillingContactError,
  UpdateBillingContactParams,
  UpdateBillingRatioData,
  UpdateBillingRatioError,
  UpdateBusinessDetailsData,
  UpdateBusinessDetailsError,
  UpdateCallStatusData,
  UpdateCallStatusError,
  UpdateCallStatusParams,
  UpdateCallStatusRequest,
  UpdateCategoryData,
  UpdateCategoryError,
  UpdateCategoryParams,
  UpdateClientData,
  UpdateClientError,
  UpdateClientMedicalConditionsData,
  UpdateClientMedicalConditionsError,
  UpdateClientMedicalConditionsParams,
  UpdateClientMedicalRecordData,
  UpdateClientMedicalRecordError,
  UpdateClientMedicalRecordParams,
  UpdateClientParams,
  UpdateClientQualificationData,
  UpdateClientQualificationError,
  UpdateClientQualificationParams,
  UpdateCronSettingsData,
  UpdateCronSettingsError,
  UpdateEventData,
  UpdateEventError,
  UpdateEventParams,
  UpdateExpenseClaimData,
  UpdateExpenseClaimError,
  UpdateExpenseClaimParams,
  UpdateInvoiceStatusData,
  UpdateInvoiceStatusError,
  UpdateInvoiceStatusParams,
  UpdateJourneyData,
  UpdateJourneyError,
  UpdateJourneyOfficeTravelData,
  UpdateJourneyOfficeTravelError,
  UpdateJourneyOfficeTravelParams,
  UpdateJourneyOfficeTravelRequest,
  UpdateJourneyParams,
  UpdateJourneyRequest,
  UpdateLunchBreakData,
  UpdateLunchBreakError,
  UpdateLunchBreakParams,
  UpdateMedicalConditionData,
  UpdateMedicalConditionError,
  UpdateMedicalConditionParams,
  UpdateMileageRequest,
  UpdateNewsArticleData,
  UpdateNewsArticleError,
  UpdateNewsArticleParams,
  UpdateNewsRequest,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesError,
  UpdateOfficeTaskData,
  UpdateOfficeTaskError,
  UpdateOfficeTaskParams,
  UpdateOvertimeChoiceData,
  UpdateOvertimeChoiceError,
  UpdateOvertimeChoiceParams,
  UpdatePickupRequestStatusData,
  UpdatePickupRequestStatusError,
  UpdatePickupRequestStatusParams,
  UpdatePickupStatusRequest,
  UpdatePlaceData,
  UpdatePlaceError,
  UpdatePlaceParams,
  UpdatePreferencesRequest,
  UpdatePriceBookData,
  UpdatePriceBookError,
  UpdatePriceBookParams,
  UpdateRatioRequest,
  UpdateServiceData,
  UpdateServiceDefaultsData,
  UpdateServiceDefaultsError,
  UpdateServiceDefaultsParams,
  UpdateServiceError,
  UpdateServiceParams,
  UpdateSmtpSettingsData,
  UpdateSmtpSettingsError,
  UpdateStaffAllowancesData,
  UpdateStaffAllowancesError,
  UpdateStaffAllowancesParams,
  UpdateStaffAllowancesRequest,
  UpdateStaffData,
  UpdateStaffError,
  UpdateStaffMileageData,
  UpdateStaffMileageError,
  UpdateStaffMileageParams,
  UpdateStaffParams,
  UpdateStaffQualificationData,
  UpdateStaffQualificationError,
  UpdateStaffQualificationParams,
  UpdateStaffTimeRecordData,
  UpdateStaffTimeRecordError,
  UpdateStaffTimeRecordParams,
  UpdateStaffTimesForAppointmentData,
  UpdateStaffTimesForAppointmentError,
  UpdateStaffTimesRequest,
  UpdateStaffWorkingHoursData,
  UpdateStaffWorkingHoursError,
  UpdateStaffWorkingHoursParams,
  UpdateSupportCoordinatorData,
  UpdateSupportCoordinatorError,
  UpdateSupportCoordinatorParams,
  UpdateTaskData,
  UpdateTaskError,
  UpdateTaskParams,
  UpdateTravelSegmentData,
  UpdateTravelSegmentError,
  UpdateTravelSegmentRequest,
  UpdateTravelVehicleData,
  UpdateTravelVehicleError,
  UpdateTravelVehicleRequest,
  UpdateUnavailabilityData,
  UpdateUnavailabilityError,
  UpdateUnavailabilityParams,
  UpdateUserRoleData,
  UpdateUserRoleError,
  UpdateUserRoleRequest,
  UpdateVehicleData,
  UpdateVehicleError,
  UpdateVehicleParams,
  UpdateWebhookKeyData,
  UpdateWebhookKeyError,
  UpdateWebhookKeyRequest,
  UploadClientQualificationImageData,
  UploadClientQualificationImageError,
  UploadClientQualificationImageParams,
  UploadEventImageData,
  UploadEventImageError,
  UploadEventVideoData,
  UploadEventVideoError,
  UploadStaffProfileImageData,
  UploadStaffProfileImageError,
  UploadStaffProfileImageParams,
  UploadStaffQualificationImageData,
  UploadStaffQualificationImageError,
  UploadStaffQualificationImageParams,
  UploadVehicleImageData,
  UploadVehicleImageError,
  UploadVehicleImageParams,
  UserEmailBatchRequest,
  VehicleAvailabilityRequest,
  VehicleCreate,
  VehicleUpdate,
  VerifyAddressData,
  VerifyAddressError,
  WithdrawJobInterestData,
  WithdrawJobInterestError,
  WithdrawJobInterestParams,
  WorkTimeEndData,
  WorkTimeEndError,
  WorkTimeEndParams,
  WorkTimeStartData,
  WorkTimeStartError,
  WorkTimeStartParams,
  WorkingHours,
  XeroWebhookHandlerData,
  XeroWebhookIntentVerificationData,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Brain<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Check health of application. Returns 200 when OK, 500 when not.
   *
   * @name check_health
   * @summary Check Health
   * @request GET:/_healthz
   */
  check_health = (params: RequestParams = {}) =>
    this.request<CheckHealthData, any>({
      path: `/_healthz`,
      method: "GET",
      ...params,
    });

  /**
   * @description Manually create a log entry for a document change, useful for changes made directly to Firestore. This is particularly useful for tracking changes that bypass the normal update API endpoints.
   *
   * @tags dbtn/module:audit_log, dbtn/hasAuth
   * @name log_manual_change
   * @summary Log Manual Change
   * @request POST:/routes/log-manual-change
   */
  log_manual_change = (data: LogManualChangeRequest, params: RequestParams = {}) =>
    this.request<LogManualChangeData, LogManualChangeError>({
      path: `/log-manual-change`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Sets the visibility (isActive status) for a client user. Requires the calling user to have the 'admin' role. Clients are users with role 'client' or 'limited_access'. Updates 'isActive' and 'updatedAt' fields.
   *
   * @tags Client Actions, dbtn/module:client_actions, dbtn/hasAuth
   * @name set_client_visibility
   * @summary Set Client Visibility
   * @request POST:/routes/clients/{client_id}/set-visibility
   */
  set_client_visibility = (
    { clientId, ...query }: SetClientVisibilityParams,
    data: SetClientVisibilityRequest,
    params: RequestParams = {},
  ) =>
    this.request<SetClientVisibilityData, SetClientVisibilityError>({
      path: `/clients/${clientId}/set-visibility`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Retrieve a list of all available client-side services.
   *
   * @tags Client-Side Services, dbtn/module:client_side_services, dbtn/hasAuth
   * @name list_client_side_services
   * @summary List Client Side Services
   * @request GET:/client-side-services/
   */
  list_client_side_services = (params: RequestParams = {}) =>
    this.request<ListClientSideServicesData, any>({
      path: `/client-side-services/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get information about possible redirect URIs for Google OAuth
   *
   * @tags dbtn/module:oauth_debug, dbtn/hasAuth
   * @name get_redirect_uri_info
   * @summary Get Redirect Uri Info
   * @request GET:/routes/redirect-uri-info
   */
  get_redirect_uri_info = (params: RequestParams = {}) =>
    this.request<GetRedirectUriInfoData, any>({
      path: `/redirect-uri-info`,
      method: "GET",
      ...params,
    });

  /**
   * @description Provides the Google Maps API key to the frontend. This endpoint is unprotected to allow immediate loading before authentication.
   *
   * @tags Public Config, dbtn/module:public_config, dbtn/hasAuth
   * @name get_google_maps_api_key_public
   * @summary Get Google Maps Api Key Public
   * @request GET:/routes/api/public/google-maps-key
   */
  get_google_maps_api_key_public = (params: RequestParams = {}) =>
    this.request<GetGoogleMapsApiKeyPublicData, any>({
      path: `/api/public/google-maps-key`,
      method: "GET",
      ...params,
    });

  /**
   * @description Provides the Google Maps API key to the frontend.
   *
   * @tags Config, dbtn/module:config, dbtn/hasAuth
   * @name get_google_maps_api_key_protected
   * @summary Get Google Maps Api Key Protected
   * @request GET:/routes/api/config/google-maps-key
   */
  get_google_maps_api_key_protected = (params: RequestParams = {}) =>
    this.request<GetGoogleMapsApiKeyProtectedData, any>({
      path: `/api/config/google-maps-key`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get the current user's custom claims for debugging.
   *
   * @tags Debug User, dbtn/module:debug_user, dbtn/hasAuth
   * @name get_user_claims
   * @summary Get User Claims
   * @request GET:/routes/debug-user/claims
   */
  get_user_claims = (params: RequestParams = {}) =>
    this.request<GetUserClaimsData, any>({
      path: `/debug-user/claims`,
      method: "GET",
      ...params,
    });

  /**
   * @description Sets custom claims for a target user. Requires caller to be an admin.
   *
   * @tags Admin Tools, dbtn/module:admin_tools, dbtn/hasAuth
   * @name set_custom_claim
   * @summary Set Custom Claim
   * @request POST:/routes/routes/admin/set-claim
   */
  set_custom_claim = (data: SetClaimRequest, params: RequestParams = {}) =>
    this.request<SetCustomClaimData, SetCustomClaimError>({
      path: `/admin/set-claim`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Bootstrap endpoint to set the first admin. Only works in development mode.
   *
   * @tags Admin Tools, dbtn/module:admin_tools, dbtn/hasAuth
   * @name bootstrap_admin
   * @summary Bootstrap Admin
   * @request POST:/routes/routes/admin/bootstrap-admin
   */
  bootstrap_admin = (data: SetClaimRequest, params: RequestParams = {}) =>
    this.request<BootstrapAdminData, BootstrapAdminError>({
      path: `/admin/bootstrap-admin`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Debug endpoint to check current user information.
   *
   * @tags Admin Tools, dbtn/module:admin_tools, dbtn/hasAuth
   * @name debug_user_info
   * @summary Debug User Info
   * @request GET:/routes/routes/admin/debug-user
   */
  debug_user_info = (params: RequestParams = {}) =>
    this.request<DebugUserInfoData, any>({
      path: `/admin/debug-user`,
      method: "GET",
      ...params,
    });

  /**
   * @description Development-only endpoint to set current authenticated user as admin.
   *
   * @tags Admin Tools, dbtn/module:admin_tools, dbtn/hasAuth
   * @name bootstrap_dev_admin
   * @summary Bootstrap Dev Admin
   * @request POST:/routes/routes/admin/bootstrap-dev-admin
   */
  bootstrap_dev_admin = (params: RequestParams = {}) =>
    this.request<BootstrapDevAdminData, any>({
      path: `/admin/bootstrap-dev-admin`,
      method: "POST",
      ...params,
    });

  /**
   * @description Basic health check endpoint
   *
   * @tags dbtn/module:my_new_api, dbtn/hasAuth
   * @name check_health_my_new_api
   * @summary Check Health My New Api
   * @request GET:/routes/health
   */
  check_health_my_new_api = (params: RequestParams = {}) =>
    this.request<CheckHealthMyNewApiData, any>({
      path: `/health`,
      method: "GET",
      ...params,
    });

  /**
   * @description Updates a user's role. Requires caller to be an admin.
   *
   * @tags User Roles, dbtn/module:user_roles, dbtn/hasAuth
   * @name update_user_role
   * @summary Update User Role
   * @request POST:/routes/update-user-role
   */
  update_user_role = (data: UpdateUserRoleRequest, params: RequestParams = {}) =>
    this.request<UpdateUserRoleData, UpdateUserRoleError>({
      path: `/update-user-role`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Development-only endpoint to set current authenticated user as admin.
   *
   * @tags User Roles, dbtn/module:user_roles, dbtn/hasAuth
   * @name bootstrap_admin_user_roles
   * @summary Bootstrap Admin User Roles
   * @request POST:/routes/bootstrap-admin
   */
  bootstrap_admin_user_roles = (params: RequestParams = {}) =>
    this.request<BootstrapAdminUserRolesData, any>({
      path: `/bootstrap-admin`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get all admin users for chat creation. Only accessible to authenticated users.
   *
   * @tags dbtn/module:admin_users, dbtn/hasAuth
   * @name get_admin_users
   * @summary Get Admin Users
   * @request GET:/routes/routes/admin-users
   */
  get_admin_users = (params: RequestParams = {}) =>
    this.request<GetAdminUsersData, any>({
      path: `/admin-users`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get timesheet summary for the authenticated staff member for a specific period.
   *
   * @tags Timesheet Summary, dbtn/module:timesheet_summary, dbtn/hasAuth
   * @name get_timesheet_summary
   * @summary Get Timesheet Summary
   * @request GET:/routes/timesheet-summary/summary
   */
  get_timesheet_summary = (query: GetTimesheetSummaryParams, params: RequestParams = {}) =>
    this.request<GetTimesheetSummaryData, GetTimesheetSummaryError>({
      path: `/timesheet-summary/summary`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Timesheet Summary, dbtn/module:timesheet_summary, dbtn/hasAuth
   * @name ping_timesheet_summary
   * @summary Ping Timesheet Summary
   * @request GET:/routes/timesheet-summary/ping
   */
  ping_timesheet_summary = (params: RequestParams = {}) =>
    this.request<PingTimesheetSummaryData, any>({
      path: `/timesheet-summary/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Retrieve a list of all service categories from Firestore.
   *
   * @tags Categories, dbtn/module:categoryapi, dbtn/hasAuth
   * @name list_categories
   * @summary List all categories
   * @request GET:/routes/categories
   */
  list_categories = (params: RequestParams = {}) =>
    this.request<ListCategoriesData, any>({
      path: `/categories`,
      method: "GET",
      ...params,
    });

  /**
   * @description Add a new service category to Firestore.
   *
   * @tags Categories, dbtn/module:categoryapi, dbtn/hasAuth
   * @name create_category
   * @summary Create a new category
   * @request POST:/routes/categories
   */
  create_category = (data: CategoryCreate, params: RequestParams = {}) =>
    this.request<CreateCategoryData, CreateCategoryError>({
      path: `/categories`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update an existing service category in Firestore.
   *
   * @tags Categories, dbtn/module:categoryapi, dbtn/hasAuth
   * @name update_category
   * @summary Update a category
   * @request PUT:/routes/categories/{category_id}
   */
  update_category = (
    { categoryId, ...query }: UpdateCategoryParams,
    data: CategoryUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCategoryData, UpdateCategoryError>({
      path: `/categories/${categoryId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a service category from Firestore.
   *
   * @tags Categories, dbtn/module:categoryapi, dbtn/hasAuth
   * @name delete_category
   * @summary Delete a category
   * @request DELETE:/routes/categories/{category_id}
   */
  delete_category = ({ categoryId, ...query }: DeleteCategoryParams, params: RequestParams = {}) =>
    this.request<DeleteCategoryData, DeleteCategoryError>({
      path: `/categories/${categoryId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description List all places for admin management. No authentication required for reading.
   *
   * @tags Places, dbtn/module:places, dbtn/hasAuth
   * @name list_places
   * @summary List Places
   * @request GET:/places
   */
  list_places = (params: RequestParams = {}) =>
    this.request<ListPlacesData, any>({
      path: `/places/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new place. Requires admin role.
   *
   * @tags Places, dbtn/module:places, dbtn/hasAuth
   * @name create_place
   * @summary Create Place
   * @request POST:/places
   */
  create_place = (data: PlaceCreate, params: RequestParams = {}) =>
    this.request<CreatePlaceData, CreatePlaceError>({
      path: `/places/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get a specific place by ID. No authentication required for reading.
   *
   * @tags Places, dbtn/module:places, dbtn/hasAuth
   * @name get_place
   * @summary Get Place
   * @request GET:/places/{place_id}
   */
  get_place = ({ placeId, ...query }: GetPlaceParams, params: RequestParams = {}) =>
    this.request<GetPlaceData, GetPlaceError>({
      path: `/places/${placeId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a place. Requires admin role.
   *
   * @tags Places, dbtn/module:places, dbtn/hasAuth
   * @name update_place
   * @summary Update Place
   * @request PUT:/places/{place_id}
   */
  update_place = ({ placeId, ...query }: UpdatePlaceParams, data: PlaceUpdate, params: RequestParams = {}) =>
    this.request<UpdatePlaceData, UpdatePlaceError>({
      path: `/places/${placeId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a place (soft delete by setting isActive=False). Requires admin role.
   *
   * @tags Places, dbtn/module:places, dbtn/hasAuth
   * @name delete_place
   * @summary Delete Place
   * @request DELETE:/places/{place_id}
   */
  delete_place = ({ placeId, ...query }: DeletePlaceParams, params: RequestParams = {}) =>
    this.request<DeletePlaceData, DeletePlaceError>({
      path: `/places/${placeId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Analyze current travel records to understand migration needs
   *
   * @tags dbtn/module:migrate_attendance, dbtn/hasAuth
   * @name analyze_travel_records
   * @summary Analyze Travel Records
   * @request GET:/routes/analyze-travel-records
   */
  analyze_travel_records = (params: RequestParams = {}) =>
    this.request<AnalyzeTravelRecordsData, any>({
      path: `/analyze-travel-records`,
      method: "GET",
      ...params,
    });

  /**
   * @description Migrate travel records to standardized structure
   *
   * @tags dbtn/module:migrate_attendance, dbtn/hasAuth
   * @name migrate_travel_records
   * @summary Migrate Travel Records
   * @request POST:/routes/migrate-travel-records
   */
  migrate_travel_records = (params: RequestParams = {}) =>
    this.request<MigrateTravelRecordsData, any>({
      path: `/migrate-travel-records`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get the default price books for a service. Lightweight endpoint for quick lookups during appointment creation.
   *
   * @tags Service Defaults, dbtn/module:service_defaults, dbtn/hasAuth
   * @name get_service_defaults
   * @summary Get Service Defaults
   * @request GET:/routes/service-defaults/services/{service_id}/defaults
   */
  get_service_defaults = ({ serviceId, ...query }: GetServiceDefaultsParams, params: RequestParams = {}) =>
    this.request<GetServiceDefaultsData, GetServiceDefaultsError>({
      path: `/service-defaults/services/${serviceId}/defaults`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update the default price books for a service. Requires admin or staff privileges.
   *
   * @tags Service Defaults, dbtn/module:service_defaults, dbtn/hasAuth
   * @name update_service_defaults
   * @summary Update Service Defaults
   * @request PUT:/routes/service-defaults/services/{service_id}/defaults
   */
  update_service_defaults = (
    { serviceId, ...query }: UpdateServiceDefaultsParams,
    data: ServiceDefaultsUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateServiceDefaultsData, UpdateServiceDefaultsError>({
      path: `/service-defaults/services/${serviceId}/defaults`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Generate lunch breaks for all eligible staff for the specified number of weeks
   *
   * @tags dbtn/module:lunch_break_management, dbtn/hasAuth
   * @name generate_bulk_lunch_breaks
   * @summary Generate Bulk Lunch Breaks
   * @request POST:/routes/lunch-break-management/generate-bulk
   */
  generate_bulk_lunch_breaks = (data: BulkGenerationRequest, params: RequestParams = {}) =>
    this.request<GenerateBulkLunchBreaksData, GenerateBulkLunchBreaksError>({
      path: `/lunch-break-management/generate-bulk`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check for conflicts between existing lunch breaks and approved time off requests
   *
   * @tags dbtn/module:lunch_break_management, dbtn/hasAuth
   * @name check_lunch_break_conflicts
   * @summary Check Lunch Break Conflicts
   * @request POST:/routes/lunch-break-management/check-conflicts
   */
  check_lunch_break_conflicts = (data: ConflictCheckRequest, params: RequestParams = {}) =>
    this.request<CheckLunchBreakConflictsData, CheckLunchBreakConflictsError>({
      path: `/lunch-break-management/check-conflicts`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Remove lunch breaks that conflict with a specific approved time off request
   *
   * @tags dbtn/module:lunch_break_management, dbtn/hasAuth
   * @name remove_lunch_breaks_for_time_off
   * @summary Remove Lunch Breaks For Time Off
   * @request DELETE:/routes/lunch-break-management/remove-conflicts-for-timeoff/{time_off_id}
   */
  remove_lunch_breaks_for_time_off = (
    { timeOffId, ...query }: RemoveLunchBreaksForTimeOffParams,
    params: RequestParams = {},
  ) =>
    this.request<RemoveLunchBreaksForTimeOffData, RemoveLunchBreaksForTimeOffError>({
      path: `/lunch-break-management/remove-conflicts-for-timeoff/${timeOffId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get all available medical conditions.
   *
   * @tags Medical Conditions, dbtn/module:medical_conditions, dbtn/hasAuth
   * @name list_medical_conditions
   * @summary List Medical Conditions
   * @request GET:/routes/medical-conditions
   */
  list_medical_conditions = (query: ListMedicalConditionsParams, params: RequestParams = {}) =>
    this.request<ListMedicalConditionsData, ListMedicalConditionsError>({
      path: `/medical-conditions`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Create a new medical condition.
   *
   * @tags Medical Conditions, dbtn/module:medical_conditions, dbtn/hasAuth
   * @name create_medical_condition
   * @summary Create Medical Condition
   * @request POST:/routes/medical-conditions
   */
  create_medical_condition = (data: MedicalConditionCreate, params: RequestParams = {}) =>
    this.request<CreateMedicalConditionData, CreateMedicalConditionError>({
      path: `/medical-conditions`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update an existing medical condition.
   *
   * @tags Medical Conditions, dbtn/module:medical_conditions, dbtn/hasAuth
   * @name update_medical_condition
   * @summary Update Medical Condition
   * @request PUT:/routes/medical-conditions/{condition_id}
   */
  update_medical_condition = (
    { conditionId, ...query }: UpdateMedicalConditionParams,
    data: MedicalConditionUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateMedicalConditionData, UpdateMedicalConditionError>({
      path: `/medical-conditions/${conditionId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a medical condition (soft delete by setting isActive to False).
   *
   * @tags Medical Conditions, dbtn/module:medical_conditions, dbtn/hasAuth
   * @name delete_medical_condition
   * @summary Delete Medical Condition
   * @request DELETE:/routes/medical-conditions/{condition_id}
   */
  delete_medical_condition = ({ conditionId, ...query }: DeleteMedicalConditionParams, params: RequestParams = {}) =>
    this.request<DeleteMedicalConditionData, DeleteMedicalConditionError>({
      path: `/medical-conditions/${conditionId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get all unique categories of medical conditions.
   *
   * @tags Medical Conditions, dbtn/module:medical_conditions, dbtn/hasAuth
   * @name get_medical_condition_categories
   * @summary Get Medical Condition Categories
   * @request GET:/routes/medical-conditions/categories
   */
  get_medical_condition_categories = (params: RequestParams = {}) =>
    this.request<GetMedicalConditionCategoriesData, any>({
      path: `/medical-conditions/categories`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get medical conditions for a specific client with resolved condition names.
   *
   * @tags Client Medical Conditions, dbtn/module:client_medical_conditions, dbtn/hasAuth
   * @name get_client_medical_conditions
   * @summary Get Client Medical Conditions
   * @request GET:/routes/clients/{client_id}/medical-conditions
   */
  get_client_medical_conditions = (
    { clientId, ...query }: GetClientMedicalConditionsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetClientMedicalConditionsData, GetClientMedicalConditionsError>({
      path: `/clients/${clientId}/medical-conditions`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update medical conditions for a specific client using checkbox format.
   *
   * @tags Client Medical Conditions, dbtn/module:client_medical_conditions, dbtn/hasAuth
   * @name update_client_medical_conditions
   * @summary Update Client Medical Conditions
   * @request PUT:/routes/clients/{client_id}/medical-conditions
   */
  update_client_medical_conditions = (
    { clientId, ...query }: UpdateClientMedicalConditionsParams,
    data: ClientMedicalConditionsUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateClientMedicalConditionsData, UpdateClientMedicalConditionsError>({
      path: `/clients/${clientId}/medical-conditions`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Synchronize staffattendance records for a specific appointment. This is the main sync endpoint that should be called when appointments are modified.
   *
   * @tags Staff Attendance Sync, dbtn/module:staffattendance_sync, dbtn/hasAuth
   * @name sync_staffattendance_for_appointment_endpoint
   * @summary Sync Staffattendance For Appointment Endpoint
   * @request POST:/routes/staffattendance-sync/sync-appointment
   */
  sync_staffattendance_for_appointment_endpoint = (data: SyncForAppointmentRequest, params: RequestParams = {}) =>
    this.request<SyncStaffattendanceForAppointmentEndpointData, SyncStaffattendanceForAppointmentEndpointError>({
      path: `/staffattendance-sync/sync-appointment`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Convenience endpoint for syncing after status-only changes.
   *
   * @tags Staff Attendance Sync, dbtn/module:staffattendance_sync, dbtn/hasAuth
   * @name sync_staffattendance_after_status_change_endpoint
   * @summary Sync Staffattendance After Status Change Endpoint
   * @request POST:/routes/staffattendance-sync/sync-status-change
   */
  sync_staffattendance_after_status_change_endpoint = (
    data: SyncAfterStatusChangeRequest,
    params: RequestParams = {},
  ) =>
    this.request<SyncStaffattendanceAfterStatusChangeEndpointData, SyncStaffattendanceAfterStatusChangeEndpointError>({
      path: `/staffattendance-sync/sync-status-change`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Health check endpoint
   *
   * @tags Staff Attendance Sync, dbtn/module:staffattendance_sync, dbtn/hasAuth
   * @name health_check
   * @summary Health Check
   * @request GET:/routes/staffattendance-sync/health
   */
  health_check = (params: RequestParams = {}) =>
    this.request<HealthCheckData, any>({
      path: `/staffattendance-sync/health`,
      method: "GET",
      ...params,
    });

  /**
   * @description Debug endpoint to check authorization for appointment cancellation
   *
   * @tags dbtn/module:debug_appointment, dbtn/hasAuth
   * @name debug_appointment_authorization
   * @summary Debug Appointment Authorization
   * @request GET:/routes/debug-appointment-auth/{appointment_id}
   */
  debug_appointment_authorization = (
    { appointmentId, ...query }: DebugAppointmentAuthorizationParams,
    params: RequestParams = {},
  ) =>
    this.request<DebugAppointmentAuthorizationData, DebugAppointmentAuthorizationError>({
      path: `/debug-appointment-auth/${appointmentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description DEPRECATED: This endpoint has been moved to staff_schedule API for centralization. Use /routes/staff/appointments/{appointment_id}/manual-clock-override instead.
   *
   * @tags Time Adjustment, dbtn/module:time_adjustment, dbtn/hasAuth
   * @name manual_time_adjustment_legacy
   * @summary Manual Time Adjustment Legacy
   * @request POST:/routes/time-adjustment/manual-override
   */
  manual_time_adjustment_legacy = (data: ManualTimeAdjustmentRequest, params: RequestParams = {}) =>
    this.request<ManualTimeAdjustmentLegacyData, ManualTimeAdjustmentLegacyError>({
      path: `/time-adjustment/manual-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Minimal test endpoint to debug costToClient data reading
   *
   * @tags dbtn/module:debug_event_cost, dbtn/hasAuth
   * @name test_event_cost
   * @summary Test Event Cost
   * @request GET:/routes/test-cost/{event_id}
   */
  test_event_cost = ({ eventId, ...query }: TestEventCostParams, params: RequestParams = {}) =>
    this.request<TestEventCostData, TestEventCostError>({
      path: `/test-cost/${eventId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Updates a specific staff time record (staffattendance document).
   *
   * @tags Staff Times, dbtn/module:staff_times, dbtn/hasAuth
   * @name update_staff_time_record
   * @summary Update Staff Time Record
   * @request PATCH:/routes/staff-times/staff-times/{staff_time_id}
   */
  update_staff_time_record = (
    { staffTimeId, ...query }: UpdateStaffTimeRecordParams,
    data: StaffTimeUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateStaffTimeRecordData, UpdateStaffTimeRecordError>({
      path: `/staff-times/staff-times/${staffTimeId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get staff time overrides for a specific appointment
   *
   * @tags Staff Times, dbtn/module:staff_times, dbtn/hasAuth
   * @name get_staff_times
   * @summary Get Staff Times
   * @request GET:/routes/staff-times/appointment/{appointment_id}
   */
  get_staff_times = ({ appointmentId, ...query }: GetStaffTimesParams, params: RequestParams = {}) =>
    this.request<GetStaffTimesData, GetStaffTimesError>({
      path: `/staff-times/appointment/${appointmentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update staff time overrides for an appointment
   *
   * @tags Staff Times, dbtn/module:staff_times, dbtn/hasAuth
   * @name update_staff_times_for_appointment
   * @summary Update Staff Times For Appointment
   * @request PUT:/routes/staff-times/for-appointment
   */
  update_staff_times_for_appointment = (data: UpdateStaffTimesRequest, params: RequestParams = {}) =>
    this.request<UpdateStaffTimesForAppointmentData, UpdateStaffTimesForAppointmentError>({
      path: `/staff-times/for-appointment`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Remove time override for a specific staff member (they will use appointment default times)
   *
   * @tags Staff Times, dbtn/module:staff_times, dbtn/hasAuth
   * @name remove_staff_time_override
   * @summary Remove Staff Time Override
   * @request DELETE:/routes/staff-times/appointment/{appointment_id}/staff/{staff_id}
   */
  remove_staff_time_override = (
    { appointmentId, staffId, ...query }: RemoveStaffTimeOverrideParams,
    params: RequestParams = {},
  ) =>
    this.request<RemoveStaffTimeOverrideData, RemoveStaffTimeOverrideError>({
      path: `/staff-times/appointment/${appointmentId}/staff/${staffId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Debug endpoint to test Firestore queries for casual staff access.
   *
   * @tags dbtn/module:debug_casual_staff, dbtn/hasAuth
   * @name test_casual_staff_queries
   * @summary Test Casual Staff Queries
   * @request GET:/routes/test-casual-staff-queries
   */
  test_casual_staff_queries = (params: RequestParams = {}) =>
    this.request<TestCasualStaffQueriesData, any>({
      path: `/test-casual-staff-queries`,
      method: "GET",
      ...params,
    });

  /**
   * @description Soft delete an appointment and its related records. Only appointments that are not active or completed can be deleted. This marks the appointment as deleted rather than permanently removing it.
   *
   * @tags dbtn/module:delete_appointment, dbtn/hasAuth
   * @name delete_appointment_with_request_body
   * @summary Delete Appointment With Request Body
   * @request DELETE:/routes/delete-appointment
   */
  delete_appointment_with_request_body = (data: DeleteAppointmentRequest, params: RequestParams = {}) =>
    this.request<DeleteAppointmentWithRequestBodyData, DeleteAppointmentWithRequestBodyError>({
      path: `/delete-appointment`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Soft-delete every FUTURE appointment in the given series.
   * Past appointments and shifts whose status is `active`, `completed`, or already `deleted` are skipped.
   * The same cascade-delete used by `/delete-appointment` runs for each remaining future appointment.
   *
   * @tags dbtn/module:delete_appointment, dbtn/hasAuth
   * @name delete_appointment_series
   * @summary Delete every future appointment in a series
   * @request DELETE:/routes/delete-appointment-series
   */
  delete_appointment_series = (
    data: { seriesId: string; deletionReason?: string },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
        seriesId: string;
        deletedAppointmentIds: string[];
        skippedAppointments: Array<{ appointmentId: string; status: string; reason: string }>;
        totalDeleted: number;
        aggregated_records: Record<string, number>;
        message: string;
      },
      { detail?: string } | any
    >({
      path: `/delete-appointment-series`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Start working on a task
   *
   * @tags Time Tracking, dbtn/module:time_tracking, dbtn/hasAuth
   * @name start_work
   * @summary Start Work
   * @request POST:/routes/time-tracking/start-work
   */
  start_work = (data: StartWorkRequest, params: RequestParams = {}) =>
    this.request<StartWorkData, StartWorkError>({
      path: `/time-tracking/start-work`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description End working on a task
   *
   * @tags Time Tracking, dbtn/module:time_tracking, dbtn/hasAuth
   * @name end_work
   * @summary End Work
   * @request POST:/routes/time-tracking/end-work
   */
  end_work = (data: AppApisTimeTrackingEndWorkRequest, params: RequestParams = {}) =>
    this.request<EndWorkData, EndWorkError>({
      path: `/time-tracking/end-work`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get time tracking information for a specific task
   *
   * @tags Time Tracking, dbtn/module:time_tracking, dbtn/hasAuth
   * @name get_task_time_tracking
   * @summary Get Task Time Tracking
   * @request GET:/routes/time-tracking/task/{task_id}
   */
  get_task_time_tracking = ({ taskId, ...query }: GetTaskTimeTrackingParams, params: RequestParams = {}) =>
    this.request<GetTaskTimeTrackingData, GetTaskTimeTrackingError>({
      path: `/time-tracking/task/${taskId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name create_office_task
   * @summary Create Office Task
   * @request POST:/office-tasks/
   */
  create_office_task = (data: OfficeTaskCreateRequest, params: RequestParams = {}) =>
    this.request<CreateOfficeTaskData, CreateOfficeTaskError>({
      path: `/office-tasks/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List office tasks with optional filtering
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name list_office_tasks
   * @summary List Office Tasks
   * @request GET:/office-tasks/
   */
  list_office_tasks = (query: ListOfficeTasksParams, params: RequestParams = {}) =>
    this.request<ListOfficeTasksData, ListOfficeTasksError>({
      path: `/office-tasks/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a specific office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name get_task
   * @summary Get Task
   * @request GET:/office-tasks/{task_id}
   */
  get_task = ({ taskId, ...query }: GetTaskParams, params: RequestParams = {}) =>
    this.request<GetTaskData, GetTaskError>({
      path: `/office-tasks/${taskId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name update_office_task
   * @summary Update Office Task
   * @request PATCH:/office-tasks/{task_id}
   */
  update_office_task = (
    { taskId, ...query }: UpdateOfficeTaskParams,
    data: OfficeTaskUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateOfficeTaskData, UpdateOfficeTaskError>({
      path: `/office-tasks/${taskId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete an office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name delete_office_task
   * @summary Delete Office Task
   * @request DELETE:/office-tasks/{task_id}
   */
  delete_office_task = ({ taskId, ...query }: DeleteOfficeTaskParams, params: RequestParams = {}) =>
    this.request<DeleteOfficeTaskData, DeleteOfficeTaskError>({
      path: `/office-tasks/${taskId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Add a note to an office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name add_task_note
   * @summary Add Task Note
   * @request POST:/office-tasks/{task_id}/notes
   */
  add_task_note = ({ taskId, ...query }: AddTaskNoteParams, data: OfficeTaskNoteRequest, params: RequestParams = {}) =>
    this.request<AddTaskNoteData, AddTaskNoteError>({
      path: `/office-tasks/${taskId}/notes`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all notes for an office task
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name list_task_notes
   * @summary List Task Notes
   * @request GET:/office-tasks/{task_id}/notes
   */
  list_task_notes = ({ taskId, ...query }: ListTaskNotesParams, params: RequestParams = {}) =>
    this.request<ListTaskNotesData, ListTaskNotesError>({
      path: `/office-tasks/${taskId}/notes`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get count of incomplete office tasks for current user
   *
   * @tags Office Tasks, dbtn/module:office_tasks, dbtn/hasAuth
   * @name get_incomplete_office_task_count
   * @summary Get Incomplete Office Task Count
   * @request GET:/office-tasks/incomplete/count
   */
  get_incomplete_office_task_count = (params: RequestParams = {}) =>
    this.request<GetIncompleteOfficeTaskCountData, any>({
      path: `/office-tasks/incomplete/count`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:roster_management, dbtn/hasAuth
   * @name accept_shift_invitation
   * @summary Accept Shift Invitation
   * @request POST:/routes/accept_shift_invitation
   */
  accept_shift_invitation = (data: ShiftInvitationRequest, params: RequestParams = {}) =>
    this.request<AcceptShiftInvitationData, AcceptShiftInvitationError>({
      path: `/routes/accept_shift_invitation`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:roster_management, dbtn/hasAuth
   * @name decline_shift_invitation
   * @summary Decline Shift Invitation
   * @request POST:/routes/decline_shift_invitation
   */
  decline_shift_invitation = (data: ShiftInvitationRequest, params: RequestParams = {}) =>
    this.request<DeclineShiftInvitationData, DeclineShiftInvitationError>({
      path: `/routes/decline_shift_invitation`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Run the office address migration script
   *
   * @tags dbtn/module:run_address_migration, dbtn/hasAuth
   * @name run_address_migration
   * @summary Run Address Migration
   * @request POST:/routes/run-address-migration
   */
  run_address_migration = (params: RequestParams = {}) =>
    this.request<RunAddressMigrationData, any>({
      path: `/run-address-migration`,
      method: "POST",
      ...params,
    });

  /**
   * @description Quick migration - just update the business_details main document
   *
   * @tags dbtn/module:quick_migrate, dbtn/hasAuth
   * @name quick_migrate_office_address
   * @summary Quick Migrate Office Address
   * @request POST:/routes/quick-migrate-office-address
   */
  quick_migrate_office_address = (params: RequestParams = {}) =>
    this.request<QuickMigrateOfficeAddressData, any>({
      path: `/quick-migrate-office-address`,
      method: "POST",
      ...params,
    });

  /**
   * @description Optimized endpoint for listing unassigned appointments. Uses database-level filtering and batched queries for better performance. Only fetches appointments for today and future dates with eligible statuses.
   *
   * @tags dbtn/module:job_board_optimization, dbtn/hasAuth
   * @name list_unassigned_appointments_optimized
   * @summary List Unassigned Appointments Optimized
   * @request GET:/unassigned-optimized
   */
  list_unassigned_appointments_optimized = (params: RequestParams = {}) =>
    this.request<ListUnassignedAppointmentsOptimizedData, any>({
      path: `/unassigned-optimized`,
      method: "GET",
      ...params,
    });

  /**
   * @description Check data consistency between staff documents and workingHours collection.
   *
   * @tags Data Consistency, dbtn/module:data_consistency, dbtn/hasAuth
   * @name check_working_hours_consistency
   * @summary Check Working Hours Consistency
   * @request GET:/routes/data-consistency/check-working-hours
   */
  check_working_hours_consistency = (params: RequestParams = {}) =>
    this.request<CheckWorkingHoursConsistencyData, any>({
      path: `/data-consistency/check-working-hours`,
      method: "GET",
      ...params,
    });

  /**
   * @description Migrate working hours from staff documents to workingHours collection.
   *
   * @tags Data Consistency, dbtn/module:data_consistency, dbtn/hasAuth
   * @name migrate_working_hours_to_collection
   * @summary Migrate Working Hours To Collection
   * @request POST:/routes/data-consistency/migrate-working-hours
   */
  migrate_working_hours_to_collection = (params: RequestParams = {}) =>
    this.request<MigrateWorkingHoursToCollectionData, any>({
      path: `/data-consistency/migrate-working-hours`,
      method: "POST",
      ...params,
    });

  /**
   * @description Sync working hours between staff document and workingHours collection for a specific staff member.
   *
   * @tags Data Consistency, dbtn/module:data_consistency, dbtn/hasAuth
   * @name sync_working_hours_for_staff
   * @summary Sync Working Hours For Staff
   * @request POST:/routes/data-consistency/sync-working-hours/{staff_id}
   */
  sync_working_hours_for_staff = ({ staffId, ...query }: SyncWorkingHoursForStaffParams, params: RequestParams = {}) =>
    this.request<SyncWorkingHoursForStaffData, SyncWorkingHoursForStaffError>({
      path: `/data-consistency/sync-working-hours/${staffId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get overtime transaction summary for a staff member.
   *
   * @tags Overtime Transactions, dbtn/module:overtime_transactions, dbtn/hasAuth
   * @name get_overtime_summary
   * @summary Get Overtime Summary
   * @request GET:/routes/overtime-transactions/summary/{staff_id}
   */
  get_overtime_summary = ({ staffId, ...query }: GetOvertimeSummaryParams, params: RequestParams = {}) =>
    this.request<GetOvertimeSummaryData, GetOvertimeSummaryError>({
      path: `/overtime-transactions/summary/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Overtime Transactions, dbtn/module:overtime_transactions, dbtn/hasAuth
   * @name ping_overtime_transactions
   * @summary Ping Overtime Transactions
   * @request GET:/routes/overtime-transactions/ping
   */
  ping_overtime_transactions = (params: RequestParams = {}) =>
    this.request<PingOvertimeTransactionsData, any>({
      path: `/overtime-transactions/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Calculate travel time and distance for a staff member on a specific date. Returns detailed travel segments and totals without storing in database.
   *
   * @tags Travel Calculation, dbtn/module:travel_calculation, dbtn/hasAuth
   * @name get_staff_travel_calculation
   * @summary Get Staff Travel Calculation
   * @request GET:/routes/travel-calc/calculate/{staff_id}
   */
  get_staff_travel_calculation = ({ staffId, ...query }: GetStaffTravelCalculationParams, params: RequestParams = {}) =>
    this.request<GetStaffTravelCalculationData, GetStaffTravelCalculationError>({
      path: `/travel-calc/calculate/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Calculate travel for a staff member on a specific date and store the results in staffattendance records.
   *
   * @tags Travel Calculation, dbtn/module:travel_calculation, dbtn/hasAuth
   * @name calculate_and_store_travel
   * @summary Calculate And Store Travel
   * @request POST:/routes/travel-calc/calculate-and-store
   */
  calculate_and_store_travel = (data: CalculateTravelRequest, params: RequestParams = {}) =>
    this.request<CalculateAndStoreTravelData, CalculateAndStoreTravelError>({
      path: `/travel-calc/calculate-and-store`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Calculate travel for multiple staff members on a specific date and store results. Useful for recalculating travel when appointments change.
   *
   * @tags Travel Calculation, dbtn/module:travel_calculation, dbtn/hasAuth
   * @name bulk_calculate_and_store_travel
   * @summary Bulk Calculate And Store Travel
   * @request POST:/routes/travel-calc/bulk-calculate-and-store
   */
  bulk_calculate_and_store_travel = (data: BulkCalculateTravelRequest, params: RequestParams = {}) =>
    this.request<BulkCalculateAndStoreTravelData, BulkCalculateAndStoreTravelError>({
      path: `/travel-calc/bulk-calculate-and-store`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Recalculate travel for all affected staff when an appointment is added, modified, or deleted. This endpoint should be called automatically when appointments change.
   *
   * @tags Travel Calculation, dbtn/module:travel_calculation, dbtn/hasAuth
   * @name recalculate_travel_for_appointment_change
   * @summary Recalculate Travel For Appointment Change
   * @request POST:/routes/travel-calc/recalculate-for-appointment-change
   */
  recalculate_travel_for_appointment_change = (
    query: RecalculateTravelForAppointmentChangeParams,
    params: RequestParams = {},
  ) =>
    this.request<RecalculateTravelForAppointmentChangeData, RecalculateTravelForAppointmentChangeError>({
      path: `/travel-calc/recalculate-for-appointment-change`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Calculate travel segments for a staff member on a specific date and store them in staffattendance. This creates billable travel records with vehicle assignments.
   *
   * @tags dbtn/module:travel_segments_management, dbtn/hasAuth
   * @name calculate_and_store_travel_segments
   * @summary Calculate And Store Travel Segments
   * @request POST:/routes/calculate-and-store
   */
  calculate_and_store_travel_segments = (data: CreateTravelSegmentsRequest, params: RequestParams = {}) =>
    this.request<CalculateAndStoreTravelSegmentsData, CalculateAndStoreTravelSegmentsError>({
      path: `/calculate-and-store`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Calculate travel segments for multiple staff members on a specific date. Useful for daily/weekly travel calculation runs.
   *
   * @tags dbtn/module:travel_segments_management, dbtn/hasAuth
   * @name bulk_calculate_and_store_travel_segments
   * @summary Bulk Calculate And Store Travel Segments
   * @request POST:/routes/bulk-calculate-and-store
   */
  bulk_calculate_and_store_travel_segments = (data: BulkCreateTravelSegmentsRequest, params: RequestParams = {}) =>
    this.request<BulkCalculateAndStoreTravelSegmentsData, BulkCalculateAndStoreTravelSegmentsError>({
      path: `/bulk-calculate-and-store`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List every appointment-to-appointment travel connector across the given week+staff that ISN'T already saved as a `travel_segment`. Used by the diary "Add all travel for the week" button to show a confirmation list before the mass conversion.
   *
   * @tags Travel Segments Management
   * @name preview_weekly_travel_candidates
   * @summary Preview Weekly Travel Candidates
   * @request POST:/preview-weekly-travel-candidates
   */
  preview_weekly_travel_candidates = (data: { staff_ids: string[]; dates: string[] }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/preview-weekly-travel-candidates`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get all travel segments for a specific staff member on a specific date.
   *
   * @tags dbtn/module:travel_segments_management, dbtn/hasAuth
   * @name get_travel_segments_for_staff_date
   * @summary Get Travel Segments For Staff Date
   * @request GET:/routes/staff/{staff_id}/date/{date}
   */
  get_travel_segments_for_staff_date = (
    { staffId, date, ...query }: GetTravelSegmentsForStaffDateParams,
    params: RequestParams = {},
  ) =>
    this.request<GetTravelSegmentsForStaffDateData, GetTravelSegmentsForStaffDateError>({
      path: `/staff/${staffId}/date/${date}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Delete all travel segments for a specific staff member on a specific date.
   *
   * @tags dbtn/module:travel_segments_management, dbtn/hasAuth
   * @name delete_travel_segments_for_staff_date
   * @summary Delete Travel Segments For Staff Date
   * @request DELETE:/routes/staff/{staff_id}/date/{date}
   */
  delete_travel_segments_for_staff_date = (
    { staffId, date, ...query }: DeleteTravelSegmentsForStaffDateParams,
    params: RequestParams = {},
  ) =>
    this.request<DeleteTravelSegmentsForStaffDateData, DeleteTravelSegmentsForStaffDateError>({
      path: `/staff/${staffId}/date/${date}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Trigger travel calculation for specified staff members and dates. This is typically called after appointment updates to refresh travel segments.
   *
   * @tags Travel Calculation, dbtn/module:travel_trigger, dbtn/hasAuth
   * @name trigger_travel_calculation
   * @summary Trigger Travel Calculation
   * @request POST:/routes/travel-trigger/calculate
   */
  trigger_travel_calculation = (data: TravelCalculationRequest, params: RequestParams = {}) =>
    this.request<TriggerTravelCalculationData, TriggerTravelCalculationError>({
      path: `/travel-trigger/calculate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Detect duplicate travel records in the staffattendance collection. These duplicates are typically caused by race conditions in concurrent travel calculations.
   *
   * @tags dbtn/module:duplicate_cleanup, dbtn/hasAuth
   * @name detect_duplicate_travel_records
   * @summary Detect Duplicate Travel Records
   * @request POST:/routes/detect-duplicates
   */
  detect_duplicate_travel_records = (query: DetectDuplicateTravelRecordsParams, params: RequestParams = {}) =>
    this.request<DetectDuplicateTravelRecordsData, DetectDuplicateTravelRecordsError>({
      path: `/detect-duplicates`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Clean up duplicate travel records by keeping the oldest record and removing duplicates. Uses dry_run=True by default for safety - set to false to actually perform cleanup.
   *
   * @tags dbtn/module:duplicate_cleanup, dbtn/hasAuth
   * @name cleanup_duplicate_travel_records
   * @summary Cleanup Duplicate Travel Records
   * @request POST:/routes/cleanup-duplicates
   */
  cleanup_duplicate_travel_records = (query: CleanupDuplicateTravelRecordsParams, params: RequestParams = {}) =>
    this.request<CleanupDuplicateTravelRecordsData, CleanupDuplicateTravelRecordsError>({
      path: `/cleanup-duplicates`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Get overall statistics about duplicate travel records in the system.
   *
   * @tags dbtn/module:duplicate_cleanup, dbtn/hasAuth
   * @name get_duplicate_statistics
   * @summary Get Duplicate Statistics
   * @request GET:/routes/duplicate-stats
   */
  get_duplicate_statistics = (params: RequestParams = {}) =>
    this.request<GetDuplicateStatisticsData, any>({
      path: `/duplicate-stats`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetches all appointment notes (not filtered by author). Used for counting notes across multiple appointments.
   *
   * @tags dbtn/module:notes_management, dbtn/hasAuth
   * @name get_all_my_notes
   * @summary Get All My Notes
   * @request GET:/routes/get_all_my_notes
   */
  get_all_my_notes = (params: RequestParams = {}) =>
    this.request<GetAllMyNotesData, any>({
      path: `/get_all_my_notes`,
      method: "GET",
      ...params,
    });

  /**
   * @description Migrate all office addresses from old format "11B/43-47 Morayfield Rd" to Google's standard format "Unit 11b/43 Morayfield Rd"
   *
   * @tags dbtn/module:migrate_office_addresses, dbtn/hasAuth
   * @name migrate_office_addresses
   * @summary Migrate Office Addresses
   * @request POST:/routes/migrate-office-addresses
   */
  migrate_office_addresses = (params: RequestParams = {}) =>
    this.request<MigrateOfficeAddressesData, any>({
      path: `/migrate-office-addresses`,
      method: "POST",
      ...params,
    });

  /**
   * @description Preview what would be updated in the address migration without making changes
   *
   * @tags dbtn/module:migrate_office_addresses, dbtn/hasAuth
   * @name preview_address_migration
   * @summary Preview Address Migration
   * @request GET:/routes/preview-address-migration
   */
  preview_address_migration = (params: RequestParams = {}) =>
    this.request<PreviewAddressMigrationData, any>({
      path: `/preview-address-migration`,
      method: "GET",
      ...params,
    });

  /**
   * @description Soft delete a travel segment by marking it as deleted. This preserves the record for audit trails while hiding it from normal queries.
   *
   * @tags dbtn/module:travel_deletion, dbtn/hasAuth
   * @name delete_travel_segment
   * @summary Delete Travel Segment
   * @request DELETE:/routes/delete-travel-segment
   */
  delete_travel_segment = (data: DeleteTravelRequest, params: RequestParams = {}) =>
    this.request<DeleteTravelSegmentData, DeleteTravelSegmentError>({
      path: `/delete-travel-segment`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Migrate existing overtime choices in staffattendance to transaction-based system.
   *
   * @tags Migration Utilities, dbtn/module:migration_utils, dbtn/hasAuth
   * @name migrate_overtime_choices
   * @summary Migrate Overtime Choices
   * @request POST:/routes/migration/overtime-choices-to-transactions
   */
  migrate_overtime_choices = (query: MigrateOvertimeChoicesParams, params: RequestParams = {}) =>
    this.request<MigrateOvertimeChoicesData, MigrateOvertimeChoicesError>({
      path: `/migration/overtime-choices-to-transactions`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Migration Utilities, dbtn/module:migration_utils, dbtn/hasAuth
   * @name ping_migration
   * @summary Ping Migration
   * @request GET:/routes/migration/ping
   */
  ping_migration = (params: RequestParams = {}) =>
    this.request<PingMigrationData, any>({
      path: `/migration/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Debug endpoint to check travel segments have vehicle data after TravelCalculator fix.
   *
   * @tags Migration Utilities, dbtn/module:migration_utils, dbtn/hasAuth
   * @name debug_travel_vehicles
   * @summary Debug Travel Vehicles
   * @request GET:/routes/migration/debug-travel-vehicles
   */
  debug_travel_vehicles = (params: RequestParams = {}) =>
    this.request<DebugTravelVehiclesData, any>({
      path: `/migration/debug-travel-vehicles`,
      method: "GET",
      ...params,
    });

  /**
   * @description Calculate the cost for an appointment based on service, time, and distance.
   *
   * @tags Appointment Pricing, dbtn/module:appointment_pricing, dbtn/hasAuth
   * @name calculate_appointment_cost
   * @summary Calculate Appointment Cost
   * @request POST:/routes/appointment-pricing/calculate
   */
  calculate_appointment_cost = (data: PriceCalculationRequest, params: RequestParams = {}) =>
    this.request<CalculateAppointmentCostData, CalculateAppointmentCostError>({
      path: `/appointment-pricing/calculate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fallback to legacy hourly pricing if no price book is available.
   *
   * @tags Appointment Pricing, dbtn/module:appointment_pricing, dbtn/hasAuth
   * @name calculate_legacy_pricing
   * @summary Calculate Legacy Pricing
   * @request POST:/routes/appointment-pricing/legacy-fallback
   */
  calculate_legacy_pricing = (query: CalculateLegacyPricingParams, params: RequestParams = {}) =>
    this.request<CalculateLegacyPricingData, CalculateLegacyPricingError>({
      path: `/appointment-pricing/legacy-fallback`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Update or create a travel segment with new timing. This is used when travel segments are moved via drag and drop.
   *
   * @tags dbtn/module:travel_segments, dbtn/hasAuth
   * @name update_travel_segment
   * @summary Update Travel Segment
   * @request POST:/routes/update-travel-segment
   */
  update_travel_segment = (data: UpdateTravelSegmentRequest, params: RequestParams = {}) =>
    this.request<UpdateTravelSegmentData, UpdateTravelSegmentError>({
      path: `/update-travel-segment`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update price book assignments on a travel-segment SA doc. Mirrors `update_appointment_request_details` but writes to the `staffattendance` collection so admins can edit a travel segment's inherited price books directly from the diary hover popup.
   *
   * @tags dbtn/module:travel_segments, dbtn/hasAuth
   * @name update_travel_segment_pricing
   * @summary Update Travel Segment Pricing
   * @request POST:/routes/travel-segments/{travel_segment_id}/pricing
   */
  update_travel_segment_pricing = (
    { travelSegmentId }: { travelSegmentId: string },
    data: {
      individualAssignments: Record<string, { priceBookIds: string[]; ratio?: number }>;
      useIndividualCharges: boolean;
      staffCount?: number;
      clientCount?: number;
      isOverridden?: boolean;
      change_reason?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
        travelSegmentId: string;
        clientBilling: any[];
        selectedPriceBooks: string[];
      },
      any
    >({
      path: `/travel-segments/${travelSegmentId}/pricing`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });


  /**
   * @description Get all admin_client conversations for a specific client. Only accessible by admin users.
   *
   * @tags dbtn/module:chat_admin, dbtn/hasAuth
   * @name get_all_client_conversations
   * @summary Get All Client Conversations
   * @request GET:/routes/admin/client-conversations/{client_id}
   */
  get_all_client_conversations = (
    { clientId, ...query }: GetAllClientConversationsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetAllClientConversationsData, GetAllClientConversationsError>({
      path: `/admin/client-conversations/${clientId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Batch-fetch admin_client conversations for many clients in ONE call.
   *
   * @tags dbtn/module:chat_admin, dbtn/hasAuth
   * @name get_client_conversations_batch
   * @summary Batch fetch client conversations
   * @request POST:/admin/client-conversations/batch
   */
  get_client_conversations_batch = (
    data: { client_ids: string[] },
    params: RequestParams = {},
  ) =>
    this.request<
      { by_client: Record<string, any[]> },
      any
    >({
      path: `/admin/client-conversations/batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a new unavailability period
   *
   * @tags Unavailability, dbtn/module:unavailability, dbtn/hasAuth
   * @name create_unavailability
   * @summary Create Unavailability
   * @request POST:/routes/routes/unavailability/
   */
  create_unavailability = (data: UnavailabilityCreateRequest, params: RequestParams = {}) =>
    this.request<CreateUnavailabilityData, CreateUnavailabilityError>({
      path: `/unavailability/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update an existing unavailability period
   *
   * @tags Unavailability, dbtn/module:unavailability, dbtn/hasAuth
   * @name update_unavailability
   * @summary Update Unavailability
   * @request PUT:/routes/routes/unavailability/{unavailability_id}
   */
  update_unavailability = (
    { unavailabilityId, ...query }: UpdateUnavailabilityParams,
    data: UnavailabilityUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateUnavailabilityData, UpdateUnavailabilityError>({
      path: `/unavailability/${unavailabilityId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Soft delete an unavailability by setting status to cancelled
   *
   * @tags Unavailability, dbtn/module:unavailability, dbtn/hasAuth
   * @name delete_unavailability
   * @summary Delete Unavailability
   * @request DELETE:/routes/routes/unavailability/{unavailability_id}
   */
  delete_unavailability = ({ unavailabilityId, ...query }: DeleteUnavailabilityParams, params: RequestParams = {}) =>
    this.request<DeleteUnavailabilityData, DeleteUnavailabilityError>({
      path: `/unavailability/${unavailabilityId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description List unavailabilities for a specific staff member
   *
   * @tags Unavailability, dbtn/module:unavailability, dbtn/hasAuth
   * @name list_staff_unavailabilities
   * @summary List Staff Unavailabilities
   * @request GET:/routes/routes/unavailability/staff/{staff_id}
   */
  list_staff_unavailabilities = ({ staffId, ...query }: ListStaffUnavailabilitiesParams, params: RequestParams = {}) =>
    this.request<ListStaffUnavailabilitiesData, ListStaffUnavailabilitiesError>({
      path: `/unavailability/staff/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List unavailabilities for all staff members or specific staff IDs (admin only) This endpoint is optimized for bulk fetching to reduce API calls in the Gantt chart. Instead of making individual calls per staff member, this returns all unavailabilities for multiple staff members in a single request.
   *
   * @tags Unavailability, dbtn/module:unavailability, dbtn/hasAuth
   * @name admin_list_all_staff_unavailabilities
   * @summary Admin List All Staff Unavailabilities
   * @request GET:/routes/routes/unavailability/admin/bulk
   */
  admin_list_all_staff_unavailabilities = (
    query: AdminListAllStaffUnavailabilitiesParams,
    params: RequestParams = {},
  ) =>
    this.request<AdminListAllStaffUnavailabilitiesData, AdminListAllStaffUnavailabilitiesError>({
      path: `/unavailability/admin/bulk`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get current business details. No authentication required for reading.
   *
   * @tags Business Details, dbtn/module:business_details, dbtn/hasAuth
   * @name get_business_details
   * @summary Get Business Details
   * @request GET:/business-details/
   */
  get_business_details = (params: RequestParams = {}) =>
    this.request<GetBusinessDetailsData, any>({
      path: `/business-details/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update business details. Requires admin role.
   *
   * @tags Business Details, dbtn/module:business_details, dbtn/hasAuth
   * @name update_business_details
   * @summary Update Business Details
   * @request PUT:/business-details/
   */
  update_business_details = (data: BusinessDetailsUpdate, params: RequestParams = {}) =>
    this.request<UpdateBusinessDetailsData, UpdateBusinessDetailsError>({
      path: `/business-details/`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a new event (admin only)
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name create_event
   * @summary Create Event
   * @request POST:/events/
   */
  create_event = (data: EventCreate, params: RequestParams = {}) =>
    this.request<CreateEventData, CreateEventError>({
      path: `/events/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all events
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name list_events
   * @summary List Events
   * @request GET:/events/
   */
  list_events = (query: ListEventsParams, params: RequestParams = {}) =>
    this.request<ListEventsData, ListEventsError>({
      path: `/events/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a specific event by ID
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name get_event
   * @summary Get Event
   * @request GET:/events/{event_id}
   */
  get_event = ({ eventId, ...query }: GetEventParams, params: RequestParams = {}) =>
    this.request<GetEventData, GetEventError>({
      path: `/events/${eventId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an event (admin only)
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name update_event
   * @summary Update Event
   * @request PUT:/events/{event_id}
   */
  update_event = ({ eventId, ...query }: UpdateEventParams, data: EventUpdate, params: RequestParams = {}) =>
    this.request<UpdateEventData, UpdateEventError>({
      path: `/events/${eventId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete an event (admin only)
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name delete_event
   * @summary Delete Event
   * @request DELETE:/events/{event_id}
   */
  delete_event = ({ eventId, ...query }: DeleteEventParams, params: RequestParams = {}) =>
    this.request<DeleteEventData, DeleteEventError>({
      path: `/events/${eventId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Restore a soft-deleted event and its transport bookings
   *
   * @tags Events
   * @name restore_event
   * @summary Restore Event
   * @request POST:/events/{event_id}/restore
   */
  restore_event = ({ eventId }: { eventId: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/events/${eventId}/restore`,
      method: "POST",
      ...params,
    });

  /**
   * @description Hard-delete every soft-deleted appointment AND every staff attendance record linked to those appointments. Irreversible.
   *
   * @tags Appointments
   * @name purge_all_deleted_appointments
   * @summary Purge All Deleted Appointments
   * @request POST:/appointments/purge-all-deleted
   */
  purge_all_deleted_appointments = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/appointments/purge-all-deleted`,
      method: "POST",
      ...params,
    });

  /**
   * @description Dry-run preview for the Purge All admin tool. Returns exact counts of soft-deleted appointments and linked staff attendance rows that would be hard-deleted. Read-only.
   *
   * @tags Appointments
   * @name preview_purge_all_deleted_appointments
   * @summary Preview Purge All Deleted Appointments
   * @request GET:/appointments/purge-all-deleted/preview
   */
  preview_purge_all_deleted_appointments = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/appointments/purge-all-deleted/preview`,
      method: "GET",
      ...params,
    });

  /**
   * @description Register client interest in an event
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name register_interest
   * @summary Register Interest
   * @request POST:/events/{event_id}/register-interest
   */
  register_interest = (
    { eventId, ...query }: RegisterInterestParams,
    data: EventInterestRequest,
    params: RequestParams = {},
  ) =>
    this.request<RegisterInterestData, RegisterInterestError>({
      path: `/events/${eventId}/register-interest`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Unregister client interest in an event
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name unregister_interest
   * @summary Unregister Interest
   * @request DELETE:/events/{event_id}/register-interest
   */
  unregister_interest = ({ eventId, ...query }: UnregisterInterestParams, data: { reason: string; cancelledByRole?: "client" | "staff" | "admin" }, params: RequestParams = {}) =>
    this.request<UnregisterInterestData, UnregisterInterestError>({
      path: `/events/${eventId}/register-interest`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Uploads an image for an event and returns its storage key.
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name upload_event_image
   * @summary Upload Event Image
   * @request POST:/events/image-upload
   */
  upload_event_image = (data: BodyUploadEventImage, params: RequestParams = {}) =>
    this.request<UploadEventImageData, UploadEventImageError>({
      path: `/events/image-upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Uploads a video for an event and returns its storage key.
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name upload_event_video
   * @summary Upload Event Video
   * @request POST:/events/video-upload
   */
  upload_event_video = (data: BodyUploadEventVideo, params: RequestParams = {}) =>
    this.request<UploadEventVideoData, UploadEventVideoError>({
      path: `/events/video-upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Serves an event image from binary storage.
   *
   * @tags Events, stream, dbtn/module:events, dbtn/hasAuth
   * @name get_event_image
   * @summary Get Event Image
   * @request GET:/events/images/{image_key}
   */
  get_event_image = ({ imageKey, ...query }: GetEventImageParams, params: RequestParams = {}) =>
    this.requestStream<GetEventImageData, GetEventImageError>({
      path: `/events/images/${imageKey}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Serves an event video from binary storage.
   *
   * @tags Events, stream, dbtn/module:events, dbtn/hasAuth
   * @name get_event_video
   * @summary Get Event Video
   * @request GET:/events/videos/{video_key}
   */
  get_event_video = ({ videoKey, ...query }: GetEventVideoParams, params: RequestParams = {}) =>
    this.requestStream<GetEventVideoData, GetEventVideoError>({
      path: `/events/videos/${videoKey}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get all events in a series by seriesId
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name get_series_events
   * @summary Get Series Events
   * @request GET:/events/series/{series_id}
   */
  get_series_events = ({ seriesId, ...query }: GetSeriesEventsParams, params: RequestParams = {}) =>
    this.request<GetSeriesEventsData, GetSeriesEventsError>({
      path: `/events/series/${seriesId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get all attendees for an event from the appointment's clientIds
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name get_event_attendees
   * @summary Get Event Attendees
   * @request GET:/events/{event_id}/attendees
   */
  get_event_attendees = ({ eventId, ...query }: GetEventAttendeesParams, params: RequestParams = {}) =>
    this.request<GetEventAttendeesData, GetEventAttendeesError>({
      path: `/events/${eventId}/attendees`,
      method: "GET",
      ...params,
    });

  /**
   * @description Set or clear a client's time override for an event.
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name set_client_time_override
   * @summary Set Client Time Override
   * @request POST:/events/{event_id}/client-time-override
   */
  set_client_time_override = (
    eventId: string,
    data: { clientId: string; startTime?: string | null; endTime?: string | null },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; message: string; clientTimeOverrides?: Record<string, { startTime?: string | null; endTime?: string | null }> | null }, any>({
      path: `/events/${eventId}/client-time-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Cancel individual attendance for an event. Uses unified cancellation system with cancelledParticipants field.
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name cancel_individual_attendance_event
   * @summary Cancel Individual Attendance Event
   * @request POST:/events/{event_id}/cancel-attendance
   */
  cancel_individual_attendance_event = (
    { eventId, ...query }: CancelIndividualAttendanceEventParams,
    data: AppApisEventsIndividualCancellationRequest,
    params: RequestParams = {},
  ) =>
    this.request<CancelIndividualAttendanceEventData, CancelIndividualAttendanceEventError>({
      path: `/events/${eventId}/cancel-attendance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Rebook individual attendance for an event. Removes participant from cancelledParticipants and restores them to active status.
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name rebook_individual_attendance_event
   * @summary Rebook Individual Attendance Event
   * @request POST:/events/{event_id}/rebook-attendance
   */
  rebook_individual_attendance_event = (
    { eventId, ...query }: RebookIndividualAttendanceEventParams,
    data: AppApisEventsIndividualRebookRequest,
    params: RequestParams = {},
  ) =>
    this.request<RebookIndividualAttendanceEventData, RebookIndividualAttendanceEventError>({
      path: `/events/${eventId}/rebook-attendance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Register client interest in an event
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name register_attendee
   * @summary Register Attendee
   * @request POST:/events/{event_id}/register-attendee
   */
  register_attendee = (
    { eventId, ...query }: RegisterAttendeeParams,
    data: AdminRegisterAttendeeRequest,
    params: RequestParams = {},
  ) =>
    this.request<RegisterAttendeeData, RegisterAttendeeError>({
      path: `/events/${eventId}/register-attendee`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Unregister client interest in an event
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name unregister_attendee
   * @summary Unregister Attendee
   * @request DELETE:/events/{event_id}/register-attendee
   */
  unregister_attendee = ({ eventId, ...query }: UnregisterAttendeeParams, data: { reason: string; cancelledByRole?: "client" | "staff" | "admin" }, params: RequestParams = {}) =>
    this.request<UnregisterAttendeeData, UnregisterAttendeeError>({
      path: `/events/${eventId}/register-attendee`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Register attendees for ALL events in a series
   *
   * @tags Events, dbtn/module:events, dbtn/hasAuth
   * @name register_attendee_for_series
   * @summary Register Attendee For Series
   * @request POST:/events/series/{series_id}/register-attendee
   */
  register_attendee_for_series = (
    { seriesId }: { seriesId: string },
    data: { clientIds: string[]; notes?: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/events/series/${seriesId}/register-attendee`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allows an authenticated staff member to submit an appointment request for a client.
   *
   * @tags Appointment Requests, dbtn/module:appointment_requests, dbtn/hasAuth
   * @name request_appointment_legacy
   * @summary Request Appointment Legacy
   * @request POST:/routes/appointment-requests/legacy
   */
  request_appointment_legacy = (data: AppApisAppointmentRequestsAppointmentRequestCreate, params: RequestParams = {}) =>
    this.request<RequestAppointmentLegacyData, RequestAppointmentLegacyError>({
      path: `/appointment-requests/legacy`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allows an authenticated client to submit their own appointment request.
   *
   * @tags Appointment Requests, dbtn/module:appointment_requests, dbtn/hasAuth
   * @name client_create_appointment_request
   * @summary Client Create Appointment Request
   * @request POST:/routes/appointment-requests/client/request
   */
  client_create_appointment_request = (data: ClientAppointmentRequestCreate, params: RequestParams = {}) =>
    this.request<ClientCreateAppointmentRequestData, ClientCreateAppointmentRequestError>({
      path: `/appointment-requests/client/request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a new lunch break for a staff member
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name create_lunch_break
   * @summary Create Lunch Break
   * @request POST:/routes/lunch-breaks/create
   */
  create_lunch_break = (data: LunchBreakRequest, params: RequestParams = {}) =>
    this.request<CreateLunchBreakData, CreateLunchBreakError>({
      path: `/lunch-breaks/create`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List lunch breaks for a specific date, optionally filtered by staff member
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name list_lunch_breaks
   * @summary List Lunch Breaks
   * @request GET:/routes/lunch-breaks/list
   */
  list_lunch_breaks = (query: ListLunchBreaksParams, params: RequestParams = {}) =>
    this.request<ListLunchBreaksData, ListLunchBreaksError>({
      path: `/lunch-breaks/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List lunch breaks across a date range — used by the
   * Timesheet Approval fortnight view to avoid 14 separate daily calls.
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name list_lunch_breaks_range
   * @summary List Lunch Breaks (range)
   * @request GET:/routes/lunch-breaks/range
   */
  list_lunch_breaks_range = (
    query: { start_date: string; end_date: string; staff_id?: string },
    params: RequestParams = {},
  ) =>
    this.request<ListLunchBreaksData, ListLunchBreaksError>({
      path: `/lunch-breaks/range`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Update an existing lunch break
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name update_lunch_break
   * @summary Update Lunch Break
   * @request PUT:/routes/lunch-breaks/update/{lunch_break_id}
   */
  update_lunch_break = (
    { lunchBreakId, ...query }: UpdateLunchBreakParams,
    data: LunchBreakRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateLunchBreakData, UpdateLunchBreakError>({
      path: `/lunch-breaks/update/${lunchBreakId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a lunch break
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name delete_lunch_break
   * @summary Delete Lunch Break
   * @request DELETE:/routes/lunch-breaks/delete/{lunch_break_id}
   */
  delete_lunch_break = ({ lunchBreakId, ...query }: DeleteLunchBreakParams, params: RequestParams = {}) =>
    this.request<DeleteLunchBreakData, DeleteLunchBreakError>({
      path: `/lunch-breaks/delete/${lunchBreakId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Auto-generate lunch breaks for full-time and part-time staff for a specific date
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name auto_generate_lunch_breaks
   * @summary Auto Generate Lunch Breaks
   * @request POST:/routes/lunch-breaks/auto-generate
   */
  auto_generate_lunch_breaks = (data: AutoGenerateLunchBreaksRequest, params: RequestParams = {}) =>
    this.request<AutoGenerateLunchBreaksData, AutoGenerateLunchBreaksError>({
      path: `/lunch-breaks/auto-generate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Populate lunch breaks for all permanent staff for the next 6 months
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name populate_lunch_breaks_6_months
   * @summary Populate Lunch Breaks 6 Months
   * @request POST:/routes/lunch-breaks/populate-6-months
   */
  populate_lunch_breaks_6_months = (params: RequestParams = {}) =>
    this.request<PopulateLunchBreaks6MonthsData, any>({
      path: `/lunch-breaks/populate-6-months`,
      method: "POST",
      ...params,
    });

  /**
   * @description List lunch breaks for an entire week (7 days) in one optimized call
   *
   * @tags dbtn/module:lunch_breaks, dbtn/hasAuth
   * @name list_weekly_lunch_breaks
   * @summary List Weekly Lunch Breaks
   * @request GET:/routes/lunch-breaks/weekly-list
   */
  list_weekly_lunch_breaks = (query: ListWeeklyLunchBreaksParams, params: RequestParams = {}) =>
    this.request<ListWeeklyLunchBreaksData, ListWeeklyLunchBreaksError>({
      path: `/lunch-breaks/weekly-list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get medical record for a specific client. Creates empty record if none exists.
   *
   * @tags Medical Records, dbtn/module:medical_records, dbtn/hasAuth
   * @name get_client_medical_record
   * @summary Get Client Medical Record
   * @request GET:/routes/clients/{client_id}/medical-record
   */
  get_client_medical_record = ({ clientId, ...query }: GetClientMedicalRecordParams, params: RequestParams = {}) =>
    this.request<GetClientMedicalRecordData, GetClientMedicalRecordError>({
      path: `/clients/${clientId}/medical-record`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update medical record for a specific client.
   *
   * @tags Medical Records, dbtn/module:medical_records, dbtn/hasAuth
   * @name update_client_medical_record
   * @summary Update Client Medical Record
   * @request PUT:/routes/clients/{client_id}/medical-record
   */
  update_client_medical_record = (
    { clientId, ...query }: UpdateClientMedicalRecordParams,
    data: MedicalRecordUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateClientMedicalRecordData, UpdateClientMedicalRecordError>({
      path: `/clients/${clientId}/medical-record`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Creates a new Firebase Authentication user and a corresponding Firestore document in the 'users' collection for a new client. Requires the caller to be an authenticated staff member. Uses an initialized Firestore client injected via dependency.
   *
   * @tags Client Management, dbtn/module:client_management, dbtn/hasAuth
   * @name create_client
   * @summary Create Client
   * @request POST:/routes/create-client
   */
  create_client = (data: CreateClientRequest, params: RequestParams = {}) =>
    this.request<CreateClientData, CreateClientError>({
      path: `/create-client`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Updates client details in the Firestore 'users' collection.
   *
   * @tags Client Management, dbtn/module:client_management, dbtn/hasAuth
   * @name update_client
   * @summary Update Client
   * @request PUT:/routes/clients/{client_id}
   */
  update_client = (
    { clientId, ...query }: UpdateClientParams,
    data: ClientUpdateOptional,
    params: RequestParams = {},
  ) =>
    this.request<UpdateClientData, UpdateClientError>({
      path: `/clients/${clientId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Push a client's new home address onto every future appointment that was using the old address. Only touches appointments where startTime > now and where the appointment's servicePlaceId / serviceAddressString matches the OLD home address — community-access locations are intentionally left alone.
   *
   * @tags Client Management, dbtn/module:client_management, dbtn/hasAuth
   * @name propagate_client_address
   * @summary Propagate Client Address
   * @request POST:/routes/clients/{client_id}/propagate-address
   */
  propagate_client_address = (
    clientId: string,
    data: {
      old_address_string?: string | null;
      old_place_id?: string | null;
      new_address_string: string;
      new_place_id?: string | null;
      change_reason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        appointments_updated: number;
        appointment_ids: string[];
        staff_attendance_updated: number;
      },
      { detail?: string }
    >({
      path: `/clients/${clientId}/propagate-address`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetches all notes for a given appointment.
   *
   * @tags notes, dbtn/module:notes_api, dbtn/hasAuth
   * @name list_appointment_notes
   * @summary List Appointment Notes
   * @request GET:/routes/appointments/{appointment_id}/notes
   */
  list_appointment_notes = ({ appointmentId, ...query }: ListAppointmentNotesParams, params: RequestParams = {}) =>
    this.request<ListAppointmentNotesData, ListAppointmentNotesError>({
      path: `/appointments/${appointmentId}/notes`,
      method: "GET",
      query: query as any,
      ...params,
    });

  /**
   * @description Creates a new note for a given appointment. Automatically saves clientIds from the appointment for easier querying.
   *
   * @tags notes, dbtn/module:notes_api, dbtn/hasAuth
   * @name create_appointment_note
   * @summary Create Appointment Note
   * @request POST:/routes/appointments/{appointment_id}/notes
   */
  create_appointment_note = (
    { appointmentId, ...query }: CreateAppointmentNoteParams,
    data: NoteCreateRequest,
    params: RequestParams = {},
  ) =>
    this.request<CreateAppointmentNoteData, CreateAppointmentNoteError>({
      path: `/appointments/${appointmentId}/notes`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Backfill clientIds field in appointment_notes collection. For each note, fetches the associated appointment and adds its clientIds.
   *
   * @tags dbtn/module:notes_migration, dbtn/hasAuth
   * @name migrate_appointment_notes_clientids
   * @summary Migrate Appointment Notes Clientids
   * @request POST:/routes/migrate-appointment-notes-clientids
   */
  migrate_appointment_notes_clientids = (params: RequestParams = {}) =>
    this.request<MigrateAppointmentNotesClientidsData, any>({
      path: `/migrate-appointment-notes-clientids`,
      method: "POST",
      ...params,
    });

  /**
   * @description List job board entries with optional filtering
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name list_job_board_entries
   * @summary List Job Board Entries
   * @request GET:/job-board/entries
   */
  list_job_board_entries = (query: ListJobBoardEntriesParams, params: RequestParams = {}) =>
    this.request<ListJobBoardEntriesData, ListJobBoardEntriesError>({
      path: `/job-board/entries`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Add an appointment to the job board
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name create_job_board_entry
   * @summary Create Job Board Entry
   * @request POST:/job-board/entries
   */
  create_job_board_entry = (data: JobBoardEntryRequest, params: RequestParams = {}) =>
    this.request<CreateJobBoardEntryData, CreateJobBoardEntryError>({
      path: `/job-board/entries`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allow staff to express interest in a job
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name express_job_interest
   * @summary Express Job Interest
   * @request POST:/job-board/entries/{appointment_id}/interest
   */
  express_job_interest = (
    { appointmentId, ...query }: ExpressJobInterestParams,
    data: JobInterestRequest,
    params: RequestParams = {},
  ) =>
    this.request<ExpressJobInterestData, ExpressJobInterestError>({
      path: `/job-board/entries/${appointmentId}/interest`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allow staff to withdraw their interest in a job
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name withdraw_job_interest
   * @summary Withdraw Job Interest
   * @request DELETE:/job-board/entries/{appointment_id}/interest
   */
  withdraw_job_interest = ({ appointmentId, ...query }: WithdrawJobInterestParams, params: RequestParams = {}) =>
    this.request<WithdrawJobInterestData, WithdrawJobInterestError>({
      path: `/job-board/entries/${appointmentId}/interest`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Admin invite specific staff to a job
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name invite_staff_to_job
   * @summary Invite Staff To Job
   * @request POST:/job-board/entries/{appointment_id}/invite
   */
  invite_staff_to_job = (
    { appointmentId, ...query }: InviteStaffToJobParams,
    data: StaffInvitationRequest,
    params: RequestParams = {},
  ) =>
    this.request<InviteStaffToJobData, InviteStaffToJobError>({
      path: `/job-board/entries/${appointmentId}/invite`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Assign an interested staff member to the appointment
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name assign_interested_staff
   * @summary Assign Interested Staff
   * @request POST:/job-board/entries/{appointment_id}/assign-staff
   */
  assign_interested_staff = (
    { appointmentId, ...query }: AssignInterestedStaffParams,
    data: AssignStaffRequest,
    params: RequestParams = {},
  ) =>
    this.request<AssignInterestedStaffData, AssignInterestedStaffError>({
      path: `/job-board/entries/${appointmentId}/assign-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Remove a job from the job board when filled
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name remove_from_job_board
   * @summary Remove From Job Board
   * @request DELETE:/job-board/entries/{appointment_id}
   */
  remove_from_job_board = ({ appointmentId, ...query }: RemoveFromJobBoardParams, params: RequestParams = {}) =>
    this.request<RemoveFromJobBoardData, RemoveFromJobBoardError>({
      path: `/job-board/entries/${appointmentId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description List job board invitations for staff members from appointment data
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name list_job_board_invitations
   * @summary List Job Board Invitations
   * @request GET:/job-board/invitations
   */
  list_job_board_invitations = (query: ListJobBoardInvitationsParams, params: RequestParams = {}) =>
    this.request<ListJobBoardInvitationsData, ListJobBoardInvitationsError>({
      path: `/job-board/invitations`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Add a transport journey to the job board
   * @name create_transport_job_board_entry
   * @request POST:/job-board/transport-entries
   */
  create_transport_job_board_entry = (
    data: {
      bookingId: string;
      journeyId: string;
      priority?: "low" | "normal" | "high" | "urgent";
      requiredAbilities?: string[] | null;
      deadline?: string | null;
      notes?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/job-board/transport-entries`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Remove a transport journey from the job board
   * @name remove_transport_from_job_board
   * @request DELETE:/job-board/transport-entries/{booking_id}/{journey_id}
   */
  remove_transport_from_job_board = (
    { bookingId, journeyId }: { bookingId: string; journeyId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/job-board/transport-entries/${bookingId}/${journeyId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Express interest in a transport journey job
   * @name express_transport_job_interest
   * @request POST:/job-board/transport-entries/{booking_id}/{journey_id}/interest
   */
  express_transport_job_interest = (
    { bookingId, journeyId }: { bookingId: string; journeyId: string },
    data: { message?: string | null; availability?: string | null },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/job-board/transport-entries/${bookingId}/${journeyId}/interest`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Withdraw interest in a transport journey job
   * @name withdraw_transport_job_interest
   * @request DELETE:/job-board/transport-entries/{booking_id}/{journey_id}/interest
   */
  withdraw_transport_job_interest = (
    { bookingId, journeyId }: { bookingId: string; journeyId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/job-board/transport-entries/${bookingId}/${journeyId}/interest`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Assign an interested staff member as the driver for a transport journey
   * @name assign_transport_job_staff
   * @request POST:/job-board/transport-entries/{booking_id}/{journey_id}/assign-staff
   */
  assign_transport_job_staff = (
    { bookingId, journeyId }: { bookingId: string; journeyId: string },
    data: { staffId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/job-board/transport-entries/${bookingId}/${journeyId}/assign-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Cancel a job board invitation
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name cancel_job_board_invitation
   * @summary Cancel Job Board Invitation
   * @request DELETE:/job-board/invitations/{appointment_id}/{staff_id}
   */
  cancel_job_board_invitation = (
    { appointmentId, staffId, ...query }: CancelJobBoardInvitationParams,
    params: RequestParams = {},
  ) =>
    this.request<CancelJobBoardInvitationData, CancelJobBoardInvitationError>({
      path: `/job-board/invitations/${appointmentId}/${staffId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Respond to a job board invitation (accept or decline)
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name respond_to_job_board_invitation
   * @summary Respond To Job Board Invitation
   * @request POST:/job-board/invitations/respond
   */
  respond_to_job_board_invitation = (data: RespondToJobBoardInvitationRequest, params: RequestParams = {}) =>
    this.request<RespondToJobBoardInvitationData, RespondToJobBoardInvitationError>({
      path: `/job-board/invitations/respond`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Legacy alias for creating job board entry
   *
   * @tags dbtn/module:job_board_management, dbtn/hasAuth
   * @name post_job_to_board
   * @summary Post Job To Board
   * @request POST:/job-board/post-job
   */
  post_job_to_board = (data: JobBoardEntryRequest, params: RequestParams = {}) =>
    this.request<PostJobToBoardData, PostJobToBoardError>({
      path: `/job-board/post-job`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get current cron/scheduler settings for notifications. Only accessible by admin users.
   *
   * @tags dbtn/module:cron_settings, dbtn/hasAuth
   * @name get_cron_settings
   * @summary Get Cron Settings
   * @request GET:/routes/cron-settings
   */
  get_cron_settings = (params: RequestParams = {}) =>
    this.request<GetCronSettingsData, any>({
      path: `/cron-settings/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update cron/scheduler settings for notifications. Only accessible by admin users.
   *
   * @tags dbtn/module:cron_settings, dbtn/hasAuth
   * @name update_cron_settings
   * @summary Update Cron Settings
   * @request POST:/routes/cron-settings
   */
  update_cron_settings = (data: CronSettingsData, params: RequestParams = {}) =>
    this.request<UpdateCronSettingsData, UpdateCronSettingsError>({
      path: `/cron-settings/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a new news article (admin only)
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name create_news_article
   * @summary Create News Article
   * @request POST:/news/create
   */
  create_news_article = (data: CreateNewsRequest, params: RequestParams = {}) =>
    this.request<CreateNewsArticleData, CreateNewsArticleError>({
      path: `/news/create`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List news articles based on user role (open endpoint)
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name list_news_articles
   * @summary List News Articles
   * @request GET:/news/list
   */
  list_news_articles = (query: ListNewsArticlesParams, params: RequestParams = {}) =>
    this.request<ListNewsArticlesData, ListNewsArticlesError>({
      path: `/news/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List all news articles for admin (including unpublished)
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name admin_list_news_articles
   * @summary Admin List News Articles
   * @request GET:/news/admin/list
   */
  admin_list_news_articles = (params: RequestParams = {}) =>
    this.request<AdminListNewsArticlesData, any>({
      path: `/news/admin/list`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get a single news article
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name get_news_article
   * @summary Get News Article
   * @request GET:/news/{news_id}
   */
  get_news_article = ({ newsId, ...query }: GetNewsArticleParams, params: RequestParams = {}) =>
    this.request<GetNewsArticleData, GetNewsArticleError>({
      path: `/news/${newsId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a news article (admin only)
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name update_news_article
   * @summary Update News Article
   * @request PUT:/news/{news_id}
   */
  update_news_article = (
    { newsId, ...query }: UpdateNewsArticleParams,
    data: UpdateNewsRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateNewsArticleData, UpdateNewsArticleError>({
      path: `/news/${newsId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a news article (admin only)
   *
   * @tags dbtn/module:news_management, dbtn/hasAuth
   * @name delete_news_article
   * @summary Delete News Article
   * @request DELETE:/news/{news_id}
   */
  delete_news_article = ({ newsId, ...query }: DeleteNewsArticleParams, params: RequestParams = {}) =>
    this.request<DeleteNewsArticleData, DeleteNewsArticleError>({
      path: `/news/${newsId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Fetch a list of all users from the profiles collection. Requires admin or staff privileges. Returns all active users regardless of role. Returns a dictionary mapping user ID (UID) to their full name.
   *
   * @tags profiles, dbtn/module:profiles, dbtn/hasAuth
   * @name list_clients
   * @summary List Clients
   * @request GET:/routes/profiles/list-clients
   */
  list_clients = (params: RequestParams = {}) =>
    this.request<ListClientsData, any>({
      path: `/profiles/list-clients`,
      method: "GET",
      ...params,
    });

  /**
   * @description List all incident reports
   *
   * @tags dbtn/module:incident_reports, dbtn/hasAuth
   * @name list_incident_reports
   * @summary List Incident Reports
   * @request GET:/incident-reports
   */
  list_incident_reports = (params: RequestParams = {}) =>
    this.request<ListIncidentReportsData, any>({
      path: `/incident-reports`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new incident report
   *
   * @tags dbtn/module:incident_reports, dbtn/hasAuth
   * @name create_incident_report
   * @summary Create Incident Report
   * @request POST:/incident-reports
   */
  create_incident_report = (data: IncidentReportRequest, params: RequestParams = {}) =>
    this.request<CreateIncidentReportData, CreateIncidentReportError>({
      path: `/incident-reports`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get a specific incident report by ID
   *
   * @tags dbtn/module:incident_reports, dbtn/hasAuth
   * @name get_incident_report
   * @summary Get Incident Report
   * @request GET:/incident-reports/{incident_id}
   */
  get_incident_report = ({ incidentId, ...query }: GetIncidentReportParams, params: RequestParams = {}) =>
    this.request<GetIncidentReportData, GetIncidentReportError>({
      path: `/incident-reports/${incidentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get count of unreviewed incident reports
   *
   * @tags dbtn/module:incident_reports, dbtn/hasAuth
   * @name count_unreviewed_incidents
   * @summary Count Unreviewed Incidents
   * @request GET:/incident-reports/count/unreviewed
   */
  count_unreviewed_incidents = (params: RequestParams = {}) =>
    this.request<CountUnreviewedIncidentsData, any>({
      path: `/incident-reports/count/unreviewed`,
      method: "GET",
      ...params,
    });

  /**
   * @description Mark an incident report as reviewed
   *
   * @tags dbtn/module:incident_reports, dbtn/hasAuth
   * @name mark_incident_reviewed
   * @summary Mark Incident Reviewed
   * @request POST:/incident-reports/{incident_id}/mark-reviewed
   */
  mark_incident_reviewed = ({ incidentId, ...query }: MarkIncidentReviewedParams, params: RequestParams = {}) =>
    this.request<MarkIncidentReviewedData, MarkIncidentReviewedError>({
      path: `/incident-reports/${incidentId}/mark-reviewed`,
      method: "POST",
      ...params,
    });

  /**
   * @description Count all pending invitations across all appointments. Invitations are stored in the invitedStaff array within appointment documents.
   *
   * @tags Pending Invitations, dbtn/module:pending_invitations, dbtn/hasAuth
   * @name get_pending_invitations_count
   * @summary Get Pending Invitations Count
   * @request GET:/routes/pending-invitations/count
   */
  get_pending_invitations_count = (params: RequestParams = {}) =>
    this.request<GetPendingInvitationsCountData, any>({
      path: `/pending-invitations/count`,
      method: "GET",
      ...params,
    });

  /**
   * @description List all pending invitations across all appointments with details.
   *
   * @tags Pending Invitations, dbtn/module:pending_invitations, dbtn/hasAuth
   * @name list_pending_invitations
   * @summary List Pending Invitations
   * @request GET:/routes/pending-invitations/list
   */
  list_pending_invitations = (params: RequestParams = {}) =>
    this.request<ListPendingInvitationsData, any>({
      path: `/pending-invitations/list`,
      method: "GET",
      ...params,
    });

  /**
   * @description Count staffattendance records where status='active'. These are shifts where staff have clocked in but not yet clocked out.
   *
   * @tags dbtn/module:count_active_shifts, dbtn/hasAuth
   * @name count_active_shifts
   * @summary Count Active Shifts
   * @request GET:/routes/count-active-shifts
   */
  count_active_shifts = (params: RequestParams = {}) =>
    this.request<CountActiveShiftsData, any>({
      path: `/count-active-shifts`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get SMTP settings (admin only) Password is not returned for security
   *
   * @tags dbtn/module:admin_settings, dbtn/hasAuth
   * @name get_smtp_settings
   * @summary Get Smtp Settings
   * @request GET:/routes/admin/smtp-settings
   */
  get_smtp_settings = (params: RequestParams = {}) =>
    this.request<GetSmtpSettingsData, any>({
      path: `/admin/smtp-settings`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update SMTP settings (admin only)
   *
   * @tags dbtn/module:admin_settings, dbtn/hasAuth
   * @name update_smtp_settings
   * @summary Update Smtp Settings
   * @request POST:/routes/admin/smtp-settings
   */
  update_smtp_settings = (data: SMTPSettings, params: RequestParams = {}) =>
    this.request<UpdateSmtpSettingsData, UpdateSmtpSettingsError>({
      path: `/admin/smtp-settings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Test SMTP connection (admin only)
   *
   * @tags dbtn/module:admin_settings, dbtn/hasAuth
   * @name test_smtp_settings
   * @summary Test Smtp Settings
   * @request POST:/routes/admin/smtp-settings/test
   */
  test_smtp_settings = (params: RequestParams = {}) =>
    this.request<TestSmtpSettingsData, any>({
      path: `/admin/smtp-settings/test`,
      method: "POST",
      ...params,
    });

  /**
   * @description List public events with only safe, non-sensitive information. This endpoint is PUBLIC and requires NO authentication. It only returns information suitable for public viewing.
   *
   * @tags Public News and Events, dbtn/module:publicnewsandevents
   * @name list_public_events
   * @summary List Public Events
   * @request GET:/routes/publicnewsandevents/events
   */
  list_public_events = (query: ListPublicEventsParams, params: RequestParams = {}) =>
    this.request<ListPublicEventsData, ListPublicEventsError>({
      path: `/publicnewsandevents/events`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a single public event by ID with only safe, non-sensitive information. This endpoint is PUBLIC and requires NO authentication.
   *
   * @tags Public News and Events, dbtn/module:publicnewsandevents
   * @name get_public_event
   * @summary Get Public Event
   * @request GET:/routes/publicnewsandevents/events/{event_id}
   */
  get_public_event = ({ eventId, ...query }: GetPublicEventParams, params: RequestParams = {}) =>
    this.request<GetPublicEventData, GetPublicEventError>({
      path: `/publicnewsandevents/events/${eventId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Verifies an address using the Google Geocoding API based on a single input string.
   *
   * @tags dbtn/module:address_verification, dbtn/hasAuth
   * @name verify_address
   * @summary Verify Address
   * @request POST:/routes/verify-address
   */
  verify_address = (data: AddressVerificationRequest, params: RequestParams = {}) =>
    this.request<VerifyAddressData, VerifyAddressError>({
      path: `/verify-address`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Migrate all staff to A/B roster system by copying Week A data to Week B for staff who don't have Week B data.
   *
   * @tags dbtn/module:migrate_ab_roster, dbtn/hasAuth
   * @name migrate_to_ab_roster
   * @summary Migrate To Ab Roster
   * @request POST:/routes/migrate-to-ab-roster
   */
  migrate_to_ab_roster = (params: RequestParams = {}) =>
    this.request<MigrateToAbRosterData, any>({
      path: `/migrate-to-ab-roster`,
      method: "POST",
      ...params,
    });

  /**
   * @description Check the current status of A/B roster migration - how many staff have Week B data.
   *
   * @tags dbtn/module:migrate_ab_roster, dbtn/hasAuth
   * @name check_migration_status
   * @summary Check Migration Status
   * @request GET:/routes/check-migration-status
   */
  check_migration_status = (params: RequestParams = {}) =>
    this.request<CheckMigrationStatusData, any>({
      path: `/check-migration-status`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags Admin Features, dbtn/module:admin_features, dbtn/hasAuth
   * @name override_attendance_time
   * @summary Override Attendance Time
   * @request POST:/routes/admin-features/override-attendance-time
   */
  override_attendance_time = (data: AdminTimeOverrideRequest, params: RequestParams = {}) =>
    this.request<OverrideAttendanceTimeData, OverrideAttendanceTimeError>({
      path: `/admin-features/override-attendance-time`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Submit an access request that requires admin approval
   *
   * @tags dbtn/module:access_requests
   * @name submit_access_request
   * @summary Submit Access Request
   * @request POST:/routes/access-requests/submit
   */
  submit_access_request = (data: AccessRequest, params: RequestParams = {}) =>
    this.request<SubmitAccessRequestData, SubmitAccessRequestError>({
      path: `/access-requests/submit`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all access requests (admin only) Filter by status: pending, approved, rejected
   *
   * @tags dbtn/module:access_requests
   * @name list_access_requests
   * @summary List Access Requests
   * @request GET:/routes/access-requests/list
   */
  list_access_requests = (query: ListAccessRequestsParams, params: RequestParams = {}) =>
    this.request<ListAccessRequestsData, ListAccessRequestsError>({
      path: `/access-requests/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Approve or reject an access request (admin only) Sends email notification to the user
   *
   * @tags dbtn/module:access_requests
   * @name process_access_request
   * @summary Process Access Request
   * @request POST:/routes/access-requests/process
   */
  process_access_request = (data: ApprovalRequest, params: RequestParams = {}) =>
    this.request<ProcessAccessRequestData, ProcessAccessRequestError>({
      path: `/access-requests/process`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check if an email has been approved for account creation
   *
   * @tags dbtn/module:access_requests
   * @name check_approval_status
   * @summary Check Approval Status
   * @request GET:/routes/access-requests/check-approval/{email}
   */
  check_approval_status = ({ email, ...query }: CheckApprovalStatusParams, params: RequestParams = {}) =>
    this.request<CheckApprovalStatusData, CheckApprovalStatusError>({
      path: `/access-requests/check-approval/${email}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Called after user creates their Firebase account to clean up approval data
   *
   * @tags dbtn/module:access_requests
   * @name complete_signup
   * @summary Complete Signup
   * @request POST:/routes/access-requests/complete-signup
   */
  complete_signup = (query: CompleteSignupParams, params: RequestParams = {}) =>
    this.request<CompleteSignupData, CompleteSignupError>({
      path: `/access-requests/complete-signup`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description One-time migration: Move access requests from db.storage.json to Firestore
   *
   * @tags dbtn/module:access_requests
   * @name migrate_from_storage
   * @summary Migrate From Storage
   * @request POST:/routes/access-requests/migrate-from-storage
   */
  migrate_from_storage = (params: RequestParams = {}) =>
    this.request<MigrateFromStorageData, any>({
      path: `/access-requests/migrate-from-storage`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get count of pending access requests (admin only)
   *
   * @tags dbtn/module:access_requests
   * @name count_pending_access_requests
   * @summary Count Pending Access Requests
   * @request GET:/routes/access-requests/count-pending
   */
  count_pending_access_requests = (params: RequestParams = {}) =>
    this.request<CountPendingAccessRequestsData, any>({
      path: `/access-requests/count-pending`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetch user emails/display names for a batch of user IDs. Only accessible to authenticated users. Returns a map of userId -> email (or display name if available).
   *
   * @tags dbtn/module:user_info, dbtn/hasAuth
   * @name get_user_emails_batch
   * @summary Get User Emails Batch
   * @request POST:/routes/user-emails/batch
   */
  get_user_emails_batch = (data: UserEmailBatchRequest, params: RequestParams = {}) =>
    this.request<GetUserEmailsBatchData, GetUserEmailsBatchError>({
      path: `/user-emails/batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetch all shift notes (noteType='staff_general') within a date range. Date format: ISO 8601 (e.g., '2024-01-01T00:00:00Z')
   *
   * @tags dbtn/module:shift_notes_review, dbtn/hasAuth
   * @name get_shift_notes
   * @summary Get Shift Notes
   * @request GET:/shift-notes
   */
  get_shift_notes = (query: GetShiftNotesParams, params: RequestParams = {}) =>
    this.request<GetShiftNotesData, GetShiftNotesError>({
      path: `/shift-notes`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get all appointments for a specific client in a given month. Args: client_id: The client's user ID year: Year (e.g., 2025) month: Month (1-12) Returns: List of appointments for the client in the specified month
   *
   * @tags Client Diary, dbtn/module:client_diary, dbtn/hasAuth
   * @name get_client_diary_appointments
   * @summary Get Client Diary Appointments
   * @request GET:/routes/client-diary/appointments/{client_id}
   */
  get_client_diary_appointments = (
    { clientId, ...query }: GetClientDiaryAppointmentsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetClientDiaryAppointmentsData, GetClientDiaryAppointmentsError>({
      path: `/client-diary/appointments/${clientId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get transport bookings for the authenticated client. Only returns bookings where the client has pickup requests.
   *
   * @tags dbtn/module:client_transport_bookings, dbtn/hasAuth
   * @name get_client_transport_bookings
   * @summary Get Client Transport Bookings
   * @request GET:/routes/client-transport-bookings
   */
  get_client_transport_bookings = (params: RequestParams = {}) =>
    this.request<GetClientTransportBookingsData, any>({
      path: `/routes/client-transport-bookings`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get transport bookings for a specific client (staff use only). Returns bookings where the specified client has pickup requests.
   *
   * @tags dbtn/module:client_transport_bookings, dbtn/hasAuth
   * @name get_client_transport_bookings_for_staff
   * @summary Get Client Transport Bookings For Staff
   * @request GET:/routes/staff/client-transport-bookings
   */
  get_client_transport_bookings_for_staff = (
    query: GetClientTransportBookingsForStaffParams,
    params: RequestParams = {},
  ) =>
    this.request<GetClientTransportBookingsForStaffData, GetClientTransportBookingsForStaffError>({
      path: `/routes/staff/client-transport-bookings`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Migrate all appointments and staffattendance records to have proper clientBilling structure. This fixes records where selectedPriceBooks exists at the top level but clientBilling is missing. Generates clientBilling array where each client gets the same price books. Also populates clientName by fetching from users collection.
   *
   * @tags dbtn/module:billing_migration, dbtn/hasAuth
   * @name migrate_client_billing_structure
   * @summary Migrate Client Billing Structure
   * @request POST:/routes/migrate-client-billing
   */
  migrate_client_billing_structure = (params: RequestParams = {}) =>
    this.request<MigrateClientBillingStructureData, any>({
      path: `/migrate-client-billing`,
      method: "POST",
      ...params,
    });

  /**
   * @description Create a new expense claim. Staff can create claims for their own appointments.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name create_expense_claim
   * @summary Create Expense Claim
   * @request POST:/routes/expense-claims/
   */
  create_expense_claim = (data: ExpenseClaimCreate, params: RequestParams = {}) =>
    this.request<CreateExpenseClaimData, CreateExpenseClaimError>({
      path: `/expense-claims/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List expense claims for the current staff member or all claims if admin.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name list_my_expense_claims
   * @summary List My Expense Claims
   * @request GET:/routes/expense-claims/my-claims
   */
  list_my_expense_claims = (query: ListMyExpenseClaimsParams, params: RequestParams = {}) =>
    this.request<ListMyExpenseClaimsData, ListMyExpenseClaimsError>({
      path: `/expense-claims/my-claims`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a specific expense claim. Staff can only view their own claims.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name get_expense_claim
   * @summary Get Expense Claim
   * @request GET:/routes/expense-claims/{claim_id}
   */
  get_expense_claim = ({ claimId, ...query }: GetExpenseClaimParams, params: RequestParams = {}) =>
    this.request<GetExpenseClaimData, GetExpenseClaimError>({
      path: `/expense-claims/${claimId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an expense claim. Staff can only update their own pending claims.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name update_expense_claim
   * @summary Update Expense Claim
   * @request PUT:/routes/expense-claims/{claim_id}
   */
  update_expense_claim = (
    { claimId, ...query }: UpdateExpenseClaimParams,
    data: ExpenseClaimUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateExpenseClaimData, UpdateExpenseClaimError>({
      path: `/expense-claims/${claimId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete an expense claim. Staff can only delete their own pending claims.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name delete_expense_claim
   * @summary Delete Expense Claim
   * @request DELETE:/routes/expense-claims/{claim_id}
   */
  delete_expense_claim = ({ claimId, ...query }: DeleteExpenseClaimParams, params: RequestParams = {}) =>
    this.request<DeleteExpenseClaimData, DeleteExpenseClaimError>({
      path: `/expense-claims/${claimId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Superadmin-only — approve or reject an expense claim.
   * Stamps `status`, `approved_by`, `approved_at`, and optional
   * `decision_note` on the underlying Firestore doc.
   *
   * @tags Expense Claims, dbtn/module:expense_claims, dbtn/hasAuth
   * @name decide_expense_claim
   * @summary Decide Expense Claim
   * @request POST:/routes/expense-claims/{claim_id}/decision
   */
  decide_expense_claim = (
    { claimId }: { claimId: string },
    data: { decision: "approved" | "rejected"; note?: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/expense-claims/${claimId}/decision`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all price books with optional filtering.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name list_price_books
   * @summary List Price Books
   * @request GET:/price-books/
   */
  list_price_books = (query: ListPriceBooksParams, params: RequestParams = {}) =>
    this.request<ListPriceBooksData, ListPriceBooksError>({
      path: `/price-books/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Create a new price book.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name create_price_book
   * @summary Create Price Book
   * @request POST:/price-books/
   */
  create_price_book = (data: PriceBookCreate, params: RequestParams = {}) =>
    this.request<CreatePriceBookData, CreatePriceBookError>({
      path: `/price-books/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get a specific price book by ID.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name get_price_book
   * @summary Get Price Book
   * @request GET:/price-books/{price_book_id}
   */
  get_price_book = ({ priceBookId, ...query }: GetPriceBookParams, params: RequestParams = {}) =>
    this.request<GetPriceBookData, GetPriceBookError>({
      path: `/price-books/${priceBookId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an existing price book.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name update_price_book
   * @summary Update Price Book
   * @request PUT:/price-books/{price_book_id}
   */
  update_price_book = (
    { priceBookId, ...query }: UpdatePriceBookParams,
    data: PriceBookUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdatePriceBookData, UpdatePriceBookError>({
      path: `/price-books/${priceBookId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a price book (soft delete by setting is_active to False).
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name delete_price_book
   * @summary Delete Price Book
   * @request DELETE:/price-books/{price_book_id}
   */
  delete_price_book = ({ priceBookId, ...query }: DeletePriceBookParams, params: RequestParams = {}) =>
    this.request<DeletePriceBookData, DeletePriceBookError>({
      path: `/price-books/${priceBookId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Calculate the price for an appointment based on service, time, and distance.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name calculate_price
   * @summary Calculate Price
   * @request POST:/price-books/calculate-price
   */
  calculate_price = (data: PriceCalculationRequest, params: RequestParams = {}) =>
    this.request<CalculatePriceData, CalculatePriceError>({
      path: `/price-books/calculate-price`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get the currently active price book for a specific service.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name get_active_price_book_for_service
   * @summary Get Active Price Book For Service
   * @request GET:/price-books/service/{service_id}/active
   */
  get_active_price_book_for_service = (
    { serviceId, ...query }: GetActivePriceBookForServiceParams,
    params: RequestParams = {},
  ) =>
    this.request<GetActivePriceBookForServiceData, GetActivePriceBookForServiceError>({
      path: `/price-books/service/${serviceId}/active`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get change history for a specific price book.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name get_price_book_history
   * @summary Get Price Book History
   * @request GET:/price-books/{price_book_id}/history
   */
  get_price_book_history = ({ priceBookId, ...query }: GetPriceBookHistoryParams, params: RequestParams = {}) =>
    this.request<GetPriceBookHistoryData, GetPriceBookHistoryError>({
      path: `/price-books/${priceBookId}/history`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get audit log of all price book changes.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name get_all_price_book_changes
   * @summary Get All Price Book Changes
   * @request GET:/price-books/audit-log/all
   */
  get_all_price_book_changes = (query: GetAllPriceBookChangesParams, params: RequestParams = {}) =>
    this.request<GetAllPriceBookChangesData, GetAllPriceBookChangesError>({
      path: `/price-books/audit-log/all`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Preview the impact of a bulk update without applying it.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name preview_bulk_update
   * @summary Preview Bulk Update
   * @request POST:/price-books/bulk-update/preview
   */
  preview_bulk_update = (data: BulkUpdateRequest, params: RequestParams = {}) =>
    this.request<PreviewBulkUpdateData, PreviewBulkUpdateError>({
      path: `/price-books/bulk-update/preview`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Apply bulk update to multiple price books.
   *
   * @tags Price Books, dbtn/module:price_books, dbtn/hasAuth
   * @name apply_bulk_update
   * @summary Apply Bulk Update
   * @request POST:/price-books/bulk-update/apply
   */
  apply_bulk_update = (data: BulkUpdateRequest, params: RequestParams = {}) =>
    this.request<ApplyBulkUpdateData, ApplyBulkUpdateError>({
      path: `/price-books/bulk-update/apply`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Migration endpoint to remove legacy staffInvitationStatus fields from appointment documents. This standardizes on using only the invitedStaff array for invitation data.
   *
   * @tags dbtn/module:data_migration, dbtn/hasAuth
   * @name remove_staff_invitation_status
   * @summary Remove Staff Invitation Status
   * @request POST:/routes/data-migration/remove-staff-invitation-status
   */
  remove_staff_invitation_status = (query: RemoveStaffInvitationStatusParams, params: RequestParams = {}) =>
    this.request<RemoveStaffInvitationStatusData, RemoveStaffInvitationStatusError>({
      path: `/data-migration/remove-staff-invitation-status`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Migrates attendance data from multiple storage locations to staffAttendanceDetails as the primary source of truth. This migration function: 1. Scans appointments (up to limit) 2. For each appointment, consolidates staff attendance data from multiple sources 3. Updates the staffAttendanceDetails array in each appointment document This function should be run with admin privileges.
   *
   * @tags dbtn/module:data_migration, dbtn/hasAuth
   * @name consolidate_attendance_data
   * @summary Consolidate Attendance Data
   * @request POST:/routes/data-migration/consolidate-attendance-data
   */
  consolidate_attendance_data = (query: ConsolidateAttendanceDataParams, params: RequestParams = {}) =>
    this.request<ConsolidateAttendanceDataData, ConsolidateAttendanceDataError>({
      path: `/data-migration/consolidate-attendance-data`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Migration endpoint to fix appointment timing issues where end time is before start time due to daily recurring bug
   *
   * @tags dbtn/module:data_migration, dbtn/hasAuth
   * @name fix_appointment_timing
   * @summary Fix Appointment Timing
   * @request POST:/routes/data-migration/fix-appointment-timing
   */
  fix_appointment_timing = (query: FixAppointmentTimingParams, params: RequestParams = {}) =>
    this.request<FixAppointmentTimingData, FixAppointmentTimingError>({
      path: `/data-migration/fix-appointment-timing`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Migration endpoint to get problematic appointments where end time is before start time due to daily recurring bug
   *
   * @tags dbtn/module:data_migration, dbtn/hasAuth
   * @name get_problematic_appointments
   * @summary Get Problematic Appointments
   * @request POST:/routes/data-migration/get-problematic-appointments
   */
  get_problematic_appointments = (query: GetProblematicAppointmentsParams, params: RequestParams = {}) =>
    this.request<GetProblematicAppointmentsData, GetProblematicAppointmentsError>({
      path: `/data-migration/get-problematic-appointments`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description MYA-1558: Populate clientBilling for appointments missing it or with empty clientBilling. This fixes appointments created before clientName was added to clientBilling structure.
   *
   * @tags dbtn/module:data_migration, dbtn/hasAuth
   * @name fix_client_billing
   * @summary Fix Client Billing
   * @request POST:/routes/data-migration/fix-client-billing
   */
  fix_client_billing = (query: FixClientBillingParams, params: RequestParams = {}) =>
    this.request<FixClientBillingData, FixClientBillingError>({
      path: `/data-migration/fix-client-billing`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Calculates travel time and distance from a fixed origin to the provided destination address using the Google Directions API.
   *
   * @tags dbtn/module:directions, dbtn/hasAuth
   * @name calculate_travel
   * @summary Calculate Travel
   * @request POST:/routes/calculate-travel
   */
  calculate_travel = (data: TravelRequest, params: RequestParams = {}) =>
    this.request<CalculateTravelData, CalculateTravelError>({
      path: `/calculate-travel`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Calculates travel time and distance between two addresses using the Google Directions API.
   *
   * @tags dbtn/module:directions, dbtn/hasAuth
   * @name calculate_travel_between_addresses
   * @summary Calculate Travel Between Addresses
   * @request POST:/calculate-travel-between-addresses
   */
  calculate_travel_between_addresses = (data: TravelBetweenAddressesRequest, params: RequestParams = {}) =>
    this.request<CalculateTravelBetweenAddressesData, CalculateTravelBetweenAddressesError>({
      path: `/calculate-travel-between-addresses`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Retrieve a list of all available services.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name list_services
   * @summary List Services
   * @request GET:/services/
   */
  list_services = (params: RequestParams = {}) =>
    this.request<ListServicesData, any>({
      path: `/services/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new service.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name create_service
   * @summary Create Service
   * @request POST:/services/
   */
  create_service = (data: ServiceCreate, params: RequestParams = {}) =>
    this.request<CreateServiceData, CreateServiceError>({
      path: `/services/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get details of a specific service by its ID.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name get_service
   * @summary Get Service
   * @request GET:/services/{service_id}
   */
  get_service = ({ serviceId, ...query }: GetServiceParams, params: RequestParams = {}) =>
    this.request<GetServiceData, GetServiceError>({
      path: `/services/${serviceId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an existing service.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name update_service
   * @summary Update Service
   * @request PUT:/services/{service_id}
   */
  update_service = (
    { serviceId, ...query }: UpdateServiceParams,
    data: ServiceUpdateOptional,
    params: RequestParams = {},
  ) =>
    this.request<UpdateServiceData, UpdateServiceError>({
      path: `/services/${serviceId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a service by its ID.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name delete_service
   * @summary Delete Service
   * @request DELETE:/services/{service_id}
   */
  delete_service = ({ serviceId, ...query }: DeleteServiceParams, params: RequestParams = {}) =>
    this.request<DeleteServiceData, DeleteServiceError>({
      path: `/services/${serviceId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Retrieve the change history for a specific service, including user names.
   *
   * @tags Services, dbtn/module:services, dbtn/hasAuth
   * @name get_service_history
   * @summary Get Service History
   * @request GET:/services/{service_id}/history
   */
  get_service_history = ({ serviceId, ...query }: GetServiceHistoryParams, params: RequestParams = {}) =>
    this.request<GetServiceHistoryData, GetServiceHistoryError>({
      path: `/services/${serviceId}/history`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetch approved billing records for a period and group by client for invoice preview.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name preview_approved_billing
   * @summary Preview Approved Billing
   * @request POST:/routes/invoices/preview-approved-billing
   */
  preview_approved_billing = (data: BillingRecordPreviewRequest, params: RequestParams = {}) =>
    this.request<PreviewApprovedBillingData, PreviewApprovedBillingError>({
      path: `/invoices/preview-approved-billing`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Generate invoices for selected clients based on approved billing records. One invoice per client.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name generate_invoices
   * @summary Generate Invoices
   * @request POST:/routes/invoices/generate
   */
  generate_invoices = (data: GenerateInvoiceRequest, params: RequestParams = {}) =>
    this.request<GenerateInvoicesData, GenerateInvoicesError>({
      path: `/invoices/generate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List invoices with optional filters.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name list_invoices
   * @summary List Invoices
   * @request GET:/routes/invoices/list
   */
  list_invoices = (query: ListInvoicesParams, params: RequestParams = {}) =>
    this.request<ListInvoicesData, ListInvoicesError>({
      path: `/invoices/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a single invoice by ID.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name get_invoice
   * @summary Get Invoice
   * @request GET:/routes/invoices/get/{invoice_id}
   */
  get_invoice = ({ invoiceId, ...query }: GetInvoiceParams, params: RequestParams = {}) =>
    this.request<GetInvoiceData, GetInvoiceError>({
      path: `/invoices/get/${invoiceId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update invoice status (draft -> sent -> paid).
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name update_invoice_status
   * @summary Update Invoice Status
   * @request PUT:/routes/invoices/{invoice_id}/status
   */
  update_invoice_status = ({ invoiceId, ...query }: UpdateInvoiceStatusParams, params: RequestParams = {}) =>
    this.request<UpdateInvoiceStatusData, UpdateInvoiceStatusError>({
      path: `/invoices/${invoiceId}/status`,
      method: "PUT",
      query: query,
      ...params,
    });

  /**
   * @description List staffattendance shifts in the period that have no client/no billing data and still need payroll approval. Used by the No-Billing Shifts (Payroll Only) section on Admin Billing Approval.
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name get_no_client_shifts
   * @request GET:/routes/billing/no-client-shifts
   */
  get_no_client_shifts = (
    query?: { start_date?: string; end_date?: string },
    params: RequestParams = {},
  ) =>
    this.request<any[], any>({
      path: `/billing/no-client-shifts`,
      method: "GET",
      query,
      ...params,
    });

  /**
   * @description Mark a no-client shift as 'closed — no payroll items'. Used when the same staff is already paid via an overlapping billed shift.
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name close_no_payroll
   * @request POST:/routes/billing/close-no-payroll
   */
  close_no_payroll = (
    data: { staffAttendanceId: string; reason?: string },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; staffAttendanceId: string }, any>({
      path: `/billing/close-no-payroll`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Find staffattendance records approved for the timesheet but NOT flagged for payroll (drift from the older non-billable approval path). Returns count + sample list of up to 50 rows.
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name payroll_integrity_check
   * @request GET:/routes/billing/payroll-integrity-check
   */
  payroll_integrity_check = (params: RequestParams = {}) =>
    this.request<
      {
        driftCount: number;
        rows: Array<{
          staffAttendanceId: string;
          staffName?: string | null;
          startTime?: string | null;
          endTime?: string | null;
          timesheetApprovedHours?: number | null;
          payrollStatus?: string | null;
          isApproved?: boolean | null;
        }>;
      },
      any
    >({
      path: `/billing/payroll-integrity-check`,
      method: "GET",
      ...params,
    });

  /**
   * @description Flip every drifted staffattendance record so it flows to payroll. Pass `{staffAttendanceId}` to fix just one row instead of all.
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name payroll_integrity_fix
   * @request POST:/routes/billing/payroll-integrity-fix
   */
  payroll_integrity_fix = (
    data: { staffAttendanceId?: string } = {},
    params: RequestParams = {},
  ) =>
    this.request<{ fixedCount: number }, any>({
      path: `/billing/payroll-integrity-fix`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Mark an invoice as "Do not sync to Xero" (or restore it).
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name toggle_invoice_sync_ignored
   * @summary Toggle Invoice Sync Ignored
   * @request POST:/routes/invoices/{invoice_id}/sync-ignored
   */
  toggle_invoice_sync_ignored = (
    { invoiceId }: { invoiceId: string },
    data: { ignored: boolean },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; invoiceId: string; xeroSyncStatus: string }, any>({
      path: `/invoices/${invoiceId}/sync-ignored`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Read the currently active billing state (defaults to 'QLD').
   * @tags dbtn/module:price_books, dbtn/hasAuth
   * @name get_billing_state
   * @request GET:/price-books/billing-state/current
   */
  get_billing_state = (params: RequestParams = {}) =>
    this.request<{ state: string; supported: string[] }, any>({
      path: `/price-books/billing-state/current`,
      method: "GET",
      ...params,
    });

  /**
   * @description Apply a state's NDIS price ceilings to every PriceBookEntry.price (uses the per-entry `state_pricing` archive populated by the NDIS importer).
   * @tags dbtn/module:price_books, dbtn/hasAuth
   * @name apply_billing_state
   * @request POST:/price-books/billing-state/apply
   */
  apply_billing_state = (data: { state: string }, params: RequestParams = {}) =>
    this.request<
      {
        state: string;
        price_books_scanned: number;
        price_books_updated: number;
        periods_updated: number;
        periods_missing_state: number;
      },
      any
    >({
      path: `/price-books/billing-state/apply`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Find groups of duplicate price books (any shared period billing code).
   * @tags dbtn/module:price_books, dbtn/hasAuth
   * @name find_duplicate_price_books
   * @request GET:/price-books/duplicates
   */
  find_duplicate_price_books = (params: RequestParams = {}) =>
    this.request<
      {
        groups: Array<{
          shared_codes: string[];
          price_book_ids: string[];
          suggested_keeper_id: string;
        }>;
      },
      any
    >({
      path: `/price-books/duplicates/list`,
      method: "GET",
      ...params,
    });

  /**
   * @description Merge price books — re-points service + km_rate references, then hard-deletes the losers.
   * @tags dbtn/module:price_books, dbtn/hasAuth
   * @name merge_price_books
   * @request POST:/price-books/merge
   */
  merge_price_books = (
    data: { keeper_id: string; loser_ids: string[] },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        keeper_id: string;
        losers_deleted: number;
        services_repointed: number;
        catalog_entries_repointed: number;
      },
      any
    >({
      path: `/price-books/duplicates/merge`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  refresh_state_pricing = (
    data: {
      updates: Array<{
        billing_code: string;
        state_pricing: Record<string, number>;
        replicate?: boolean;
        price?: number;
        billing_description?: string;
      }>;
      dry_run?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        matched: number;
        not_found: string[];
        price_books_updated: number;
        state_only_updates: number;
        replication_updates: number;
        dry_run: boolean;
      },
      any
    >({
      path: `/price-books/state-pricing/refresh`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Bulk-replace stale price-book IDs on every appointment + staffattendance with the parent service's defaults. Use this after the merge tool deletes a duplicate book.
   * @tags dbtn/module:price_books, dbtn/hasAuth
   * @name backfill_stale_price_book_references
   * @request POST:/price-books/backfill-stale-references
   */
  backfill_stale_price_book_references = (
    data: { dry_run?: boolean; phase?: 'appointments' | 'sa'; cursor?: string | null; batch_size?: number },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        phase: string;
        next_cursor: string | null;
        done: boolean;
        appointments_scanned: number;
        appointments_patched: number;
        sa_scanned: number;
        sa_patched: number;
        total_stale_refs_replaced: number;
        appointments_with_no_default: number;
        sa_with_no_default: number;
        appointments_with_no_service: number;
        dry_run: boolean;
      },
      any
    >({
      path: `/price-books/backfill-stale-references`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Reverse an unsynced invoice. Voids the invoice and flips every linked billingRecord back to 'approved' status. Refuses if the invoice has already been synced to Xero.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name reverse_invoice
   * @summary Reverse Invoice
   * @request POST:/routes/invoices/{invoice_id}/reverse
   */
  reverse_invoice = (
    { invoiceId }: { invoiceId: string },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; invoiceId: string; billingRecordsRestored: number }, any>({
      path: `/invoices/${invoiceId}/reverse`,
      method: "POST",
      ...params,
    });

  /**
   * @description Reverse shift/billing approval for selected clients × period × optional billingContactType. Deletes approved billingRecords and clears the linked staffattendance approval state so the shifts bounce back to the Shift Approval queue.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name reverse_billing_approval
   * @summary Reverse Billing Approval
   * @request POST:/routes/invoices/reverse-approval
   */
  reverse_billing_approval = (
    data: {
      clientIds?: string[];
      periodStart: string;
      periodEnd: string;
      billingContactType?: "main" | "secondary";
      appointmentIds?: string[];
      staffAttendanceIds?: string[];
      /** Required latch for UNSCOPED period-wide reversals. */
      confirmReverseAll?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; billingRecordsDeleted: number; staffAttendanceCleared: number }, any>({
      path: `/invoices/reverse-approval`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Nuclear admin recovery: clear approval data on every staffattendance doc.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name wipe_all_staff_approvals
   * @summary Wipe All Staff Approvals
   * @request POST:/routes/invoices/wipe-all-staff-approvals
   */
  wipe_all_staff_approvals = (params: RequestParams = {}) =>
    this.request<{ success: boolean; staffAttendanceCleared: number; staffAttendanceScanned: number }, any>({
      path: `/invoices/wipe-all-staff-approvals`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get summary of invoices for a period.
   *
   * @tags dbtn/module:invoices, dbtn/hasAuth
   * @name get_invoice_summary
   * @summary Get Invoice Summary
   * @request GET:/routes/invoices/summary/period
   */
  get_invoice_summary = (query: GetInvoiceSummaryParams, params: RequestParams = {}) =>
    this.request<GetInvoiceSummaryData, GetInvoiceSummaryError>({
      path: `/invoices/summary/period`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Manually overrides the clock-in or clock-out time for a travel segment. The travel_segment_id is the document ID in the staffattendance collection.
   *
   * @tags Travel, dbtn/module:travel_time_override, dbtn/hasAuth
   * @name manual_travel_time_override
   * @summary Manual Travel Time Override
   * @request POST:/routes/travel/segments/{travel_segment_id}/manual-time-override
   */
  manual_travel_time_override = (
    { travelSegmentId, ...query }: ManualTravelTimeOverrideParams,
    data: TravelTimeOverrideRequest,
    params: RequestParams = {},
  ) =>
    this.request<ManualTravelTimeOverrideData, ManualTravelTimeOverrideError>({
      path: `/travel/segments/${travelSegmentId}/manual-time-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update vehicle assignment for a travel segment. This updates the vehicleId and vehicleLicensePlate fields on a staffattendance record.
   *
   * @tags Travel, dbtn/module:travel_vehicle_update, dbtn/hasAuth
   * @name update_travel_vehicle
   * @summary Update Travel Vehicle
   * @request POST:/routes/travel-vehicle/update
   */
  update_travel_vehicle = (data: UpdateTravelVehicleRequest, params: RequestParams = {}) =>
    this.request<UpdateTravelVehicleData, UpdateTravelVehicleError>({
      path: `/travel-vehicle/update`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check for shifts that are still active 3+ hours past their scheduled end time. Send notifications to staff who are still clocked in. This endpoint should be called periodically (e.g., every hour) by a scheduled job.
   *
   * @tags dbtn/module:active_shift_monitoring, dbtn/hasAuth
   * @name check_active_shifts
   * @summary Check Active Shifts
   * @request POST:/routes/check-active-shifts
   */
  check_active_shifts = (params: RequestParams = {}) =>
    this.request<CheckActiveShiftsData, any>({
      path: `/routes/check-active-shifts`,
      method: "POST",
      ...params,
    });

  /**
   * @description Retrieves all change log history for appointments, with pagination.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name list_all_appointment_logs
   * @summary List All Appointment Logs
   * @request GET:/routes/admin/logs/appointments/all
   */
  list_all_appointment_logs = (query: ListAllAppointmentLogsParams, params: RequestParams = {}) =>
    this.request<ListAllAppointmentLogsData, ListAllAppointmentLogsError>({
      path: `/admin/logs/appointments/all`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Retrieves the change log history for a specific Firestore document.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name get_document_logs
   * @summary Get Document Logs
   * @request GET:/routes/admin/logs/{document_id}
   */
  get_document_logs = ({ documentId, ...query }: GetDocumentLogsParams, params: RequestParams = {}) =>
    this.request<GetDocumentLogsData, GetDocumentLogsError>({
      path: `/admin/logs/${documentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Lists all appointment requests with status 'requested', 'pending', or 'needs rescheduling'.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name list_pending_appointments
   * @summary List Pending Appointments
   * @request GET:/routes/admin/pending-appointments
   */
  list_pending_appointments = (params: RequestParams = {}) =>
    this.request<ListPendingAppointmentsData, any>({
      path: `/admin/pending-appointments`,
      method: "GET",
      ...params,
    });

  /**
   * @description Updates the status and related details of an appointment request.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name update_appointment_status
   * @summary Update Appointment Status
   * @request PUT:/routes/admin/appointments/{request_id}/status
   */
  update_appointment_status = (
    { requestId, ...query }: UpdateAppointmentStatusParams,
    data: AppApisAdminActionsAppointmentUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateAppointmentStatusData, UpdateAppointmentStatusError>({
      path: `/admin/appointments/${requestId}/status`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Audit appointments for data consistency issues. Identifies appointments with status 'scheduled' but no staff assigned.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name audit_appointment_consistency
   * @summary Audit Appointment Consistency
   * @request GET:/routes/admin/data/audit-appointment-consistency
   */
  audit_appointment_consistency = (params: RequestParams = {}) =>
    this.request<AuditAppointmentConsistencyData, any>({
      path: `/admin/data/audit-appointment-consistency`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fix appointments with status 'scheduled' but no staff assigned. Updates their status to 'accepted' to maintain data consistency.
   *
   * @tags Admin Actions, dbtn/module:admin_actions, dbtn/hasAuth
   * @name fix_appointment_consistency
   * @summary Fix Appointment Consistency
   * @request POST:/routes/admin/data/fix-appointment-consistency
   */
  fix_appointment_consistency = (params: RequestParams = {}) =>
    this.request<FixAppointmentConsistencyData, any>({
      path: `/admin/data/fix-appointment-consistency`,
      method: "POST",
      ...params,
    });

  /**
   * @description Soft delete an appointment and all related records. This will mark the appointment as deleted instead of permanently removing it, as well as related records from logs and appointment_notes collections. Appointments with status 'active' or 'completed' cannot be deleted.
   *
   * @tags Appointment Actions, dbtn/module:appointment_actions, dbtn/hasAuth
   * @name delete_appointment
   * @summary Delete Appointment
   * @request DELETE:/routes/appointments/{appointment_id}
   */
  delete_appointment = ({ appointmentId, ...query }: DeleteAppointmentParams, params: RequestParams = {}) =>
    this.request<DeleteAppointmentData, DeleteAppointmentError>({
      path: `/appointments/${appointmentId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * No description
   *
   * @tags Appointment Actions, dbtn/module:appointment_actions, dbtn/hasAuth
   * @name mark_appointment_completed
   * @summary Mark Appointment Completed
   * @request POST:/routes/appointments/{appointment_id}/mark-completed
   */
  mark_appointment_completed = (
    { appointmentId, ...query }: MarkAppointmentCompletedParams,
    params: RequestParams = {},
  ) =>
    this.request<MarkAppointmentCompletedData, MarkAppointmentCompletedError>({
      path: `/appointments/${appointmentId}/mark-completed`,
      method: "POST",
      ...params,
    });

  /**
   * @description Duplicates an existing appointment.
   *
   * @tags Appointment Actions, dbtn/module:appointment_actions, dbtn/hasAuth
   * @name duplicate_appointment
   * @summary Duplicate Appointment
   * @request POST:/routes/appointments/duplicate
   */
  duplicate_appointment = (data: DuplicateAppointmentRequest, params: RequestParams = {}) =>
    this.request<DuplicateAppointmentData, DuplicateAppointmentError>({
      path: `/appointments/duplicate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Duplicates an existing appointment and creates a series of recurring appointments using RepeatConfiguration. This uses the same comprehensive repeat system as the AddAppointment functionality.
   *
   * @tags Appointment Actions, dbtn/module:appointment_actions, dbtn/hasAuth
   * @name duplicate_appointment_with_series
   * @summary Duplicate Appointment With Series
   * @request POST:/routes/appointments/duplicate-series
   */
  duplicate_appointment_with_series = (data: DuplicateAppointmentWithSeriesRequest, params: RequestParams = {}) =>
    this.request<DuplicateAppointmentWithSeriesData, DuplicateAppointmentWithSeriesError>({
      path: `/appointments/duplicate-series`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get allowances for all staff members from staffattendance collection
   *
   * @tags dbtn/module:appointment_allowances, dbtn/hasAuth
   * @name get_staff_allowances
   * @summary Get Staff Allowances
   * @request GET:/routes/appointments/{appointment_id}/staff-allowances
   */
  get_staff_allowances = ({ appointmentId, ...query }: GetStaffAllowancesParams, params: RequestParams = {}) =>
    this.request<GetStaffAllowancesData, GetStaffAllowancesError>({
      path: `/appointments/${appointmentId}/staff-allowances`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update allowances for a specific staff member in staffattendance collection
   *
   * @tags dbtn/module:appointment_allowances, dbtn/hasAuth
   * @name update_staff_allowances
   * @summary Update Staff Allowances
   * @request PUT:/routes/appointments/{appointment_id}/staff-allowances
   */
  update_staff_allowances = (
    { appointmentId, ...query }: UpdateStaffAllowancesParams,
    data: UpdateStaffAllowancesRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateStaffAllowancesData, UpdateStaffAllowancesError>({
      path: `/appointments/${appointmentId}/staff-allowances`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Quick endpoint for staff to update just their mileage allowance
   *
   * @tags dbtn/module:appointment_allowances, dbtn/hasAuth
   * @name update_staff_mileage
   * @summary Update Staff Mileage
   * @request POST:/routes/appointments/{appointment_id}/staff-allowances/mileage
   */
  update_staff_mileage = (
    { appointmentId, ...query }: UpdateStaffMileageParams,
    data: UpdateMileageRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateStaffMileageData, UpdateStaffMileageError>({
      path: `/appointments/${appointmentId}/staff-allowances/mileage`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get allowances for multiple appointments in one API call
   *
   * @tags dbtn/module:appointment_allowances, dbtn/hasAuth
   * @name get_batch_allowances
   * @summary Get Batch Allowances
   * @request POST:/routes/appointments/batch-allowances
   */
  get_batch_allowances = (data: BatchAllowancesRequest, params: RequestParams = {}) =>
    this.request<GetBatchAllowancesData, GetBatchAllowancesError>({
      path: `/appointments/batch-allowances`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Count pending invitations from the invitedStaff array in all appointments. Returns total count of pending invitations and number of appointments with pending invitations.
   *
   * @tags Appointment Invitations, dbtn/module:appointment_invitations_count, dbtn/hasAuth
   * @name count_pending_invitations
   * @summary Count Pending Invitations
   * @request GET:/routes/appointment-invitations/pending-count
   */
  count_pending_invitations = (params: RequestParams = {}) =>
    this.request<CountPendingInvitationsData, any>({
      path: `/appointment-invitations/pending-count`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new task for an appointment
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name create_task
   * @summary Create Task
   * @request POST:/routes/appointment-tasks/appointments/{appointment_id}/tasks
   */
  create_task = ({ appointmentId, ...query }: CreateTaskParams, data: TaskCreateRequest, params: RequestParams = {}) =>
    this.request<CreateTaskData, CreateTaskError>({
      path: `/appointment-tasks/appointments/${appointmentId}/tasks`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all tasks for an appointment
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name list_tasks
   * @summary List Tasks
   * @request GET:/routes/appointment-tasks/appointments/{appointment_id}/tasks
   */
  list_tasks = ({ appointmentId, ...query }: ListTasksParams, params: RequestParams = {}) =>
    this.request<ListTasksData, ListTasksError>({
      path: `/appointment-tasks/appointments/${appointmentId}/tasks`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a task
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name update_task
   * @summary Update Task
   * @request PATCH:/routes/appointment-tasks/tasks/{task_id}
   */
  update_task = ({ taskId, ...query }: UpdateTaskParams, data: TaskUpdateRequest, params: RequestParams = {}) =>
    this.request<UpdateTaskData, UpdateTaskError>({
      path: `/appointment-tasks/tasks/${taskId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a task
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name delete_task
   * @summary Delete Task
   * @request DELETE:/routes/appointment-tasks/tasks/{task_id}
   */
  delete_task = ({ taskId, ...query }: DeleteTaskParams, params: RequestParams = {}) =>
    this.request<DeleteTaskData, DeleteTaskError>({
      path: `/appointment-tasks/tasks/${taskId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Toggle task completion status (convenience endpoint)
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name toggle_task_completion
   * @summary Toggle Task Completion
   * @request PATCH:/routes/appointment-tasks/tasks/{task_id}/completion
   */
  toggle_task_completion = (
    { taskId, ...query }: ToggleTaskCompletionParams,
    data: TaskCompletionRequest,
    params: RequestParams = {},
  ) =>
    this.request<ToggleTaskCompletionData, ToggleTaskCompletionError>({
      path: `/appointment-tasks/tasks/${taskId}/completion`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get count of incomplete tasks for an appointment (used for clock-out validation)
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name get_incomplete_task_count
   * @summary Get Incomplete Task Count
   * @request GET:/routes/appointment-tasks/appointments/{appointment_id}/tasks/incomplete-count
   */
  get_incomplete_task_count = ({ appointmentId, ...query }: GetIncompleteTaskCountParams, params: RequestParams = {}) =>
    this.request<GetIncompleteTaskCountData, GetIncompleteTaskCountError>({
      path: `/appointment-tasks/appointments/${appointmentId}/tasks/incomplete-count`,
      method: "GET",
      ...params,
    });


  /**
   * @description Copy the source appointment's task template to every
   * other appointment in the same series (existing tasks on targets are
   * wiped first; completion state resets per occurrence).
   *
   * @tags Appointment Tasks, dbtn/module:appointment_tasks, dbtn/hasAuth
   * @name replicate_tasks_to_series
   * @request POST:/routes/appointment-tasks/appointments/{appointment_id}/replicate-tasks-to-series
   */
  replicate_tasks_to_series = (
    { appointmentId }: { appointmentId: string },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        series_id: string;
        source_appointment_id: string;
        target_count: number;
        tasks_per_appointment: number;
        skipped: string[];
      },
      any
    >({
      path: `/appointment-tasks/appointments/${appointmentId}/replicate-tasks-to-series`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get all available abilities from Firestore.
   *
   * @tags dbtn/module:abilities, dbtn/hasAuth
   * @name list_abilities
   * @summary List Abilities
   * @request GET:/abilities
   */
  list_abilities = (params: RequestParams = {}) =>
    this.request<ListAbilitiesData, any>({
      path: `/abilities`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new ability in Firestore.
   *
   * @tags dbtn/module:abilities, dbtn/hasAuth
   * @name create_ability
   * @summary Create Ability
   * @request POST:/routes/abilities
   */
  create_ability = (data: AbilityCreateRequest, params: RequestParams = {}) =>
    this.request<CreateAbilityData, CreateAbilityError>({
      path: `/abilities`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Soft delete an ability (mark as inactive) in Firestore.
   *
   * @tags dbtn/module:abilities, dbtn/hasAuth
   * @name delete_ability
   * @summary Delete Ability
   * @request DELETE:/routes/abilities/{ability_id}
   */
  delete_ability = ({ abilityId, ...query }: DeleteAbilityParams, params: RequestParams = {}) =>
    this.request<DeleteAbilityData, DeleteAbilityError>({
      path: `/abilities/${abilityId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Manually trigger calendar sync for all users (admin only)
   *
   * @tags dbtn/module:sync_scheduler, dbtn/hasAuth
   * @name trigger_manual_sync
   * @summary Trigger Manual Sync
   * @request POST:/google-calendar/trigger-sync
   */
  trigger_manual_sync = (params: RequestParams = {}) =>
    this.request<TriggerManualSyncData, any>({
      path: `/google-calendar/trigger-sync`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get status of automatic sync system
   *
   * @tags dbtn/module:sync_scheduler, dbtn/hasAuth
   * @name get_sync_status
   * @summary Get Sync Status
   * @request GET:/routes/routes/sync-status
   */
  get_sync_status = (params: RequestParams = {}) =>
    this.request<GetSyncStatusData, any>({
      path: `/sync-status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get statistics about Firestore collections and cached metadata
   *
   * @tags dbtn/module:cache_management, dbtn/hasAuth
   * @name get_cache_stats
   * @summary Get Cache Stats
   * @request GET:/routes/cache/stats
   */
  get_cache_stats = (params: RequestParams = {}) =>
    this.request<GetCacheStatsData, any>({
      path: `/cache/stats`,
      method: "GET",
      ...params,
    });

  /**
   * @description Clear specific cached metadata from Firestore
   *
   * @tags dbtn/module:cache_management, dbtn/hasAuth
   * @name clear_cache
   * @summary Clear Cache
   * @request POST:/routes/cache/clear
   */
  clear_cache = (data: ClearCacheRequest, params: RequestParams = {}) =>
    this.request<ClearCacheData, ClearCacheError>({
      path: `/cache/clear`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Endpoint to signal browser cache invalidation
   *
   * @tags dbtn/module:cache_management, dbtn/hasAuth
   * @name invalidate_browser_cache
   * @summary Invalidate Browser Cache
   * @request POST:/routes/cache/invalidate-browser
   */
  invalidate_browser_cache = (params: RequestParams = {}) =>
    this.request<InvalidateBrowserCacheData, any>({
      path: `/cache/invalidate-browser`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get browser cache invalidation status
   *
   * @tags dbtn/module:cache_management, dbtn/hasAuth
   * @name get_browser_cache_status
   * @summary Get Browser Cache Status
   * @request GET:/routes/cache/browser-status
   */
  get_browser_cache_status = (params: RequestParams = {}) =>
    this.request<GetBrowserCacheStatusData, any>({
      path: `/cache/browser-status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Adds a new ID document/qualification to a client.
   *
   * @tags Client Qualifications, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name create_client_qualification
   * @summary Create Client Qualification
   * @request POST:/routes/client-qualifications/{client_id}
   */
  create_client_qualification = (
    { clientId, ...query }: CreateClientQualificationParams,
    data: ClientQualificationCreate,
    params: RequestParams = {},
  ) =>
    this.request<CreateClientQualificationData, CreateClientQualificationError>({
      path: `/client-qualifications/${clientId}/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Lists all ID documents/qualifications for a specific client.
   *
   * @tags Client Qualifications, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name list_client_qualifications
   * @summary List Client Qualifications
   * @request GET:/routes/client-qualifications/{client_id}
   */
  list_client_qualifications = ({ clientId, ...query }: ListClientQualificationsParams, params: RequestParams = {}) =>
    this.request<ListClientQualificationsData, ListClientQualificationsError>({
      path: `/client-qualifications/${clientId}/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Updates an existing ID document/qualification for a client.
   *
   * @tags Client Qualifications, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name update_client_qualification
   * @summary Update Client Qualification
   * @request PUT:/routes/client-qualifications/{client_id}/{qualification_id}
   */
  update_client_qualification = (
    { clientId, qualificationId, ...query }: UpdateClientQualificationParams,
    data: ClientQualificationUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateClientQualificationData, UpdateClientQualificationError>({
      path: `/client-qualifications/${clientId}/${qualificationId}/`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Deletes a specific ID document/qualification for a client.
   *
   * @tags Client Qualifications, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name delete_client_qualification
   * @summary Delete Client Qualification
   * @request DELETE:/routes/client-qualifications/{client_id}/{qualification_id}
   */
  delete_client_qualification = (
    { clientId, qualificationId, ...query }: DeleteClientQualificationParams,
    params: RequestParams = {},
  ) =>
    this.request<DeleteClientQualificationData, DeleteClientQualificationError>({
      path: `/client-qualifications/${clientId}/${qualificationId}/`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Uploads an image for a client qualification and returns its public Firebase Storage URL.
   *
   * @tags Client Qualifications, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name upload_client_qualification_image
   * @summary Upload Client Qualification Image
   * @request POST:/routes/client-qualifications/{client_id}/image-upload
   */
  upload_client_qualification_image = (
    { clientId, ...query }: UploadClientQualificationImageParams,
    data: BodyUploadClientQualificationImage,
    params: RequestParams = {},
  ) =>
    this.request<UploadClientQualificationImageData, UploadClientQualificationImageError>({
      path: `/client-qualifications/${clientId}/image-upload/`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Serves a client qualification image - supports both legacy db.storage.keys and Firebase Storage URLs.
   *
   * @tags Client Qualifications, stream, dbtn/module:client_qualifications, dbtn/hasAuth
   * @name get_client_qualification_image
   * @summary Get Client Qualification Image
   * @request GET:/routes/client-qualifications/image/{image_key}
   */
  get_client_qualification_image = (
    { imageKey, ...query }: GetClientQualificationImageParams,
    params: RequestParams = {},
  ) =>
    this.requestStream<GetClientQualificationImageData, GetClientQualificationImageError>({
      path: `/client-qualifications/image/${imageKey}/`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name ping_test_staff_qual
   * @summary Ping Test Staff Qual
   * @request GET:/routes/routes/staff/ping-test-staff-qual
   */
  ping_test_staff_qual = (params: RequestParams = {}) =>
    this.request<PingTestStaffQualData, any>({
      path: `/staff/ping-test-staff-qual`,
      method: "GET",
      ...params,
    });

  /**
   * @description Creates a new staff or admin user in Firebase Auth and Firestore. Requires the calling user to have the 'admin' role.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name create_staff
   * @summary Create Staff
   * @request POST:/routes/staff/create-staff
   */
  create_staff = (data: CreateStaffRequest, params: RequestParams = {}) =>
    this.request<CreateStaffData, CreateStaffError>({
      path: `/routes/staff/create-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Updates details for an existing staff or admin user. Requires the calling user to have the 'admin' role.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name update_staff
   * @summary Update Staff
   * @request PUT:/routes/routes/staff/{staff_id}
   */
  update_staff = ({ staffId, ...query }: UpdateStaffParams, data: StaffUpdateOptional, params: RequestParams = {}) =>
    this.request<UpdateStaffData, UpdateStaffError>({
      path: `/routes/staff/${staffId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetches a list of users with 'staff' or 'admin' roles and specific employment types for the timesheet approval screen. Requires the calling user to have the 'admin' role.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name list_staff_for_timesheet
   * @summary List Staff For Timesheet
   * @request GET:/routes/routes/staff/list-for-timesheet
   */
  list_staff_for_timesheet = (params: RequestParams = {}) =>
    this.request<ListStaffForTimesheetData, any>({
      path: `/routes/staff/list-for-timesheet`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetches a list of users with 'staff' or 'admin' roles. Requires the calling user to have the 'admin' role.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name list_staff_members
   * @summary List Staff Members
   * @request GET:/routes/routes/staff/members
   */
  list_staff_members = (params: RequestParams = {}) =>
    this.request<ListStaffMembersData, any>({
      path: `/routes/staff/members`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name internal_ping_staff_test_func
   * @summary Internal Ping Staff Test Func
   * @request POST:/routes/routes/staff/_internal_ping_staff_test
   */
  internal_ping_staff_test_func = (data: PingRequest, params: RequestParams = {}) =>
    this.request<InternalPingStaffTestFuncData, InternalPingStaffTestFuncError>({
      path: `/staff/_internal_ping_staff_test`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Sets the visibility (isActive status) for a staff or admin user. Requires the calling user to have the 'admin' role.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name set_staff_visibility
   * @summary Set Staff Visibility
   * @request POST:/routes/routes/staff/{staff_id}/set-visibility
   */
  set_staff_visibility = (
    { staffId, ...query }: SetStaffVisibilityParams,
    data: SetVisibilityRequest,
    params: RequestParams = {},
  ) =>
    this.request<SetStaffVisibilityData, SetStaffVisibilityError>({
      path: `/staff/${staffId}/set-visibility`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Deletes a specific qualification for a staff member.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name delete_staff_qualification
   * @summary Delete Staff Qualification
   * @request DELETE:/routes/routes/staff/{staff_id}/qualifications/{qualification_id}
   */
  delete_staff_qualification = (
    { staffId, qualificationId, ...query }: DeleteStaffQualificationParams,
    params: RequestParams = {},
  ) =>
    this.request<DeleteStaffQualificationData, DeleteStaffQualificationError>({
      path: `/routes/staff/${staffId}/qualifications/${qualificationId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Updates an existing qualification for a staff member.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name update_staff_qualification
   * @summary Update Staff Qualification
   * @request PUT:/routes/routes/staff/{staff_id}/qualifications/{qualification_id}
   */
  update_staff_qualification = (
    { staffId, qualificationId, ...query }: UpdateStaffQualificationParams,
    data: QualificationUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateStaffQualificationData, UpdateStaffQualificationError>({
      path: `/routes/staff/${staffId}/qualifications/${qualificationId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Adds a new qualification to a staff member.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name create_staff_qualification
   * @summary Create Staff Qualification
   * @request POST:/routes/routes/staff/{staff_id}/qualifications
   */
  create_staff_qualification = (
    { staffId, ...query }: CreateStaffQualificationParams,
    data: QualificationCreate,
    params: RequestParams = {},
  ) =>
    this.request<CreateStaffQualificationData, CreateStaffQualificationError>({
      path: `/routes/staff/${staffId}/qualifications`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Lists all qualifications for a specific staff member.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name list_staff_qualifications
   * @summary List Staff Qualifications
   * @request GET:/routes/routes/staff/{staff_id}/qualifications
   */
  list_staff_qualifications = ({ staffId, ...query }: ListStaffQualificationsParams, params: RequestParams = {}) =>
    this.request<ListStaffQualificationsData, ListStaffQualificationsError>({
      path: `/routes/staff/${staffId}/qualifications`,
      method: "GET",
      ...params,
    });

  /**
   * @description Uploads an image for a staff qualification and returns its public Firebase Storage URL.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name upload_staff_qualification_image
   * @summary Upload Staff Qualification Image
   * @request POST:/routes/routes/staff/{staff_id}/qualifications/image-upload
   */
  upload_staff_qualification_image = (
    { staffId, ...query }: UploadStaffQualificationImageParams,
    data: BodyUploadStaffQualificationImage,
    params: RequestParams = {},
  ) =>
    this.request<UploadStaffQualificationImageData, UploadStaffQualificationImageError>({
      path: `/routes/staff/${staffId}/qualifications/image-upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Serves a qualification image - supports both legacy db.storage.keys and Firebase Storage URLs.
   *
   * @tags Staff Management, stream, dbtn/module:staff_management, dbtn/hasAuth
   * @name get_qualification_image
   * @summary Get Qualification Image
   * @request GET:/routes/routes/staff/qualifications/image/{image_key}
   */
  get_qualification_image = ({ imageKey, ...query }: GetQualificationImageParams, params: RequestParams = {}) =>
    this.requestStream<GetQualificationImageData, GetQualificationImageError>({
      path: `/routes/staff/qualifications/image/${imageKey}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Uploads a profile image for a staff member to Firebase Storage.
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name upload_staff_profile_image
   * @summary Upload Staff Profile Image
   * @request POST:/routes/staff/{staff_id}/upload-profile-image
   */
  upload_staff_profile_image = (
    { staffId, ...query }: UploadStaffProfileImageParams,
    data: BodyUploadStaffProfileImage,
    params: RequestParams = {},
  ) =>
    this.request<UploadStaffProfileImageData, UploadStaffProfileImageError>({
      path: `/staff/${staffId}/upload-profile-image`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Serves a staff profile image - supports both legacy db.storage keys and Firebase Storage URLs.
   *
   * @tags Staff Management, stream, dbtn/module:staff_management, dbtn/hasAuth
   * @name get_staff_profile_image
   * @summary Get Staff Profile Image
   * @request GET:/routes/staff/profile-image/{image_key}
   */
  get_staff_profile_image = ({ imageKey, ...query }: GetStaffProfileImageParams, params: RequestParams = {}) =>
    this.requestStream<GetStaffProfileImageData, GetStaffProfileImageError>({
      path: `/staff/profile-image/${imageKey}`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags Staff Management, dbtn/module:staff_management, dbtn/hasAuth
   * @name qualifications_ping_test
   * @summary Qualifications Ping Test
   * @request GET:/routes/routes/staff/{staff_id}/qualifications/ping
   */
  qualifications_ping_test = ({ staffId, ...query }: QualificationsPingTestParams, params: RequestParams = {}) =>
    this.request<QualificationsPingTestData, QualificationsPingTestError>({
      path: `/routes/staff/${staffId}/qualifications/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Migrate all images from db.storage.binary to Firebase Storage. This will: 1. Move staff qualification images 2. Move client qualification images 3. Move staff profile images 4. Update all Firestore references with new Firebase Storage URLs
   *
   * @tags dbtn/module:image_migration, dbtn/hasAuth
   * @name migrate_all_images
   * @summary Migrate All Images
   * @request POST:/routes/migrate-images
   */
  migrate_all_images = (params: RequestParams = {}) =>
    this.request<MigrateAllImagesData, any>({
      path: `/migrate-images`,
      method: "POST",
      ...params,
    });

  /**
   * @description Preview what images will be migrated without actually migrating them.
   *
   * @tags dbtn/module:image_migration, dbtn/hasAuth
   * @name preview_migration
   * @summary Preview Migration
   * @request GET:/routes/migration-preview
   */
  preview_migration = (params: RequestParams = {}) =>
    this.request<PreviewMigrationData, any>({
      path: `/migration-preview`,
      method: "GET",
      ...params,
    });

  /**
   * @description List all support coordinators. Requires authentication.
   *
   * @tags Support Coordinators, dbtn/module:support_coordinators, dbtn/hasAuth
   * @name list_support_coordinators
   * @summary List Support Coordinators
   * @request GET:/routes/support-coordinators/
   */
  list_support_coordinators = (params: RequestParams = {}) =>
    this.request<ListSupportCoordinatorsData, any>({
      path: `/support-coordinators/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new support coordinator. Requires admin role.
   *
   * @tags Support Coordinators, dbtn/module:support_coordinators, dbtn/hasAuth
   * @name create_support_coordinator
   * @summary Create Support Coordinator
   * @request POST:/routes/support-coordinators/
   */
  create_support_coordinator = (data: SupportCoordinatorCreate, params: RequestParams = {}) =>
    this.request<CreateSupportCoordinatorData, CreateSupportCoordinatorError>({
      path: `/support-coordinators/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get a specific support coordinator by ID. Requires authentication.
   *
   * @tags Support Coordinators, dbtn/module:support_coordinators, dbtn/hasAuth
   * @name get_support_coordinator
   * @summary Get Support Coordinator
   * @request GET:/routes/support-coordinators/{coordinator_id}
   */
  get_support_coordinator = ({ coordinatorId, ...query }: GetSupportCoordinatorParams, params: RequestParams = {}) =>
    this.request<GetSupportCoordinatorData, GetSupportCoordinatorError>({
      path: `/support-coordinators/${coordinatorId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a support coordinator. Requires admin role.
   *
   * @tags Support Coordinators, dbtn/module:support_coordinators, dbtn/hasAuth
   * @name update_support_coordinator
   * @summary Update Support Coordinator
   * @request PUT:/routes/support-coordinators/{coordinator_id}
   */
  update_support_coordinator = (
    { coordinatorId, ...query }: UpdateSupportCoordinatorParams,
    data: SupportCoordinatorUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateSupportCoordinatorData, UpdateSupportCoordinatorError>({
      path: `/support-coordinators/${coordinatorId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a support coordinator. Requires admin role.
   *
   * @tags Support Coordinators, dbtn/module:support_coordinators, dbtn/hasAuth
   * @name delete_support_coordinator
   * @summary Delete Support Coordinator
   * @request DELETE:/routes/support-coordinators/{coordinator_id}
   */
  delete_support_coordinator = (
    { coordinatorId, ...query }: DeleteSupportCoordinatorParams,
    params: RequestParams = {},
  ) =>
    this.request<DeleteSupportCoordinatorData, DeleteSupportCoordinatorError>({
      path: `/support-coordinators/${coordinatorId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description List all billing contacts. Requires authentication.
   *
   * @tags Billing Contacts, dbtn/module:billing_contacts, dbtn/hasAuth
   * @name list_billing_contacts
   * @summary List Billing Contacts
   * @request GET:/routes/billing-contacts/
   */
  list_billing_contacts = (params: RequestParams = {}) =>
    this.request<ListBillingContactsData, any>({
      path: `/billing-contacts/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new billing contact. Requires admin role.
   *
   * @tags Billing Contacts, dbtn/module:billing_contacts, dbtn/hasAuth
   * @name create_billing_contact
   * @summary Create Billing Contact
   * @request POST:/routes/billing-contacts/
   */
  create_billing_contact = (data: BillingContactCreate, params: RequestParams = {}) =>
    this.request<CreateBillingContactData, CreateBillingContactError>({
      path: `/billing-contacts/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get a specific billing contact by ID. Requires authentication.
   *
   * @tags Billing Contacts, dbtn/module:billing_contacts, dbtn/hasAuth
   * @name get_billing_contact
   * @summary Get Billing Contact
   * @request GET:/routes/billing-contacts/{contact_id}
   */
  get_billing_contact = ({ contactId, ...query }: GetBillingContactParams, params: RequestParams = {}) =>
    this.request<GetBillingContactData, GetBillingContactError>({
      path: `/billing-contacts/${contactId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a billing contact. Requires admin role.
   *
   * @tags Billing Contacts, dbtn/module:billing_contacts, dbtn/hasAuth
   * @name update_billing_contact
   * @summary Update Billing Contact
   * @request PUT:/routes/billing-contacts/{contact_id}
   */
  update_billing_contact = (
    { contactId, ...query }: UpdateBillingContactParams,
    data: BillingContactUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateBillingContactData, UpdateBillingContactError>({
      path: `/billing-contacts/${contactId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a billing contact. Requires admin role.
   *
   * @tags Billing Contacts, dbtn/module:billing_contacts, dbtn/hasAuth
   * @name delete_billing_contact
   * @summary Delete Billing Contact
   * @request DELETE:/routes/billing-contacts/{contact_id}
   */
  delete_billing_contact = ({ contactId, ...query }: DeleteBillingContactParams, params: RequestParams = {}) =>
    this.request<DeleteBillingContactData, DeleteBillingContactError>({
      path: `/billing-contacts/${contactId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Fetches the display name and photo URL for a given user ID. Requires authentication.
   *
   * @tags Users, dbtn/module:users, dbtn/hasAuth
   * @name get_basic_user_details
   * @summary Get Basic User Details
   * @request GET:/users/{user_id}/basic-details
   */
  get_basic_user_details = ({ userId, ...query }: GetBasicUserDetailsParams, params: RequestParams = {}) =>
    this.request<GetBasicUserDetailsData, GetBasicUserDetailsError>({
      path: `/users/${userId}/basic-details`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetches basic profile details for multiple user IDs in one request. Coalesces N single-user lookups into ONE round-trip to avoid 429 rate limits.
   *
   * @tags Users, dbtn/module:users, dbtn/hasAuth
   * @name get_basic_user_details_batch
   * @summary Batch fetch basic user details
   * @request POST:/users/basic-details/batch
   */
  get_basic_user_details_batch = (
    data: { userIds: string[] },
    params: RequestParams = {},
  ) =>
    this.request<
      { users: Record<string, {
        name: string;
        photoURL?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        role?: string | null;
        employmentType?: string | null;
        clientId?: string | null;
        isActive?: boolean | null;
      }> },
      any
    >({
      path: `/users/basic-details/batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });


  /**
   * @description Uploads a profile image for a user to Firebase Storage and updates their photoURL.
   *
   * @tags Users, dbtn/module:users, dbtn/hasAuth
   * @name upload_user_profile_image
   * @summary Upload User Profile Image
   * @request POST:/users/{user_id}/upload-profile-image
   */
  upload_user_profile_image = (
    { userId, ...query }: { userId: string },
    data: { file: File },
    params: RequestParams = {},
  ) =>
    this.request<{ imageUrl: string }, any>({
      path: `/users/${userId}/upload-profile-image`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });


  /**
   * @description Reverse geocode coordinates to get a formatted address using Google Places API.
   *
   * @tags dbtn/module:geocoding, dbtn/hasAuth
   * @name reverse_geocode
   * @summary Reverse Geocode
   * @request POST:/routes/reverse-geocode
   */
  reverse_geocode = (data: ReverseGeocodeRequest, params: RequestParams = {}) =>
    this.request<ReverseGeocodeData, ReverseGeocodeError>({
      path: `/reverse-geocode`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Start Google Calendar OAuth flow - No authentication required
   *
   * @tags dbtn/module:google_oauth_unprotected
   * @name start_auth_unprotected
   * @summary Start Auth Unprotected
   * @request POST:/routes/start-auth
   */
  start_auth_unprotected = (params: RequestParams = {}) =>
    this.request<StartAuthUnprotectedData, any>({
      path: `/start-auth`,
      method: "POST",
      ...params,
    });

  /**
   * @description Handle OAuth callback from Google - No authentication required
   *
   * @tags dbtn/module:google_oauth_unprotected
   * @name handle_oauth_callback
   * @summary Handle Oauth Callback
   * @request GET:/routes/oauth2callback
   */
  handle_oauth_callback = (query: HandleOauthCallbackParams, params: RequestParams = {}) =>
    this.request<HandleOauthCallbackData, HandleOauthCallbackError>({
      path: `/oauth2callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get current OAuth configuration for debugging
   *
   * @tags dbtn/module:google_calendar
   * @name get_oauth_config
   * @summary Get Oauth Config
   * @request GET:/routes/google-calendar/oauth-config
   */
  get_oauth_config = (params: RequestParams = {}) =>
    this.request<GetOauthConfigData, any>({
      path: `/google-calendar/oauth-config`,
      method: "GET",
      ...params,
    });

  /**
   * @description Start the OAuth flow for Google Calendar
   *
   * @tags dbtn/module:google_calendar
   * @name start_auth
   * @summary Start Auth
   * @request POST:/routes/google-calendar/start-auth
   */
  start_auth = (params: RequestParams = {}) =>
    this.request<StartAuthData, any>({
      path: `/google-calendar/start-auth`,
      method: "POST",
      ...params,
    });

  /**
   * @description Handle OAuth2 callback from Google
   *
   * @tags dbtn/module:google_calendar
   * @name oauth2_callback
   * @summary Oauth2 Callback
   * @request GET:/routes/google-calendar/oauth2callback
   */
  oauth2_callback = (params: RequestParams = {}) =>
    this.request<Oauth2CallbackData, any>({
      path: `/google-calendar/oauth2callback`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get the current Google Calendar connection status
   *
   * @tags dbtn/module:google_calendar
   * @name get_calendar_status
   * @summary Get Calendar Status
   * @request GET:/routes/google-calendar/status
   */
  get_calendar_status = (params: RequestParams = {}) =>
    this.request<GetCalendarStatusData, any>({
      path: `/google-calendar/status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Sync calendar events from Google Calendar and create TIL leave requests
   *
   * @tags dbtn/module:google_calendar
   * @name sync_calendar
   * @summary Sync Calendar
   * @request POST:/routes/google-calendar/sync
   */
  sync_calendar = (params: RequestParams = {}) =>
    this.request<SyncCalendarData, any>({
      path: `/google-calendar/sync`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get synced calendar events
   *
   * @tags dbtn/module:google_calendar
   * @name get_synced_events
   * @summary Get Synced Events
   * @request GET:/routes/google-calendar/events
   */
  get_synced_events = (params: RequestParams = {}) =>
    this.request<GetSyncedEventsData, any>({
      path: `/google-calendar/events`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get list of processed/ignored event IDs
   *
   * @tags dbtn/module:google_calendar
   * @name get_processed_events
   * @summary Get Processed Events
   * @request GET:/routes/google-calendar/processed-events
   */
  get_processed_events = (params: RequestParams = {}) =>
    this.request<GetProcessedEventsData, any>({
      path: `/google-calendar/processed-events`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get count of pending Google Calendar events that need TIL review
   *
   * @tags dbtn/module:google_calendar
   * @name get_pending_til_count
   * @summary Get Pending Til Count
   * @request GET:/routes/google-calendar/pending-til-count
   */
  get_pending_til_count = (params: RequestParams = {}) =>
    this.request<GetPendingTilCountData, any>({
      path: `/google-calendar/pending-til-count`,
      method: "GET",
      ...params,
    });

  /**
   * @description Mark a calendar event as processed/ignored
   *
   * @tags dbtn/module:google_calendar
   * @name mark_event_processed
   * @summary Mark Event Processed
   * @request POST:/routes/google-calendar/mark-event-processed
   */
  mark_event_processed = (data: MarkEventProcessedPayload, params: RequestParams = {}) =>
    this.request<MarkEventProcessedData, MarkEventProcessedError>({
      path: `/google-calendar/mark-event-processed`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Auto-mark calendar events that have matching TIL requests as processed
   *
   * @tags dbtn/module:google_calendar
   * @name cleanup_processed_events
   * @summary Cleanup Processed Events
   * @request POST:/routes/google-calendar/cleanup-processed-events
   */
  cleanup_processed_events = (params: RequestParams = {}) =>
    this.request<CleanupProcessedEventsData, any>({
      path: `/google-calendar/cleanup-processed-events`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get calendar events for multiple staff members in one call (bulk fetch optimization)
   *
   * @tags dbtn/module:google_calendar
   * @name get_bulk_staff_calendar_events
   * @summary Get Bulk Staff Calendar Events
   * @request GET:/routes/google-calendar/events/bulk
   */
  get_bulk_staff_calendar_events = (query: GetBulkStaffCalendarEventsParams, params: RequestParams = {}) =>
    this.request<GetBulkStaffCalendarEventsData, GetBulkStaffCalendarEventsError>({
      path: `/google-calendar/events/bulk`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get calendar events for a specific staff member with optional date filtering
   *
   * @tags dbtn/module:google_calendar
   * @name get_staff_calendar_events
   * @summary Get Staff Calendar Events
   * @request GET:/routes/google-calendar/events/{staff_id}
   */
  get_staff_calendar_events = ({ staffId, ...query }: GetStaffCalendarEventsParams, params: RequestParams = {}) =>
    this.request<GetStaffCalendarEventsData, GetStaffCalendarEventsError>({
      path: `/google-calendar/events/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Disconnect Google Calendar
   *
   * @tags dbtn/module:google_calendar
   * @name disconnect_calendar
   * @summary Disconnect Calendar
   * @request POST:/routes/google-calendar/disconnect
   */
  disconnect_calendar = (params: RequestParams = {}) =>
    this.request<DisconnectCalendarData, any>({
      path: `/google-calendar/disconnect`,
      method: "POST",
      ...params,
    });

  /**
   * @description Start a background task to sync Google Calendar
   *
   * @tags dbtn/module:google_calendar
   * @name sync_background
   * @summary Sync Background
   * @request POST:/routes/google-calendar/sync-background
   */
  sync_background = (params: RequestParams = {}) =>
    this.request<SyncBackgroundData, any>({
      path: `/google-calendar/sync-background`,
      method: "POST",
      ...params,
    });

  /**
   * @description Cancel a background task to sync Google Calendar
   *
   * @tags dbtn/module:google_calendar
   * @name sync_background_cancel
   * @summary Sync Background Cancel
   * @request POST:/routes/google-calendar/sync-background-cancel
   */
  sync_background_cancel = (params: RequestParams = {}) =>
    this.request<SyncBackgroundCancelData, any>({
      path: `/google-calendar/sync-background-cancel`,
      method: "POST",
      ...params,
    });

  /**
   * @description Start the automatic Google Calendar sync as a background task
   *
   * @tags dbtn/module:google_calendar
   * @name start_background_sync
   * @summary Start Background Sync
   * @request POST:/routes/google-calendar/start-auto-sync
   */
  start_background_sync = (params: RequestParams = {}) =>
    this.request<StartBackgroundSyncData, any>({
      path: `/google-calendar/start-auto-sync`,
      method: "POST",
      ...params,
    });

  /**
   * @description Stop the running automatic Google Calendar sync
   *
   * @tags dbtn/module:google_calendar
   * @name stop_background_sync
   * @summary Stop Background Sync
   * @request POST:/routes/google-calendar/stop-auto-sync
   */
  stop_background_sync = (params: RequestParams = {}) =>
    this.request<StopBackgroundSyncData, any>({
      path: `/google-calendar/stop-auto-sync`,
      method: "POST",
      ...params,
    });

  /**
   * @description Check the status of the automatic Google Calendar sync
   *
   * @tags dbtn/module:google_calendar
   * @name get_auto_sync_status
   * @summary Get Auto Sync Status
   * @request GET:/routes/google-calendar/auto-sync-status
   */
  get_auto_sync_status = (params: RequestParams = {}) =>
    this.request<GetAutoSyncStatusData, any>({
      path: `/google-calendar/auto-sync-status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get lightweight diary data with only essential fields for diary views. Now includes journey data to eliminate separate API calls. OPTIMIZED: Consolidated queries and parallel execution for better performance.
   *
   * @tags dbtn/module:diary_lightweight, dbtn/hasAuth
   * @name get_lightweight_diary_data
   * @summary Get Lightweight Diary Data
   * @request GET:/diary-lightweight
   */
  get_lightweight_diary_data = (query: GetLightweightDiaryDataParams, params: RequestParams = {}) =>
    this.request<GetLightweightDiaryDataData, GetLightweightDiaryDataError>({
      path: `/diary-lightweight`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get journey data for diary display. Returns journey blocks that can be displayed in the diary view alongside regular appointments, with proper vehicle/driver assignment for column placement.
   *
   * @tags dbtn/module:diary_journeys, dbtn/hasAuth
   * @name get_diary_journey_data
   * @summary Get Diary Journey Data
   * @request GET:/routes/diary-journeys/diary-data
   */
  get_diary_journey_data = (query: GetDiaryJourneyDataParams, params: RequestParams = {}) =>
    this.request<GetDiaryJourneyDataData, GetDiaryJourneyDataError>({
      path: `/diary-journeys/diary-data`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Single unified endpoint for all diary data - fast and consistent
   *
   * @tags dbtn/module:diary, dbtn/hasAuth
   * @name get_daily_diary_data
   * @summary Get Daily Diary Data
   * @request GET:/routes/diary/daily
   */
  get_daily_diary_data = (query: GetDailyDiaryDataParams, params: RequestParams = {}) =>
    this.request<GetDailyDiaryDataData, GetDailyDiaryDataError>({
      path: `/diary/daily`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Generate payroll entries from workingHours (permanent staff) and staffAttendance (casual + overtime) for a fortnight. Stores DAILY BREAKDOWN of hours, mileage, and allowances for direct Xero mapping. Data Sources: - Permanent (full_time/part_time): workingHours collection for base hours - Casual: staffAttendance.regular_hours_worked for base hours - All staff: staffAttendance where overtime_choice === 'overtime_pay' for overtime Critical: Staff are ALWAYS paid their scheduled hours, regardless of TIL earned/used. Only overtime chosen as "Pay" gets included at premium rates.
   *
   * @tags dbtn/module:payroll_entries, dbtn/hasAuth
   * @name generate_payroll_entries
   * @summary Generate Payroll Entries
   * @request POST:/generate-entries
   */
  generate_payroll_entries = (data: BulkGenerateRequest, params: RequestParams = {}) =>
    this.request<GeneratePayrollEntriesData, GeneratePayrollEntriesError>({
      path: `/generate-entries`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Save a payroll entry for a staff member for a specific fortnight period. Creates one record in the payrollEntries collection.
   *
   * @tags dbtn/module:payroll_entries, dbtn/hasAuth
   * @name generate_payroll_entry
   * @summary Generate Payroll Entry
   * @request POST:/routes/generate-entry
   */
  generate_payroll_entry = (data: PayrollEntryRequest, params: RequestParams = {}) =>
    this.request<GeneratePayrollEntryData, GeneratePayrollEntryError>({
      path: `/generate-entry`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetch all payroll entries for a specific fortnight. Query by fortnightStart field.
   *
   * @tags dbtn/module:payroll_entries, dbtn/hasAuth
   * @name list_payroll_entries
   * @summary List Payroll Entries
   * @request GET:/list
   */
  list_payroll_entries = (query: ListPayrollEntriesParams, params: RequestParams = {}) =>
    this.request<ListPayrollEntriesData, ListPayrollEntriesError>({
      path: `/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Approve attendance entry with specific start and end times
   *
   * @tags dbtn/module:attendance_approval, dbtn/hasAuth
   * @name approve_attendance_times
   * @summary Approve Attendance Times
   * @request POST:/approve-attendance-times
   */
  approve_attendance_times = (data: AttendanceApprovalRequest, params: RequestParams = {}) =>
    this.request<ApproveAttendanceTimesData, ApproveAttendanceTimesError>({
      path: `/approve-attendance-times`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Simple approve/decline attendance entry using clock times
   *
   * @tags dbtn/module:attendance_approval, dbtn/hasAuth
   * @name simple_approve_attendance
   * @summary Simple Approve Attendance
   * @request POST:/simple-approve-attendance
   */
  simple_approve_attendance = (data: SimpleApprovalRequest, params: RequestParams = {}) =>
    this.request<SimpleApproveAttendanceData, SimpleApproveAttendanceError>({
      path: `/simple-approve-attendance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Health check endpoint
   *
   * @tags dbtn/module:attendance_approval, dbtn/hasAuth
   * @name ping_attendance_approval
   * @summary Ping Attendance Approval
   * @request GET:/routes/ping
   */
  ping_attendance_approval = (params: RequestParams = {}) =>
    this.request<PingAttendanceApprovalData, any>({
      path: `/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Check if Xero is connected and return connection details
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_xero_connection_status
   * @summary Get Xero Connection Status
   * @request GET:/routes/xero/status
   */
  get_xero_connection_status = (params: RequestParams = {}) =>
    this.request<GetXeroConnectionStatusData, any>({
      path: `/xero/status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Initiate Xero OAuth connection
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name initiate_xero_connection
   * @summary Initiate Xero Connection
   * @request GET:/routes/xero/connect
   */
  initiate_xero_connection = (params: RequestParams = {}) =>
    this.request<InitiateXeroConnectionData, any>({
      path: `/xero/connect`,
      method: "GET",
      ...params,
    });

  /**
   * @description Handle OAuth callback from Xero
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name handle_xero_callback
   * @summary Handle Xero Callback
   * @request GET:/routes/xero/callback
   */
  handle_xero_callback = (query: HandleXeroCallbackParams, params: RequestParams = {}) =>
    this.request<HandleXeroCallbackData, HandleXeroCallbackError>({
      path: `/xero/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Disconnect Xero integration by clearing stored credentials
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name disconnect_xero
   * @summary Disconnect Xero
   * @request POST:/routes/xero/disconnect
   */
  disconnect_xero = (params: RequestParams = {}) =>
    this.request<DisconnectXeroData, any>({
      path: `/xero/disconnect`,
      method: "POST",
      ...params,
    });

  /**
   * @description Update the Xero webhook signing key in secrets
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name update_webhook_key
   * @summary Update Webhook Key
   * @request POST:/routes/xero/update-webhook-key
   */
  update_webhook_key = (data: UpdateWebhookKeyRequest, params: RequestParams = {}) =>
    this.request<UpdateWebhookKeyData, UpdateWebhookKeyError>({
      path: `/xero/update-webhook-key`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Sync a client to Xero as a Contact
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name sync_client_to_xero
   * @summary Sync Client To Xero
   * @request POST:/routes/xero/sync-client
   */
  sync_client_to_xero = (data: SyncClientRequest, params: RequestParams = {}) =>
    this.request<SyncClientToXeroData, SyncClientToXeroError>({
      path: `/xero/sync-client`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Sync an invoice to Xero
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name sync_invoice_to_xero
   * @summary Sync Invoice To Xero
   * @request POST:/routes/xero/sync-invoice
   */
  sync_invoice_to_xero = (data: SyncInvoiceRequest, params: RequestParams = {}) =>
    this.request<SyncInvoiceToXeroData, SyncInvoiceToXeroError>({
      path: `/xero/sync-invoice`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Approve and sync multiple invoices to Xero
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name approve_and_sync_invoices
   * @summary Approve And Sync Invoices
   * @request POST:/routes/xero/approve-and-sync
   */
  approve_and_sync_invoices = (data: ApproveAndSyncRequest, params: RequestParams = {}) =>
    this.request<ApproveAndSyncInvoicesData, ApproveAndSyncInvoicesError>({
      path: `/xero/approve-and-sync`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Handle Xero webhook intent verification (GET request)
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name xero_webhook_intent_verification
   * @summary Xero Webhook Intent Verification
   * @request GET:/routes/xero/webhook
   */
  xero_webhook_intent_verification = (params: RequestParams = {}) =>
    this.request<XeroWebhookIntentVerificationData, any>({
      path: `/xero/webhook`,
      method: "GET",
      ...params,
    });

  /**
   * @description Handle incoming Xero webhooks with signature verification
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name xero_webhook_handler
   * @summary Xero Webhook Handler
   * @request POST:/routes/xero/webhook
   */
  xero_webhook_handler = (params: RequestParams = {}) =>
    this.request<XeroWebhookHandlerData, any>({
      path: `/xero/webhook`,
      method: "POST",
      ...params,
    });

  /**
   * @description Refresh invoice status from Xero.
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name refresh_invoice_status
   * @summary Refresh Invoice Status
   * @request POST:/routes/xero/refresh-status
   */
  refresh_invoice_status = (data: RefreshStatusRequest, params: RequestParams = {}) =>
    this.request<RefreshInvoiceStatusData, RefreshInvoiceStatusError>({
      path: `/xero/refresh-status`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check sync status for a fortnight period
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_xero_sync_status
   * @summary Get Xero Sync Status
   * @request GET:/routes/xero/payroll/sync-status
   */
  get_xero_sync_status = (query: GetXeroSyncStatusParams, params: RequestParams = {}) =>
    this.request<GetXeroSyncStatusData, GetXeroSyncStatusError>({
      path: `/xero/payroll/sync-status`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Fetch all employees from Xero Payroll AU
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_xero_employees
   * @summary Get Xero Employees
   * @request GET:/routes/xero/payroll/employees
   */
  get_xero_employees = (params: RequestParams = {}) =>
    this.request<GetXeroEmployeesData, any>({
      path: `/xero/payroll/employees`,
      method: "GET",
      ...params,
    });

  /**
   * @description Fetch earnings rates from Xero Payroll AU
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_xero_earnings_rates
   * @summary Get Xero Earnings Rates
   * @request GET:/routes/xero/payroll/earnings-rates
   */
  get_xero_earnings_rates = (params: RequestParams = {}) =>
    this.request<GetXeroEarningsRatesData, any>({
      path: `/xero/payroll/earnings-rates`,
      method: "GET",
      ...params,
    });

  /**
   * @description Extract and group award classifications from Xero earnings rates
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_award_classifications
   * @summary Get Award Classifications
   * @request GET:/routes/xero/payroll/award-classifications
   */
  get_award_classifications = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/xero/payroll/award-classifications`,
      method: "GET",
      ...params,
    });

  /**
   * @description Map a staff member to a Xero employee
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name map_staff_to_employee
   * @summary Map Staff To Employee
   * @request POST:/routes/xero/payroll/map-staff
   */
  map_staff_to_employee = (data: MapStaffRequest, params: RequestParams = {}) =>
    this.request<MapStaffToEmployeeData, MapStaffToEmployeeError>({
      path: `/xero/payroll/map-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Save earnings rate mappings to Firestore
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name save_earnings_rate_mappings
   * @summary Save Earnings Rate Mappings
   * @request POST:/routes/xero/payroll/save-earnings-rate-mappings
   */
  save_earnings_rate_mappings = (data: SaveEarningsRateMappingsRequest, params: RequestParams = {}) =>
    this.request<SaveEarningsRateMappingsData, SaveEarningsRateMappingsError>({
      path: `/xero/payroll/save-earnings-rate-mappings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get earnings rate mappings from Firestore
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_earnings_rate_mappings
   * @summary Get Earnings Rate Mappings
   * @request GET:/routes/xero/payroll/get-earnings-rate-mappings
   */
  get_earnings_rate_mappings = (params: RequestParams = {}) =>
    this.request<GetEarningsRateMappingsData, any>({
      path: `/xero/payroll/get-earnings-rate-mappings`,
      method: "GET",
      ...params,
    });

  /**
   * @description Push fortnight timesheets to Xero Payroll AU using payrollEntries data
   *
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name push_timesheets
   * @summary Push Timesheets
   * @request POST:/routes/xero/payroll/push-timesheets
   */
  push_timesheets = (data: PushTimesheetsRequest, params: RequestParams = {}) =>
    this.request<PushTimesheetsData, PushTimesheetsError>({
      path: `/xero/payroll/push-timesheets`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Dry-run — returns what WOULD be pushed per staff (line totals + daily breakdowns + unmapped earnings types) without hitting the Xero API.
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name preview_timesheets_push
   * @request POST:/routes/xero/payroll/preview-timesheets-push
   */
  preview_timesheets_push = (data: PushTimesheetsRequest, params: RequestParams = {}) =>
    this.request<
      {
        fortnight_start_date: string;
        fortnight_end_date: string;
        results: Array<{
          staff_id: string;
          staff_name: string;
          award_classification?: string | null;
          success: boolean;
          error?: string | null;
          lines: Array<{
            earnings_type: string;
            alias_resolved_to?: string | null;
            total_units: number;
            daily: number[];
            xero_earnings_rate_id?: string | null;
            mapped: boolean;
          }>;
          unmapped: string[];
        }>;
      },
      any
    >({
      path: `/xero/payroll/preview-timesheets-push`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Force-rebuild every staffattendance doc whose parent appointment starts at or after `fromDateTime`. Idempotent.
   * @tags dbtn/module:admin_actions, dbtn/hasAuth
   * @name rebuild_future_staffattendance
   * @request POST:/routes/admin/staffattendance/rebuild-future
   */
  rebuild_future_staffattendance = (
    data: { fromDateTime: string; dryRun?: boolean },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        appointmentsScanned: number;
        appointmentsOk: number;
        saCreated: number;
        saUpdated: number;
        saDeleted: number;
        errors: number;
        errorSamples: string[];
        dryRun: boolean;
      },
      any
    >({
      path: `/admin/staffattendance/rebuild-future`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Read the global "Let Xero auto-generate invoice numbers" toggle.
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name get_invoice_numbering_settings
   * @request GET:/routes/xero/invoice-numbering
   */
  get_invoice_numbering_settings = (params: RequestParams = {}) =>
    this.request<{ autoGenerateInvoiceNumbers: boolean }, any>({
      path: `/xero/invoice-numbering`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update the global "Let Xero auto-generate invoice numbers" toggle.
   * @tags dbtn/module:xero_integration, dbtn/hasAuth
   * @name set_invoice_numbering_settings
   * @request POST:/routes/xero/invoice-numbering
   */
  set_invoice_numbering_settings = (
    data: { autoGenerateInvoiceNumbers: boolean },
    params: RequestParams = {},
  ) =>
    this.request<{ autoGenerateInvoiceNumbers: boolean }, any>({
      path: `/xero/invoice-numbering`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get working hours for a specific staff member.
   *
   * @tags Working Hours, dbtn/module:working_hours, dbtn/hasAuth
   * @name get_staff_working_hours
   * @summary Get Staff Working Hours
   * @request GET:/routes/working-hours/staff/{staff_id}
   */
  get_staff_working_hours = ({ staffId, ...query }: GetStaffWorkingHoursParams, params: RequestParams = {}) =>
    this.request<GetStaffWorkingHoursData, GetStaffWorkingHoursError>({
      path: `/working-hours/staff/${staffId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update working hours for a specific staff member.
   *
   * @tags Working Hours, dbtn/module:working_hours, dbtn/hasAuth
   * @name update_staff_working_hours
   * @summary Update Staff Working Hours
   * @request PUT:/routes/working-hours/staff/{staff_id}
   */
  update_staff_working_hours = (
    { staffId, ...query }: UpdateStaffWorkingHoursParams,
    data: WorkingHours,
    params: RequestParams = {},
  ) =>
    this.request<UpdateStaffWorkingHoursData, UpdateStaffWorkingHoursError>({
      path: `/working-hours/staff/${staffId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Start work on an office task
   *
   * @tags Work Time Tracking, dbtn/module:work_time_tracking, dbtn/hasAuth
   * @name work_time_start
   * @summary Work Time Start
   * @request POST:/routes/work-time/start/{task_id}
   */
  work_time_start = ({ taskId, ...query }: WorkTimeStartParams, params: RequestParams = {}) =>
    this.request<WorkTimeStartData, WorkTimeStartError>({
      path: `/work-time/start/${taskId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description End work on an office task
   *
   * @tags Work Time Tracking, dbtn/module:work_time_tracking, dbtn/hasAuth
   * @name work_time_end
   * @summary Work Time End
   * @request POST:/routes/work-time/end/{task_id}
   */
  work_time_end = (
    { taskId, ...query }: WorkTimeEndParams,
    data: AppApisWorkTimeTrackingEndWorkRequest,
    params: RequestParams = {},
  ) =>
    this.request<WorkTimeEndData, WorkTimeEndError>({
      path: `/work-time/end/${taskId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get current work status for an office task
   *
   * @tags Work Time Tracking, dbtn/module:work_time_tracking, dbtn/hasAuth
   * @name get_work_status
   * @summary Get Work Status
   * @request GET:/routes/work-time/status/{task_id}
   */
  get_work_status = ({ taskId, ...query }: GetWorkStatusParams, params: RequestParams = {}) =>
    this.request<GetWorkStatusData, GetWorkStatusError>({
      path: `/work-time/status/${taskId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a call message in the chat.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name create_call_message
   * @summary Create Call Message
   * @request POST:/video_calls/call-message
   */
  create_call_message = (data: CreateCallMessageRequest, params: RequestParams = {}) =>
    this.request<CreateCallMessageData, CreateCallMessageError>({
      path: `/video_calls/call-message`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Initiate a video call. Creates a call document in Firestore. Admin/Staff can call anyone, clients can only call admin users.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name initiate_call
   * @summary Initiate Call
   * @request POST:/video_calls/initiate
   */
  initiate_call = (data: InitiateCallRequest, params: RequestParams = {}) =>
    this.request<InitiateCallData, InitiateCallError>({
      path: `/video_calls/initiate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update the status of an existing call. Only participants can update the call status.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name update_call_status
   * @summary Update Call Status
   * @request PUT:/video_calls/status/{call_id}
   */
  update_call_status = (
    { callId, ...query }: UpdateCallStatusParams,
    data: UpdateCallStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCallStatusData, UpdateCallStatusError>({
      path: `/video_calls/status/${callId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Accept a call with first-to-answer logic. For admin_call type: removes all other admins, keeping only the accepting admin and client(s).
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name accept_call
   * @summary Accept Call
   * @request POST:/video_calls/accept/{call_id}
   */
  accept_call = ({ callId, ...query }: AcceptCallParams, data: AcceptCallRequest, params: RequestParams = {}) =>
    this.request<AcceptCallData, AcceptCallError>({
      path: `/video_calls/accept/${callId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Send a WebRTC signal (offer, answer, or ICE candidate) for a call. Uses Firestore Admin SDK to bypass frontend permission restrictions.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name send_signal
   * @summary Send Signal
   * @request POST:/video_calls/signal/{call_id}
   */
  send_signal = ({ callId, ...query }: SendSignalParams, data: SendSignalRequest, params: RequestParams = {}) =>
    this.request<SendSignalData, SendSignalError>({
      path: `/video_calls/signal/${callId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Retrieve all signals for a call that are addressed to the current user. Uses Firestore Admin SDK to bypass frontend permission restrictions.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name get_signals
   * @summary Get Signals
   * @request GET:/video_calls/signals/{call_id}
   */
  get_signals = ({ callId, ...query }: GetSignalsParams, params: RequestParams = {}) =>
    this.request<GetSignalsData, GetSignalsError>({
      path: `/video_calls/signals/${callId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Delete a processed signal. Uses Firestore Admin SDK to bypass frontend permission restrictions.
   *
   * @tags dbtn/module:video_calls, dbtn/hasAuth
   * @name delete_signal
   * @summary Delete Signal
   * @request DELETE:/video_calls/signal/{signal_id}
   */
  delete_signal = ({ signalId, ...query }: DeleteSignalParams, params: RequestParams = {}) =>
    this.request<DeleteSignalData, DeleteSignalError>({
      path: `/video_calls/signal/${signalId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Health check for vehicle management API
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name ping_vehicles
   * @summary Ping Vehicles
   * @request GET:/routes/routes/vehicles/ping
   */
  ping_vehicles = (params: RequestParams = {}) =>
    this.request<PingVehiclesData, any>({
      path: `/vehicles/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new vehicle
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name create_vehicle
   * @summary Create Vehicle
   * @request POST:/routes/routes/vehicles/
   */
  create_vehicle = (data: VehicleCreate, params: RequestParams = {}) =>
    this.request<CreateVehicleData, CreateVehicleError>({
      path: `/vehicles/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all vehicles
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name list_vehicles
   * @summary List Vehicles
   * @request GET:/routes/routes/vehicles/
   */
  list_vehicles = (query: ListVehiclesParams, params: RequestParams = {}) =>
    this.request<ListVehiclesData, ListVehiclesError>({
      path: `/vehicles/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a specific vehicle by ID
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name get_vehicle
   * @summary Get Vehicle
   * @request GET:/routes/routes/vehicles/{vehicle_id}
   */
  get_vehicle = ({ vehicleId, ...query }: GetVehicleParams, params: RequestParams = {}) =>
    this.request<GetVehicleData, GetVehicleError>({
      path: `/vehicles/${vehicleId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a vehicle
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name update_vehicle
   * @summary Update Vehicle
   * @request PUT:/routes/routes/vehicles/{vehicle_id}
   */
  update_vehicle = ({ vehicleId, ...query }: UpdateVehicleParams, data: VehicleUpdate, params: RequestParams = {}) =>
    this.request<UpdateVehicleData, UpdateVehicleError>({
      path: `/vehicles/${vehicleId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a vehicle (soft delete by default)
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name delete_vehicle
   * @summary Delete Vehicle
   * @request DELETE:/routes/vehicles/{vehicle_id}
   */
  delete_vehicle = ({ vehicleId, ...query }: DeleteVehicleParams, params: RequestParams = {}) =>
    this.request<DeleteVehicleData, DeleteVehicleError>({
      path: `/routes/vehicles/${vehicleId}`,
      method: "DELETE",
      query: query,
      ...params,
    });

  /**
   * @description Restore a soft-deleted vehicle
   *
   * @tags Vehicle Management
   * @name restore_vehicle
   * @summary Restore Vehicle
   * @request POST:/routes/vehicles/{vehicle_id}/restore
   */
  restore_vehicle = ({ vehicleId }: { vehicleId: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/routes/vehicles/${vehicleId}/restore`,
      method: "POST",
      ...params,
    });

  /**
   * @description Check availability of all vehicles for a given time period (with 30-minute buffer before and after, except for same staff)
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name check_vehicle_availability
   * @summary Check Vehicle Availability
   * @request POST:/routes/routes/vehicles/check-availability
   */
  check_vehicle_availability = (data: VehicleAvailabilityRequest, params: RequestParams = {}) =>
    this.request<CheckVehicleAvailabilityData, CheckVehicleAvailabilityError>({
      path: `/routes/vehicles/check-availability`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check availability of all staff members for a given time period
   *
   * @tags Staff Management
   * @name check_staff_availability
   * @summary Check Staff Availability
   * @request POST:/routes/staff/check-availability
   */
  check_staff_availability = (data: { start_time: string; end_time: string; exclude_appointment_id?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/routes/staff/check-availability`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Uploads an image for a vehicle and returns its storage key.
   *
   * @tags Vehicle Management, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name upload_vehicle_image
   * @summary Upload Vehicle Image
   * @request POST:/routes/routes/vehicles/{vehicle_id}/image-upload
   */
  upload_vehicle_image = (
    { vehicleId, ...query }: UploadVehicleImageParams,
    data: BodyUploadVehicleImage,
    params: RequestParams = {},
  ) =>
    this.request<UploadVehicleImageData, UploadVehicleImageError>({
      path: `/vehicles/${vehicleId}/image-upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Serves a vehicle image from binary storage.
   *
   * @tags Vehicle Management, stream, dbtn/module:vehicle_management, dbtn/hasAuth
   * @name get_vehicle_image
   * @summary Get Vehicle Image
   * @request GET:/routes/routes/vehicles/images/{image_key}
   */
  get_vehicle_image = ({ imageKey, ...query }: GetVehicleImageParams, params: RequestParams = {}) =>
    this.requestStream<GetVehicleImageData, GetVehicleImageError>({
      path: `/vehicles/images/${imageKey}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Start an unplanned work session for a staff member. Creates entries in appointments, staff attendance, and visit_logs collections. Supports manual time entry for retroactive work recording.
   *
   * @tags dbtn/module:unplanned_work, dbtn/hasAuth
   * @name start_unplanned_work
   * @summary Start Unplanned Work
   * @request POST:/start-unplanned-work
   */
  start_unplanned_work = (data: StartUnplannedWorkRequest, params: RequestParams = {}) =>
    this.request<StartUnplannedWorkData, StartUnplannedWorkError>({
      path: `/start-unplanned-work`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description End an unplanned work session. Updates both appointments and staff attendance records. Supports manual time entry via manualEndTime parameter.
   *
   * @tags dbtn/module:unplanned_work, dbtn/hasAuth
   * @name end_unplanned_work
   * @summary End Unplanned Work
   * @request POST:/end-unplanned-work
   */
  end_unplanned_work = (data: EndUnplannedWorkRequest, params: RequestParams = {}) =>
    this.request<EndUnplannedWorkData, EndUnplannedWorkError>({
      path: `/end-unplanned-work`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Check if a staff member has an active unplanned work session.
   *
   * @tags dbtn/module:unplanned_work, dbtn/hasAuth
   * @name check_active_unplanned_work
   * @summary Check Active Unplanned Work
   * @request GET:/check-active-unplanned-work/{staff_id}
   */
  check_active_unplanned_work = ({ staffId, ...query }: CheckActiveUnplannedWorkParams, params: RequestParams = {}) =>
    this.request<CheckActiveUnplannedWorkData, CheckActiveUnplannedWorkError>({
      path: `/check-active-unplanned-work/${staffId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Clock in to a travel segment between two appointments. Creates a new travel attendance record.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name clock_in_travel
   * @summary Clock In Travel
   * @request POST:/routes/travel-tracking/clock-in
   */
  clock_in_travel = (data: TravelClockInRequest, params: RequestParams = {}) =>
    this.request<ClockInTravelData, ClockInTravelError>({
      path: `/travel-tracking/clock-in`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Clock out of a travel segment. Updates the travel attendance record with clock out time and actual values.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name clock_out_travel
   * @summary Clock Out Travel
   * @request POST:/routes/travel-tracking/clock-out
   */
  clock_out_travel = (data: TravelClockOutRequest, params: RequestParams = {}) =>
    this.request<ClockOutTravelData, ClockOutTravelError>({
      path: `/travel-tracking/clock-out`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Idempotently persist an admin-clicked travel segment from the diary. Creates a staffattendance row with type=travel_segment OR returns the existing id if (staff, fromAppt, toAppt) already matches a saved row. Inherits client billing from both adjacent appointments.
   *
   * @tags Travel Tracking
   * @name admin_save_travel_segment
   * @summary Admin Save Travel Segment
   * @request POST:/travel-tracking/admin-save-segment
   */
  admin_save_travel_segment = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-save-segment`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create or delete the per-staff office travel_segment that backs the "Starts @ office" / "Ends @ office" toggle on the appointment hover popup. Google Directions is used server-side to derive distance/duration. Idempotent: re-enabling without disabling first returns the existing segment, and disabling when none exists is a no-op.
   *
   * @tags Travel Tracking
   * @name admin_toggle_office_segment
   * @summary Admin Toggle Office Segment
   * @request POST:/travel-tracking/admin-toggle-office-segment
   */
  admin_toggle_office_segment = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-toggle-office-segment`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Per-driver office travel_segment toggle for a transport-booking journey. Mirrors `admin_toggle_office_segment` but resolves the journey's origin/destination address from `transportBookings/{booking_id}.journeys[]` instead of an appointment.
   *
   * @tags Travel Tracking
   * @name admin_toggle_office_segment_for_journey
   * @summary Admin Toggle Office Segment For Journey
   * @request POST:/travel-tracking/admin-toggle-office-segment-for-journey
   */
  admin_toggle_office_segment_for_journey = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-toggle-office-segment-for-journey`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Partial update for an admin-saved travel segment. Only mutates the fields the caller passed (start/end time, vehicle, notes) and re-derives duration when times change.
   *
   * @tags Travel Tracking
   * @name admin_update_travel_segment
   * @summary Admin Update Travel Segment
   * @request PATCH:/travel-tracking/admin-segment/{segment_id}
   */
  admin_update_travel_segment = (segmentId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-segment/${segmentId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Look up an existing admin-saved travel_segment by the (staff, from, to) tuple. Returns the segment id if one exists.
   *
   * @tags Travel Tracking
   * @name admin_find_travel_segment
   * @summary Admin Find Travel Segment
   * @request GET:/travel-tracking/admin-find-segment
   */
  admin_find_travel_segment = (
    query: { staff_id: string; from_appointment_id: string; to_appointment_id: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-find-segment`,
      method: "GET",
      query,
      ...params,
    });

  /**
   * @description Hard-delete an admin-saved travel segment. Used by the editor when admins want to wipe a row saved with stale defaults and recreate it.
   *
   * @tags Travel Tracking
   * @name admin_delete_travel_segment
   * @summary Admin Delete Travel Segment
   * @request DELETE:/travel-tracking/admin-segment/{segment_id}
   */
  admin_delete_travel_segment = (segmentId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/travel-tracking/admin-segment/${segmentId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Send a real FCM push to a staffer's registered devices. Admin diagnostic — confirms FCM delivery is working end-to-end in one click, so "I'm not getting notifications" complaints can be triaged in seconds (payload vs device).
   *
   * @tags Admin Diagnostics
   * @name admin_send_test_push
   * @summary Admin Send Test Push
   * @request POST:/admin-diagnostics/send-test-push
   */
  admin_send_test_push = (
    data: { staff_id: string; title?: string; body?: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/admin-diagnostics/send-test-push`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Gets the current travel status between two appointments for a staff member.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name get_travel_status
   * @summary Get Travel Status
   * @request GET:/travel-tracking/travel-tracking/status
   */
  get_travel_status = (query: GetTravelStatusParams, params: RequestParams = {}) =>
    this.request<GetTravelStatusData, GetTravelStatusError>({
      path: `/travel-tracking/travel-tracking/status`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get travel confirmation data for the clock out dialog.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name get_travel_confirmation_data
   * @summary Get Travel Confirmation Data
   * @request GET:/routes/travel-tracking/travel-tracking/confirmation/{travel_segment_id}
   */
  get_travel_confirmation_data = (
    { travelSegmentId, ...query }: GetTravelConfirmationDataParams,
    params: RequestParams = {},
  ) =>
    this.request<GetTravelConfirmationDataData, GetTravelConfirmationDataError>({
      path: `/travel-tracking/travel-tracking/confirmation/${travelSegmentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name ping_travel_tracking
   * @summary Ping Travel Tracking
   * @request GET:/routes/travel-tracking/ping
   */
  ping_travel_tracking = (params: RequestParams = {}) =>
    this.request<PingTravelTrackingData, any>({
      path: `/travel-tracking/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get all active travel segments for the current user. Returns travel segments that are currently active.
   *
   * @tags Travel Tracking, dbtn/module:travel_tracking, dbtn/hasAuth
   * @name get_active_travel_segments
   * @summary Get Active Travel Segments
   * @request GET:/routes/travel-tracking/active-segments
   */
  get_active_travel_segments = (params: RequestParams = {}) =>
    this.request<GetActiveTravelSegmentsData, any>({
      path: `/travel-tracking/active-segments`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a pickup request for an event
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name create_pickup_request
   * @summary Create Pickup Request
   * @request POST:/routes/routes/create-pickup-request
   */
  create_pickup_request = (data: CreatePickupRequestRequest, params: RequestParams = {}) =>
    this.request<CreatePickupRequestData, CreatePickupRequestError>({
      path: `/routes/create-pickup-request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List transport bookings with optional filtering
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name list_transport_bookings
   * @summary List Transport Bookings
   * @request GET:/routes/routes/list-transport-bookings
   */
  list_transport_bookings = (query: ListTransportBookingsParams, params: RequestParams = {}) =>
    this.request<ListTransportBookingsData, ListTransportBookingsError>({
      path: `/routes/list-transport-bookings`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a specific transport booking by ID
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name get_transport_booking
   * @summary Get Transport Booking
   * @request GET:/routes/routes/transport-booking/{booking_id}
   */
  get_transport_booking = ({ bookingId, ...query }: GetTransportBookingParams, params: RequestParams = {}) =>
    this.request<GetTransportBookingData, GetTransportBookingError>({
      path: `/routes/transport-booking/${bookingId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Assign a vehicle to a transport booking (LEGACY - Use journey-specific assignment instead)
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name assign_vehicle_to_transport_booking
   * @summary Assign Vehicle To Transport Booking
   * @request POST:/routes/routes/transport-booking/{booking_id}/assign-vehicle
   */
  assign_vehicle_to_transport_booking = (
    { bookingId, ...query }: AssignVehicleToTransportBookingParams,
    data: AssignVehicleRequest,
    params: RequestParams = {},
  ) =>
    this.request<AssignVehicleToTransportBookingData, AssignVehicleToTransportBookingError>({
      path: `/routes/transport-booking/${bookingId}/assign-vehicle`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Assign a vehicle to a specific journey
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name assign_vehicle_to_journey
   * @summary Assign Vehicle To Journey
   * @request POST:/routes/routes/transport-booking/{booking_id}/journeys/{journey_id}/assign-vehicle
   */
  assign_vehicle_to_journey = (
    { bookingId, journeyId, ...query }: AssignVehicleToJourneyParams,
    data: AssignVehicleRequest,
    params: RequestParams = {},
  ) =>
    this.request<AssignVehicleToJourneyData, AssignVehicleToJourneyError>({
      path: `/routes/transport-booking/${bookingId}/journeys/${journeyId}/assign-vehicle`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Optimize pickup route for a transport booking (LEGACY - Use journey-specific optimization instead)
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name optimize_transport_route
   * @summary Optimize Transport Route
   * @request POST:/routes/routes/transport-booking/{booking_id}/optimize-route
   */
  optimize_transport_route = (
    { bookingId, ...query }: OptimizeTransportRouteParams,
    data: OptimizeRouteRequest,
    params: RequestParams = {},
  ) =>
    this.request<OptimizeTransportRouteData, OptimizeTransportRouteError>({
      path: `/routes/transport-booking/${bookingId}/optimize-route`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Optimize pickup route for a specific journey
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name optimize_journey_route
   * @summary Optimize Journey Route
   * @request POST:/routes/routes/transport-bookings/{booking_id}/journeys/{journey_id}/optimize-route
   */
  optimize_journey_route = (
    { bookingId, journeyId, ...query }: OptimizeJourneyRouteParams,
    data: OptimizeRouteRequest,
    params: RequestParams = {},
  ) =>
    this.request<OptimizeJourneyRouteData, OptimizeJourneyRouteError>({
      path: `/routes/transport-bookings/${bookingId}/journeys/${journeyId}/optimize-route`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Re-run route optimization on every transport journey whose event date is today or later. Returns counts.
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name reoptimize_future_journeys
   * @summary Bulk re-optimize future transport journeys
   * @request POST:/routes/transport-bookings/reoptimize-future-journeys
   */
  reoptimize_future_journeys = (params: RequestParams = {}) =>
    this.request<
      {
        optimized: number;
        skipped_past: number;
        failed: number;
        failed_details: { booking_id: string; journey_id: string; error: string }[];
        total_journeys_seen: number;
      },
      any
    >({
      path: `/routes/transport-bookings/reoptimize-future-journeys`,
      method: "POST",
      ...params,
    });

  /**
   * @description Cancel a pickup request
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name cancel_pickup_request
   * @summary Cancel Pickup Request
   * @request DELETE:/routes/routes/pickup-request/{pickup_request_id}
   */
  cancel_pickup_request = ({ pickupRequestId, ...query }: CancelPickupRequestParams, params: RequestParams = {}) =>
    this.request<CancelPickupRequestData, CancelPickupRequestError>({
      path: `/routes/pickup-request/${pickupRequestId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Update the status of a pickup request (staff only)
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name update_pickup_request_status
   * @summary Update Pickup Request Status
   * @request PUT:/routes/routes/pickup-request/{pickup_request_id}/status
   */
  update_pickup_request_status = (
    { pickupRequestId, ...query }: UpdatePickupRequestStatusParams,
    data: UpdatePickupStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdatePickupRequestStatusData, UpdatePickupRequestStatusError>({
      path: `/routes/pickup-request/${pickupRequestId}/status`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Split a transport booking by creating a new journey.
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name split_transport_booking
   * @summary Split Transport Booking
   * @request POST:/routes/routes/split-transport-booking/{booking_id}
   */
  split_transport_booking = ({ bookingId, ...query }: SplitTransportBookingParams, params: RequestParams = {}) =>
    this.request<SplitTransportBookingData, SplitTransportBookingError>({
      path: `/routes/split-transport-booking/${bookingId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Move a client's pickup request from one journey to another (drag-and-drop).
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name reassign_client_between_journeys
   * @summary Reassign Client Between Journeys
   * @request POST:/routes/routes/reassign-client
   */
  reassign_client_between_journeys = (data: ReassignClientBetweenJourneysPayload, params: RequestParams = {}) =>
    this.request<ReassignClientBetweenJourneysData, ReassignClientBetweenJourneysError>({
      path: `/reassign-client`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Move a client between journeys
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name move_client_between_journeys
   * @summary Move Client Between Journeys
   * @request POST:/routes/routes/transport-bookings/{booking_id}/move-client
   */
  move_client_between_journeys = (
    { bookingId, ...query }: MoveClientBetweenJourneysParams,
    data: MoveClientBetweenJourneysRequest,
    params: RequestParams = {},
  ) =>
    this.request<MoveClientBetweenJourneysData, MoveClientBetweenJourneysError>({
      path: `/routes/transport-bookings/${bookingId}/move-client`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a new journey in a transport booking
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name create_journey
   * @summary Create Journey
   * @request POST:/routes/routes/transport-bookings/{booking_id}/create-journey
   */
  create_journey = (
    { bookingId, ...query }: CreateJourneyParams,
    data: CreateJourneyRequest,
    params: RequestParams = {},
  ) =>
    this.request<CreateJourneyData, CreateJourneyError>({
      path: `/routes/transport-bookings/${bookingId}/create-journey`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a journey from a transport booking
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name delete_journey
   * @summary Delete Journey
   * @request DELETE:/routes/routes/transport-bookings/{booking_id}/journeys/{journey_id}
   */
  delete_journey = ({ bookingId, journeyId, ...query }: DeleteJourneyParams, params: RequestParams = {}) =>
    this.request<DeleteJourneyData, DeleteJourneyError>({
      path: `/routes/transport-bookings/${bookingId}/journeys/${journeyId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Update journey details
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name update_journey
   * @summary Update Journey
   * @request PUT:/routes/routes/transport-bookings/{booking_id}/journeys/{journey_id}
   */
  update_journey = (
    { bookingId, journeyId, ...query }: UpdateJourneyParams,
    data: UpdateJourneyRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateJourneyData, UpdateJourneyError>({
      path: `/routes/transport-bookings/${bookingId}/journeys/${journeyId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Patch shift instructions on a transport journey. Mirrors
   * the value to every driver/staff SA row tied to the journey.
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name update_journey_shift_instructions
   * @summary Update Journey Shift Instructions
   * @request PATCH:/routes/routes/transport-bookings/{booking_id}/journeys/{journey_id}/shift-instructions
   */
  update_journey_shift_instructions = (
    { bookingId, journeyId }: { bookingId: string; journeyId: string },
    data: { shiftInstructions: string | null },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; journeyId: string; shiftInstructions: string | null; saRowsMirrored: number }, any>({
      path: `/routes/transport-bookings/${bookingId}/journeys/${journeyId}/shift-instructions`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get transport booking with populated journey data
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name get_transport_booking_with_journeys
   * @summary Get Transport Booking With Journeys
   * @request GET:/routes/routes/transport-bookings/{booking_id}/with-journeys
   */
  get_transport_booking_with_journeys = (
    { bookingId, ...query }: GetTransportBookingWithJourneysParams,
    params: RequestParams = {},
  ) =>
    this.request<GetTransportBookingWithJourneysData, GetTransportBookingWithJourneysError>({
      path: `/routes/transport-bookings/${bookingId}/with-journeys`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create pickup and return transport bookings for an existing event
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name create_transport_bookings_for_event
   * @summary Create Transport Bookings For Event
   * @request POST:/routes/routes/create-transport-bookings-for-event/{event_id}
   */
  create_transport_bookings_for_event = (
    { eventId, ...query }: CreateTransportBookingsForEventParams,
    data: CreateTransportBookingsForEventPayload,
    params: RequestParams = {},
  ) =>
    this.request<CreateTransportBookingsForEventData, CreateTransportBookingsForEventError>({
      path: `/create-transport-bookings-for-event/${eventId}`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create pickup and return transport bookings for an event proactively.
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name create_event_transport_bookings
   * @summary Create Event Transport Bookings
   * @request POST:/routes/routes/create-event-transport-bookings/{event_id}
   */
  create_event_transport_bookings = (
    { eventId, ...query }: CreateEventTransportBookingsParams,
    params: RequestParams = {},
  ) =>
    this.request<CreateEventTransportBookingsData, CreateEventTransportBookingsError>({
      path: `/create-event-transport-bookings/${eventId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get a specific pickup request by ID
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name get_pickup_request
   * @summary Get Pickup Request
   * @request GET:/routes/routes/transport-bookings/{booking_id}/pickup-requests/{pickup_request_id}
   */
  get_pickup_request = ({ bookingId, pickupRequestId, ...query }: GetPickupRequestParams, params: RequestParams = {}) =>
    this.request<GetPickupRequestData, GetPickupRequestError>({
      path: `/routes/transport-bookings/${bookingId}/pickup-requests/${pickupRequestId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Rebook a cancelled transport booking by changing status from cancelled to draft
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name rebook_cancelled_transport_booking
   * @summary Rebook Cancelled Transport Booking
   * @request POST:/routes/routes/transport-booking/{booking_id}/rebook
   */
  rebook_cancelled_transport_booking = (
    { bookingId, ...query }: RebookCancelledTransportBookingParams,
    params: RequestParams = {},
  ) =>
    this.request<RebookCancelledTransportBookingData, RebookCancelledTransportBookingError>({
      path: `/routes/transport-booking/${bookingId}/rebook`,
      method: "POST",
      ...params,
    });

  /**
   * @description Rebook a cancelled pickup request by changing its status from cancelled to confirmed
   *
   * @tags dbtn/module:transport_booking, dbtn/hasAuth
   * @name rebook_cancelled_pickup_request
   * @summary Rebook Cancelled Pickup Request
   * @request POST:/routes/routes/transport-booking/{booking_id}/pickup-request/{pickup_request_id}/rebook
   */
  rebook_cancelled_pickup_request = (
    { bookingId, pickupRequestId, ...query }: RebookCancelledPickupRequestParams,
    params: RequestParams = {},
  ) =>
    this.request<RebookCancelledPickupRequestData, RebookCancelledPickupRequestError>({
      path: `/routes/transport-booking/${bookingId}/pickup-request/${pickupRequestId}/rebook`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get timesheet summary v2 data for a staff member over a date range
   *
   * @tags Timesheet Summary V2, dbtn/module:timesheet_summary_v2, dbtn/hasAuth
   * @name get_timesheet_summary_v2
   * @summary Get Timesheet Summary V2
   * @request GET:/timesheet-summary-v2/summary
   */
  get_timesheet_summary_v2 = (query: GetTimesheetSummaryV2Params, params: RequestParams = {}) =>
    this.request<GetTimesheetSummaryV2Data, GetTimesheetSummaryV2Error>({
      path: `/timesheet-summary-v2/summary`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Timesheet Summary V2, dbtn/module:timesheet_summary_v2, dbtn/hasAuth
   * @name ping_timesheet_summary_v2
   * @summary Ping Timesheet Summary V2
   * @request GET:/routes/timesheet-summary-v2/ping
   */
  ping_timesheet_summary_v2 = (params: RequestParams = {}) =>
    this.request<PingTimesheetSummaryV2Data, any>({
      path: `/timesheet-summary-v2/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description List time off requests for a staff member, with optional date filtering.
   *
   * @tags Timesheet Management, dbtn/module:timesheet_management, dbtn/hasAuth
   * @name list_time_off_requests
   * @summary List Time Off Requests
   * @request GET:/timesheet/time-off-requests
   */
  list_time_off_requests = (query: ListTimeOffRequestsParams, params: RequestParams = {}) =>
    this.request<ListTimeOffRequestsData, ListTimeOffRequestsError>({
      path: `/timesheet/time-off-requests`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Fetches all staff attendance records for a given staff member within a specified date range.
   *
   * @tags Timesheet Management, dbtn/module:timesheet_management, dbtn/hasAuth
   * @name list_staff_attendance
   * @summary List Staff Attendance
   * @request GET:/routes/timesheet/attendance/{staffId}
   */
  list_staff_attendance = ({ staffId, ...query }: ListStaffAttendanceParams, params: RequestParams = {}) =>
    this.request<ListStaffAttendanceData, ListStaffAttendanceError>({
      path: `/timesheet/attendance/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Cancel a time off request. If the request is part of a group (has requestId), cancel all requests in that group.
   *
   * @tags Timesheet Management, dbtn/module:timesheet_management, dbtn/hasAuth
   * @name cancel_time_off_request
   * @summary Cancel Time Off Request
   * @request DELETE:/routes/timesheet/time-off-requests/{request_id}
   */
  cancel_time_off_request = ({ requestId, ...query }: CancelTimeOffRequestParams, params: RequestParams = {}) =>
    this.request<CancelTimeOffRequestData, CancelTimeOffRequestError>({
      path: `/timesheet/time-off-requests/${requestId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Update a pending time off request. Owner only. Approved or
   * rejected requests must be cancelled and resubmitted.
   *
   * @tags Timesheet Management, dbtn/module:timesheet_management, dbtn/hasAuth
   * @name update_time_off_request
   * @summary Update Time Off Request
   * @request PUT:/routes/timesheet/time-off-requests/{request_id}
   */
  update_time_off_request = (
    { requestId }: UpdateTimeOffRequestParams,
    body: UpdateTimeOffRequestPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateTimeOffRequestData, UpdateTimeOffRequestError>({
      path: `/timesheet/time-off-requests/${requestId}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a manually-inserted, pre-approved staffattendance entry to
   * cover a missing timesheet window. Used by the Admin Timesheet
   * Approval page's "+ Fill this gap" and "+ Add manual shift" buttons.
   * Writes isApproved=true, payrollStatus="approved", manuallyCreated=true,
   * payrollReady=true on the new SA doc. Admin-only.
   *
   * @tags Timesheet Management, dbtn/module:timesheet_management, dbtn/hasAuth
   * @name create_manual_attendance
   * @summary Create Manual Attendance
   * @request POST:/timesheet/manual-attendance
   */
  create_manual_attendance = (
    body: {
      staff_id: string;
      start_time: string;
      end_time: string;
      reason?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/timesheet/manual-attendance`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get TIL balance and recent transaction history for a staff member.
   *
   * @tags TIL Transactions, dbtn/module:til_transactions, dbtn/hasAuth
   * @name get_til_balance_with_transactions
   * @summary Get Til Balance With Transactions
   * @request GET:/routes/til-transactions/balance/{staff_id}
   */
  get_til_balance_with_transactions = (
    { staffId, ...query }: GetTilBalanceWithTransactionsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetTilBalanceWithTransactionsData, GetTilBalanceWithTransactionsError>({
      path: `/til-transactions/balance/${staffId}`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Create overtime transaction and TIL transaction (if banked) from attendance entry.
   *
   * @tags TIL Transactions, dbtn/module:til_transactions, dbtn/hasAuth
   * @name create_overtime_and_til_transactions
   * @summary Create Overtime And Til Transactions
   * @request POST:/routes/til-transactions/create-from-overtime
   */
  create_overtime_and_til_transactions = (data: CreateOvertimeTransactionRequest, params: RequestParams = {}) =>
    this.request<CreateOvertimeAndTilTransactionsData, CreateOvertimeAndTilTransactionsError>({
      path: `/til-transactions/create-from-overtime`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Bootstrap TIL balance cache for all staff with existing transactions. This endpoint calculates the current TIL balance for all staff members who have TIL transactions and populates the til_balances cache collection. Admin-only endpoint.
   *
   * @tags TIL Transactions, dbtn/module:til_transactions, dbtn/hasAuth
   * @name bootstrap_til_cache
   * @summary Bootstrap Til Cache
   * @request POST:/routes/til-transactions/bootstrap-til-cache
   */
  bootstrap_til_cache = (params: RequestParams = {}) =>
    this.request<BootstrapTilCacheData, any>({
      path: `/til-transactions/bootstrap-til-cache`,
      method: "POST",
      ...params,
    });

  /**
   * @description Update vehicle assignment for a single appointment. Allows setting a vehicle, clearing a vehicle, or marking as "Use Own Car".
   *
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name update_appointment_vehicle
   * @summary Update Appointment Vehicle
   * @request PUT:/routes/staff/appointment/{appointment_id}/vehicle
   */
  update_appointment_vehicle = (
    { appointmentId, ...query }: UpdateAppointmentVehicleParams,
    data: UpdateAppointmentVehicleRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateAppointmentVehicleData, UpdateAppointmentVehicleError>({
      path: `/staff/appointment/${appointmentId}/vehicle`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Save vehicle assignments for staff members in an appointment. Creates or updates entries in the staffattendance collection. Also sets startsAtOffice=true if this is the staff's first appointment of the day, and endsAtOffice=true if this is the staff's last appointment of the day.
   *
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name save_appointment_vehicle_assignments
   * @summary Save Appointment Vehicle Assignments
   * @request POST:/staff/appointment/{appointment_id}/vehicle-assignments
   */
  save_appointment_vehicle_assignments = (
    { appointmentId, ...query }: SaveAppointmentVehicleAssignmentsParams,
    data: SaveVehicleAssignmentsRequest,
    params: RequestParams = {},
  ) =>
    this.request<SaveAppointmentVehicleAssignmentsData, SaveAppointmentVehicleAssignmentsError>({
      path: `/staff/appointment/${appointmentId}/vehicle-assignments`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Reconcile staffattendance docs against a per-staff list of time windows. Supports multi-window per staff (split shifts, coverage hand-offs). Earliest window keeps the canonical doc id; additional windows get random ids. Existing clockIn/Out & approval state on matched SAs are preserved.
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name save_appointment_staff_time_windows
   * @summary Save Appointment Staff Time Windows
   * @request POST:/staff/appointment/{appointment_id}/staff-time-windows
   */
  save_appointment_staff_time_windows = (
    { appointmentId }: { appointmentId: string },
    data: {
      staffTimeWindows: Record<string, Array<{
        startTime: string;
        endTime: string;
        vehicleId?: string;
        vehicleLicensePlate?: string | null;
        breakDuration?: number | null;
        attendanceId?: string | null;
      }>>;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/staff/appointment/${appointmentId}/staff-time-windows`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Create a client note. Mirrors to shiftNotes for unified search.
   * @tags Client Notes, dbtn/hasAuth
   * @name create_client_note
   * @request POST:/client-notes
   */
  create_client_note = (
    data: {
      clientId: string;
      content: string;
      source?: 'chat' | 'manual' | 'import';
      chatContext?: {
        conversationId?: string;
        messageId?: string;
        senderId?: string;
        senderName?: string;
        sentAt?: string | null;
      };
      attachmentUrl?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/client-notes`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List notes for a given client (newest first).
   * @tags Client Notes, dbtn/hasAuth
   * @name list_client_notes
   * @request GET:/client-notes
   */
  list_client_notes = (
    query: { clientId: string; limit?: number },
    params: RequestParams = {},
  ) =>
    this.request<any[], any>({
      path: `/client-notes`,
      method: 'GET',
      query,
      ...params,
    });

  /**
   * @description Free-text search across client notes.
   * @tags Client Notes, dbtn/hasAuth
   * @name search_client_notes
   * @request GET:/client-notes/search
   */
  search_client_notes = (
    query: { q: string; limit?: number },
    params: RequestParams = {},
  ) =>
    this.request<any[], any>({
      path: `/client-notes/search`,
      method: 'GET',
      query,
      ...params,
    });

  /**
   * @description Delete a client note.
   * @tags Client Notes, dbtn/hasAuth
   * @name delete_client_note
   * @request DELETE:/client-notes/{note_id}
   */
  delete_client_note = (
    { noteId }: { noteId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/client-notes/${noteId}`,
      method: 'DELETE',
      ...params,
    });

  /**
   * @description Manually overrides the clock-in or clock-out time for a staff member on a specific appointment. This is the smart endpoint for handling both actions.
   *
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name manual_clock_time_override
   * @summary Manual Clock Time Override
   * @request POST:/routes/staff/appointment/{appointment_id}/manual-clock-time-override
   */
  manual_clock_time_override = (
    { appointmentId, ...query }: ManualClockTimeOverrideParams,
    data: AppApisStaffScheduleManualTimeOverrideRequest,
    params: RequestParams = {},
  ) =>
    this.request<ManualClockTimeOverrideData, ManualClockTimeOverrideError>({
      path: `/staff/appointment/${appointmentId}/manual-clock-time-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Records the clock-in time for a staff member for a specific appointment, writing to visit_logs.
   *
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name clock_in
   * @summary Clock In
   * @request POST:/routes/staff/appointments/{appointment_id}/clock-in
   */
  clock_in = ({ appointmentId, ...query }: ClockInParams, data: ClockInRequest, params: RequestParams = {}) =>
    this.request<ClockInData, ClockInError>({
      path: `/staff/appointments/${appointmentId}/clock-in`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags Staff, dbtn/module:staff_schedule, dbtn/hasAuth
   * @name clock_out
   * @summary Clock Out
   * @request POST:/routes/staff/appointments/{appointment_id}/clock-out
   */
  clock_out = ({ appointmentId, ...query }: ClockOutParams, data: ClockOutRequest, params: RequestParams = {}) =>
    this.request<ClockOutData, ClockOutError>({
      path: `/staff/appointments/${appointmentId}/clock-out`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Debug endpoint to check what user ID is being received
   *
   * @tags dbtn/module:staffattendance_listing, dbtn/hasAuth
   * @name debug_user_info_staffattendance
   * @summary Debug User Info Staffattendance
   * @request GET:/routes/debug/user-info
   */
  debug_user_info_staffattendance = (params: RequestParams = {}) =>
    this.request<DebugUserInfoStaffattendanceData, any>({
      path: `/debug/user-info`,
      method: "GET",
      ...params,
    });

  /**
   * @description List staff attendance entries from the staffattendance collection. Shows ALL attendance records for the staff member in the time period, ordered by appointment startTime (stored in staffattendance records). Regular staff can only see their own entries. Admins can see all entries or filter by staff_id.
   *
   * @tags dbtn/module:staffattendance_listing, dbtn/hasAuth
   * @name list_staff_attendance_entries
   * @summary List Staff Attendance Entries
   * @request GET:/staffattendance/entries
   */
  list_staff_attendance_entries = (query: ListStaffAttendanceEntriesParams, params: RequestParams = {}) =>
    this.request<ListStaffAttendanceEntriesData, ListStaffAttendanceEntriesError>({
      path: `/staffattendance/entries`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Update overtime choice for a specific attendance entry and create TIL transactions if needed
   *
   * @tags dbtn/module:staffattendance_listing, dbtn/hasAuth
   * @name update_overtime_choice
   * @summary Update Overtime Choice
   * @request PUT:/entries/{entry_id}/overtime-choice
   */
  update_overtime_choice = (
    { entryId, ...query }: UpdateOvertimeChoiceParams,
    data: OvertimeChoiceUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateOvertimeChoiceData, UpdateOvertimeChoiceError>({
      path: `/entries/${entryId}/overtime-choice`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Assign staff members (including drivers) to a transport journey. Updates the journey document with staff assignments and syncs staffattendance records.
   *
   * @tags Transport Journey Management, dbtn/module:transport_journey_management, dbtn/hasAuth
   * @name assign_staff_to_journey
   * @summary Assign Staff To Journey
   * @request POST:/transport-journey-management/transport-bookings/{booking_id}/journeys/{journey_id}/assign-staff
   */
  assign_staff_to_journey = (
    { bookingId, journeyId, ...query }: AssignStaffToJourneyParams,
    data: AssignStaffToJourneyRequest,
    params: RequestParams = {},
  ) =>
    this.request<AssignStaffToJourneyData, AssignStaffToJourneyError>({
      path: `/transport-journey-management/transport-bookings/${bookingId}/journeys/${journeyId}/assign-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update office travel settings for a transport journey. Sets whether the journey starts/ends at office and planned departure time.
   *
   * @tags Transport Journey Management, dbtn/module:transport_journey_management, dbtn/hasAuth
   * @name update_journey_office_travel
   * @summary Update Journey Office Travel
   * @request POST:/transport-journey-management/transport-bookings/{booking_id}/journeys/{journey_id}/office-travel
   */
  update_journey_office_travel = (
    { bookingId, journeyId, ...query }: UpdateJourneyOfficeTravelParams,
    data: UpdateJourneyOfficeTravelRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateJourneyOfficeTravelData, UpdateJourneyOfficeTravelError>({
      path: `/transport-journey-management/transport-bookings/${bookingId}/journeys/${journeyId}/office-travel`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Apply additional traffic buffer time to a journey's route optimization. This adds extra time to account for traffic conditions.
   *
   * @tags Transport Journey Management
   * @name apply_traffic_buffer_to_journey
   * @summary Apply Traffic Buffer To Journey
   * @request POST:/transport-journey-management/journeys/{journey_id}/apply-traffic-buffer
   */
  apply_traffic_buffer_to_journey = (
    { journeyId, ...data }: { journeyId: string; bufferMinutes: number },
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/transport-journey-management/journeys/${journeyId}/apply-traffic-buffer`,
      method: "POST",
      body: { bufferMinutes: data.bufferMinutes },
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Manually override the start/end time of a transport journey.
   * Either field may be omitted to keep the existing value. Mirrors the new
   * time(s) into the linked staffattendance docs.
   *
   * @tags Transport Journey Management, dbtn/module:transport_journey_management, dbtn/hasAuth
   * @name update_journey_times
   * @summary Update Journey Times
   * @request POST:/transport-journey-management/journeys/{journey_id}/update-times
   */
  update_journey_times = (
    { journeyId, ...data }: {
      journeyId: string;
      start_time?: string;
      end_time?: string;
      reason?: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/transport-journey-management/journeys/${journeyId}/update-times`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Health check endpoint for transport journey management API
   *
   * @tags Transport Journey Management, dbtn/module:transport_journey_management, dbtn/hasAuth
   * @name ping_transport_journey_management
   * @summary Ping Transport Journey Management
   * @request GET:/transport-journey-management/transport-journey-management/ping
   */
  ping_transport_journey_management = (params: RequestParams = {}) =>
    this.request<PingTransportJourneyManagementData, any>({
      path: `/transport-journey-management/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new staff invitation for a specific appointment.
   *
   * @tags dbtn/module:invitations, dbtn/hasAuth
   * @name create_invitation
   * @summary Create Invitation
   * @request POST:/routes/invitations/create
   */
  create_invitation = (data: CreateInvitationRequest, params: RequestParams = {}) =>
    this.request<CreateInvitationData, CreateInvitationError>({
      path: `/invitations/create`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List invitations. Filters by staff_id for staff users, shows all for admin users.
   *
   * @tags dbtn/module:invitations, dbtn/hasAuth
   * @name list_invitations
   * @summary List Invitations
   * @request GET:/routes/invitations/list
   */
  list_invitations = (query: ListInvitationsParams, params: RequestParams = {}) =>
    this.request<ListInvitationsData, ListInvitationsError>({
      path: `/invitations/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Staff member responds to an invitation (accept or decline).
   *
   * @tags dbtn/module:invitations, dbtn/hasAuth
   * @name respond_to_invitation
   * @summary Respond To Invitation
   * @request POST:/routes/invitations/{invitation_id}/respond
   */
  respond_to_invitation = (
    { invitationId, ...query }: RespondToInvitationParams,
    data: RespondToInvitationRequest,
    params: RequestParams = {},
  ) =>
    this.request<RespondToInvitationData, RespondToInvitationError>({
      path: `/invitations/${invitationId}/respond`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Cancel a pending invitation (admin only).
   *
   * @tags dbtn/module:invitations, dbtn/hasAuth
   * @name cancel_invitation
   * @summary Cancel Invitation
   * @request DELETE:/routes/invitations/{invitation_id}
   */
  cancel_invitation = ({ invitationId, ...query }: CancelInvitationParams, params: RequestParams = {}) =>
    this.request<CancelInvitationData, CancelInvitationError>({
      path: `/invitations/${invitationId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get invitation statistics.
   *
   * @tags dbtn/module:invitations, dbtn/hasAuth
   * @name get_invitation_stats
   * @summary Get Invitation Stats
   * @request GET:/routes/invitations/stats
   */
  get_invitation_stats = (query: GetInvitationStatsParams, params: RequestParams = {}) =>
    this.request<GetInvitationStatsData, GetInvitationStatsError>({
      path: `/invitations/stats`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Allow clients to confirm or cancel their appointment. - If confirmed=True: sets clientConfirmed to true - If confirmed=False: sets clientConfirmed to false, status to 'cancelled by client', and emails admin
   *
   * @tags dbtn/module:appointment_confirmation, dbtn/hasAuth
   * @name confirm_appointment
   * @summary Confirm Appointment
   * @request POST:/appointments/{appointment_id}/confirm
   */
  confirm_appointment = (
    { appointmentId, ...query }: ConfirmAppointmentParams,
    data: AppointmentConfirmationRequest,
    params: RequestParams = {},
  ) =>
    this.request<ConfirmAppointmentData, ConfirmAppointmentError>({
      path: `/appointments/${appointmentId}/confirm`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Send 48-hour confirmation reminders to clients for upcoming appointments. This should be called by a scheduled job/cron. Only admin users can trigger this.
   *
   * @tags dbtn/module:appointment_confirmation, dbtn/hasAuth
   * @name send_48h_appointment_reminders
   * @summary Send 48H Appointment Reminders
   * @request POST:/routes/appointments/send-48h-reminders
   */
  send_48h_appointment_reminders = (params: RequestParams = {}) =>
    this.request<Send48HAppointmentRemindersData, any>({
      path: `/appointments/send-48h-reminders`,
      method: "POST",
      ...params,
    });

  /**
   * @description Webhook endpoint to trigger 48-hour appointment reminders. This endpoint should be called by an external cron service. Protected by a secret header for security.
   *
   * @tags dbtn/module:appointment_confirmation, dbtn/hasAuth
   * @name trigger_48h_reminders_webhook
   * @summary Trigger 48H Reminders Webhook
   * @request POST:/routes/cron/48h-reminders
   */
  trigger_48h_reminders_webhook = (params: RequestParams = {}) =>
    this.request<Trigger48HRemindersWebhookData, Trigger48HRemindersWebhookError>({
      path: `/cron/48h-reminders`,
      method: "POST",
      ...params,
    });

  /**
   * @description Send a notification to a specific user. Creates a notification document in Firestore that will be picked up by the real-time listener in the frontend. Also sends a push notification via FCM if user has enabled notifications.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name send_notification
   * @summary Send Notification
   * @request POST:/routes/notifications/send
   */
  send_notification = (data: SendNotificationRequest, params: RequestParams = {}) =>
    this.request<SendNotificationData, SendNotificationError>({
      path: `/notifications/send`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Send the same notification to multiple users. Useful for broadcasting announcements or system-wide notifications. Also sends FCM push notifications to all users.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name send_bulk_notification
   * @summary Send Bulk Notification
   * @request POST:/routes/notifications/send-bulk
   */
  send_bulk_notification = (data: SendBulkNotificationRequest, params: RequestParams = {}) =>
    this.request<SendBulkNotificationData, SendBulkNotificationError>({
      path: `/notifications/send-bulk`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete all notifications for a user. Useful for cleanup or testing.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name clear_all_notifications
   * @summary Clear All Notifications
   * @request DELETE:/routes/notifications/clear/{user_id}
   */
  clear_all_notifications = ({ userId, ...query }: ClearAllNotificationsParams, params: RequestParams = {}) =>
    this.request<ClearAllNotificationsData, ClearAllNotificationsError>({
      path: `/notifications/clear/${userId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Mark a single notification as read. Only the notification owner can mark it as read.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name mark_notification_as_read
   * @summary Mark Notification As Read
   * @request POST:/routes/notifications/mark-as-read
   */
  mark_notification_as_read = (data: MarkAsReadRequest, params: RequestParams = {}) =>
    this.request<MarkNotificationAsReadData, MarkNotificationAsReadError>({
      path: `/notifications/mark-as-read`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Mark all unread notifications as read for the current user.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name mark_all_notifications_as_read
   * @summary Mark All Notifications As Read
   * @request POST:/routes/notifications/mark-all-as-read
   */
  mark_all_notifications_as_read = (params: RequestParams = {}) =>
    this.request<MarkAllNotificationsAsReadData, any>({
      path: `/notifications/mark-all-as-read`,
      method: "POST",
      ...params,
    });

  /**
   * @description Get notification preferences for the current user.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name get_notification_preferences
   * @summary Get Notification Preferences
   * @request GET:/routes/notifications/preferences
   */
  get_notification_preferences = (params: RequestParams = {}) =>
    this.request<GetNotificationPreferencesData, any>({
      path: `/notifications/preferences`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update notification preferences for the current user.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name update_notification_preferences
   * @summary Update Notification Preferences
   * @request PUT:/routes/notifications/preferences
   */
  update_notification_preferences = (data: UpdatePreferencesRequest, params: RequestParams = {}) =>
    this.request<UpdateNotificationPreferencesData, UpdateNotificationPreferencesError>({
      path: `/notifications/preferences`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Send push notifications to conversation participants when a new chat message is sent. Called after message is written to Firestore.
   *
   * @tags dbtn/module:notifications, dbtn/hasAuth
   * @name send_chat_notification
   * @summary Send Chat Notification
   * @request POST:/routes/notifications/send-chat-notification
   */
  send_chat_notification = (data: SendChatNotificationRequest, params: RequestParams = {}) =>
    this.request<SendChatNotificationData, SendChatNotificationError>({
      path: `/notifications/send-chat-notification`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get timesheet data for admin approval for a specific staff member and week.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name get_staff_timesheet_for_approval
   * @summary Get Staff Timesheet For Approval
   * @request GET:/admin-timesheet/staff-timesheet-approval
   */
  get_staff_timesheet_for_approval = (query: GetStaffTimesheetForApprovalParams, params: RequestParams = {}) =>
    this.request<GetStaffTimesheetForApprovalData, GetStaffTimesheetForApprovalError>({
      path: `/admin-timesheet/staff-timesheet-approval`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Bulk approve timesheet entries for admin approval workflow.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name bulk_approve_timesheet_entries
   * @summary Bulk Approve Timesheet Entries
   * @request POST:/admin-timesheet/bulk-approve
   */
  bulk_approve_timesheet_entries = (data: BulkTimesheetApprovalRequest, params: RequestParams = {}) =>
    this.request<BulkApproveTimesheetEntriesData, BulkApproveTimesheetEntriesError>({
      path: `/admin-timesheet/bulk-approve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List time off requests for admin review.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name admin_list_time_off_requests
   * @summary Admin List Time Off Requests
   * @request GET:/admin-timesheet/time-off-requests
   */
  admin_list_time_off_requests = (query: AdminListTimeOffRequestsParams, params: RequestParams = {}) =>
    this.request<AdminListTimeOffRequestsData, AdminListTimeOffRequestsError>({
      path: `/admin-timesheet/time-off-requests`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get count of pending time off requests for admin badge display
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name get_pending_leave_count
   * @summary Get Pending Leave Count
   * @request GET:/routes/admin-timesheet/time-off-requests/pending-count
   */
  get_pending_leave_count = (params: RequestParams = {}) =>
    this.request<GetPendingLeaveCountData, any>({
      path: `/admin-timesheet/time-off-requests/pending-count`,
      method: "GET",
      ...params,
    });

  /**
   * @description Approve a time off request.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name approve_time_off_request
   * @summary Approve Time Off Request
   * @request POST:/admin-timesheet/approve-time-off
   */
  approve_time_off_request = (query: ApproveTimeOffRequestParams, params: RequestParams = {}) =>
    this.request<ApproveTimeOffRequestData, ApproveTimeOffRequestError>({
      path: `/admin-timesheet/approve-time-off`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Retry creating TIL transaction for an approved time off request that had a TIL transaction error.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name retry_til_transaction_for_approval
   * @summary Retry Til Transaction For Approval
   * @request POST:/admin-timesheet/retry-til-transaction
   */
  retry_til_transaction_for_approval = (query: RetryTilTransactionForApprovalParams, params: RequestParams = {}) =>
    this.request<RetryTilTransactionForApprovalData, RetryTilTransactionForApprovalError>({
      path: `/admin-timesheet/retry-til-transaction`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Reject a time off request.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name reject_time_off_request
   * @summary Reject Time Off Request
   * @request POST:/admin-timesheet/reject-time-off
   */
  reject_time_off_request = (query: RejectTimeOffRequestParams, params: RequestParams = {}) =>
    this.request<RejectTimeOffRequestData, RejectTimeOffRequestError>({
      path: `/admin-timesheet/reject-time-off`,
      method: "POST",
      query: query,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Admin Timesheet Approval, dbtn/module:admin_timesheet_approval, dbtn/hasAuth
   * @name ping_admin_timesheet
   * @summary Ping Admin Timesheet
   * @request GET:/routes/admin-timesheet/ping
   */
  ping_admin_timesheet = (params: RequestParams = {}) =>
    this.request<PingAdminTimesheetData, any>({
      path: `/admin-timesheet/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new time off request for yourself (staff endpoint).
   *
   * @tags Time Off Requests, dbtn/module:time_off_working, dbtn/hasAuth
   * @name create_time_off_request
   * @summary Create Time Off Request
   * @request POST:/time-off/requests
   */
  create_time_off_request = (data: TimeOffRequestCreate, params: RequestParams = {}) =>
    this.request<CreateTimeOffRequestData, CreateTimeOffRequestError>({
      path: `/time-off/requests`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Health check endpoint.
   *
   * @tags Time Off Requests, dbtn/module:time_off_working, dbtn/hasAuth
   * @name ping_time_off_api
   * @summary Ping Time Off Api
   * @request GET:/time-off/ping
   */
  ping_time_off_api = (params: RequestParams = {}) =>
    this.request<PingTimeOffApiData, any>({
      path: `/time-off/ping`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new time off request on behalf of a staff member (admin only).
   *
   * @tags Time Off Requests, dbtn/module:time_off_working, dbtn/hasAuth
   * @name admin_create_time_off_request
   * @summary Admin Create Time Off Request
   * @request POST:/time-off/admin/requests/{staff_id}
   */
  admin_create_time_off_request = (
    { staffId, ...query }: AdminCreateTimeOffRequestParams,
    data: TimeOffRequestCreate,
    params: RequestParams = {},
  ) =>
    this.request<AdminCreateTimeOffRequestData, AdminCreateTimeOffRequestError>({
      path: `/time-off/admin/requests/${staffId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description OPTIMIZED endpoint for admin appointment list view. Returns only essential fields needed for table display - significantly faster than full endpoint.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name list_admin_appointments_light
   * @summary List Admin Appointments Light
   * @request GET:/routes/appointments/admin/list-light
   */
  list_admin_appointments_light = (query: ListAdminAppointmentsLightParams, params: RequestParams = {}) =>
    this.request<ListAdminAppointmentsLightData, ListAdminAppointmentsLightError>({
      path: `/appointments/admin/list-light`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Provides a paginated list of appointments for admin users, with filtering options. Fetches appointments from the 'appointments' collection. Attempts to fetch client and staff names if their IDs are present.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name list_admin_appointments
   * @summary List Admin Appointments
   * @request GET:/routes/appointments/admin/list
   */
  list_admin_appointments = (query: ListAdminAppointmentsParams, params: RequestParams = {}) =>
    this.request<ListAdminAppointmentsData, ListAdminAppointmentsError>({
      path: `/appointments/admin/list`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Migrate existing appointments to include denormalized fields for performance.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name migrate_denormalized_fields
   * @summary Migrate Denormalized Fields
   * @request POST:/routes/appointments/migrate-denormalized-fields
   */
  migrate_denormalized_fields = (params: RequestParams = {}) =>
    this.request<MigrateDenormalizedFieldsData, any>({
      path: `/appointments/migrate-denormalized-fields`,
      method: "POST",
      ...params,
    });

  /**
   * @description Gets the count of appointments with 'Pending', 'Requested', or 'Needs Rescheduling' statuses. Requires admin or staff role.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name get_appointment_status_count
   * @summary Get Appointment Status Count
   * @request GET:/routes/status-count
   */
  get_appointment_status_count = (params: RequestParams = {}) =>
    this.request<GetAppointmentStatusCountData, any>({
      path: `/status-count`,
      method: "GET",
      ...params,
    });

  /**
   * @description Creates a new scheduled appointment. Handles single and repeating appointments.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name create_scheduled_appointment
   * @summary Create Scheduled Appointment
   * @request POST:/appointments/create_scheduled
   */
  create_scheduled_appointment = (data: NewScheduledAppointmentData, params: RequestParams = {}) =>
    this.request<CreateScheduledAppointmentData, CreateScheduledAppointmentError>({
      path: `/appointments/create_scheduled`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Receives an appointment request from a client, validates it, and stores it in Firestore with a 'requested' status.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name create_appointment_request
   * @summary Create Appointment Request
   * @request POST:/routes/appointments/request
   */
  create_appointment_request = (data: AppApisAppointmentsAppointmentRequestCreate, params: RequestParams = {}) =>
    this.request<CreateAppointmentRequestData, CreateAppointmentRequestError>({
      path: `/appointments/request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allows a client to cancel their own appointment request (in appointment_requests collection).
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name client_cancel_appointment_request
   * @summary Client Cancel Appointment Request
   * @request PUT:/routes/appointments/requests/{request_id}/cancel
   */
  client_cancel_appointment_request = (
    { requestId, ...query }: ClientCancelAppointmentRequestParams,
    params: RequestParams = {},
  ) =>
    this.request<ClientCancelAppointmentRequestData, ClientCancelAppointmentRequestError>({
      path: `/appointments/requests/${requestId}/cancel`,
      method: "PUT",
      ...params,
    });

  /**
   * @description Updates multiple appointments in a series with the same changes. Only updates fields that are provided in the payload. Logs changes for each appointment individually.
   *
   * @tags Appointments, dbtn/module:appointments, dbtn/hasAuth
   * @name bulk_update_series_appointments
   * @summary Bulk Update Series Appointments
   * @request PUT:/routes/appointments/series/{series_id}/bulk-update
   */
  bulk_update_series_appointments = (
    { seriesId, ...query }: BulkUpdateSeriesAppointmentsParams,
    data: BulkUpdateSeriesRequest,
    params: RequestParams = {},
  ) =>
    this.request<BulkUpdateSeriesAppointmentsData, BulkUpdateSeriesAppointmentsError>({
      path: `/appointments/series/${seriesId}/bulk-update`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Cancel individual client attendance for an appointment
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name cancel_individual_attendance_appointment
   * @summary Cancel Individual Attendance Appointment
   * @request POST:/routes/appointments/{appointment_id}/cancel-individual-attendance
   */
  cancel_individual_attendance_appointment = (
    { appointmentId, ...query }: CancelIndividualAttendanceAppointmentParams,
    data: AppApisAppointmentsIndividualCancellationRequest,
    params: RequestParams = {},
  ) =>
    this.request<CancelIndividualAttendanceAppointmentData, CancelIndividualAttendanceAppointmentError>({
      path: `/appointments/${appointmentId}/cancel-individual-attendance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Rebook individual client attendance for an appointment
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name rebook_individual_attendance_appointment
   * @summary Rebook Individual Attendance Appointment
   * @request POST:/routes/appointments/{appointment_id}/rebook-individual-attendance
   */
  rebook_individual_attendance_appointment = (
    { appointmentId, ...query }: RebookIndividualAttendanceAppointmentParams,
    data: AppApisAppointmentsIndividualRebookRequest,
    params: RequestParams = {},
  ) =>
    this.request<RebookIndividualAttendanceAppointmentData, RebookIndividualAttendanceAppointmentError>({
      path: `/appointments/${appointmentId}/rebook-individual-attendance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description DEPRECATED: This endpoint has been moved to staff_schedule API for centralization. Use /routes/staff/appointments/{appointment_id}/manual-clock-override instead.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name manual_time_override
   * @summary Manual Time Override
   * @request POST:/routes/manual-time-override
   */
  manual_time_override = (data: AppApisAppointmentsManualTimeOverrideRequest, params: RequestParams = {}) =>
    this.request<ManualTimeOverrideData, ManualTimeOverrideError>({
      path: `/manual-time-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Updates the status of an appointment request (in 'appointment_requests'). If confirming, it creates a new appointment in the main 'appointments' collection. If rescheduling, it updates the details on the request itself. Requires admin or staff role (basic auth check included, fine-grained role check might be needed).
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name update_appointment_status_legacy
   * @summary Update Appointment Status Legacy
   * @request PUT:/routes/appointments/requests/{request_id}/status
   */
  update_appointment_status_legacy = (
    { requestId, ...query }: UpdateAppointmentStatusLegacyParams,
    data: AppApisAppointmentsAppointmentUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateAppointmentStatusLegacyData, UpdateAppointmentStatusLegacyError>({
      path: `/appointments/requests/${requestId}/status`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Allows a client to cancel their own accepted or scheduled appointment (in the main 'appointments' collection).
   *
   * @tags Appointments, dbtn/module:appointments, dbtn/hasAuth
   * @name client_cancel_accepted_appointment
   * @summary Client Cancel Accepted Appointment
   * @request PUT:/routes/appointments/{appointment_id}/cancel
   */
  client_cancel_accepted_appointment = (
    { appointmentId, ...query }: ClientCancelAcceptedAppointmentParams,
    params: RequestParams = {},
  ) =>
    this.request<ClientCancelAcceptedAppointmentData, ClientCancelAcceptedAppointmentError>({
      path: `/appointments/${appointmentId}/cancel`,
      method: "PUT",
      ...params,
    });

  /**
   * @description Rebooks a previously cancelled client back into an appointment. This converts the client from a cancellation object back to a string ID in the clientIds array.
   *
   * @tags dbtn/module:appointments, dbtn/hasAuth
   * @name rebook_client_from_appointment
   * @summary Rebook Client From Appointment
   * @request POST:/routes/appointments/{appointment_id}/clients/{client_id}/rebook
   */
  rebook_client_from_appointment = (
    { appointmentId, clientId, ...query }: RebookClientFromAppointmentParams,
    data: RebookClientRequest,
    params: RequestParams = {},
  ) =>
    this.request<RebookClientFromAppointmentData, RebookClientFromAppointmentError>({
      path: `/appointments/${appointmentId}/clients/${clientId}/rebook`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Lists all unassigned appointments (no staff assigned). An appointment is considered unassigned if its staffIds array is null or empty.
   *
   * @tags Appointments, dbtn/module:appointments, dbtn/hasAuth
   * @name list_unassigned_appointments
   * @summary List Unassigned Appointments
   * @request GET:/routes/appointments/unassigned
   */
  list_unassigned_appointments = (params: RequestParams = {}) =>
    this.request<ListUnassignedAppointmentsData, any>({
      path: `/appointments/unassigned`,
      method: "GET",
      ...params,
    });

  /**
   * @description Updates specific details of an existing appointment in the 'appointments' collection. Handles updating fields like times, address, notes, staff, service etc., based on payload. May change appointment status to 'assigned' or 'booked' based on staffIds. Requires admin or staff role. Requires a 'change_reason' in the payload for logging purposes.
   *
   * @tags Appointments, dbtn/module:appointments, dbtn/hasAuth
   * @name update_appointment_request_details
   * @summary Update Appointment Details
   * @request PUT:/appointments/{appointment_id}/details
   */
  update_appointment_request_details = (
    { appointmentId, ...query }: UpdateAppointmentRequestDetailsParams,
    data: UpdateAppointmentRequestDetailsPayload,
    params: RequestParams = {},
  ) =>
    this.request<UpdateAppointmentRequestDetailsData, UpdateAppointmentRequestDetailsError>({
      path: `/appointments/${appointmentId}/details`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Save billing time or duration overrides to staffattendance record immediately. Supports both time overrides (actualBillableStartTime/EndTime) and duration overrides (actualBillableDuration in minutes).
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name save_billing_override
   * @summary Save Billing Override
   * @request POST:/routes/billing/save-billing-override
   */
  save_billing_override = (data: SaveBillingOverrideRequest, params: RequestParams = {}) =>
    this.request<SaveBillingOverrideData, SaveBillingOverrideError>({
      path: `/billing/save-billing-override`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetch specific staffattendance records by IDs with billing calculations. Used to efficiently refresh just the changed records after override.
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name refresh_specific_records
   * @summary Refresh Specific Records
   * @request POST:/routes/billing/refresh-specific-records
   */
  refresh_specific_records = (data: RefreshSpecificRecordsRequest, params: RequestParams = {}) =>
    this.request<RefreshSpecificRecordsData, RefreshSpecificRecordsError>({
      path: `/billing/refresh-specific-records`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get staffattendance records that have not been approved for billing. Defaults to previous week (Mon-Sun). Excludes lunch breaks.
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name get_unapproved_attendance
   * @summary Get Unapproved Attendance
   * @request GET:/routes/billing/unapproved-attendance
   */
  get_unapproved_attendance = (query: GetUnapprovedAttendanceParams, params: RequestParams = {}) =>
    this.request<GetUnapprovedAttendanceData, GetUnapprovedAttendanceError>({
      path: `/billing/unapproved-attendance`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get pending billing records that need final approval.
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name get_pending_billing_records
   * @summary Get Pending Billing Records
   * @request GET:/routes/billing/pending-billing-records
   */
  get_pending_billing_records = (query: { start_date?: string; end_date?: string }, params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/billing/pending-billing-records`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Update a billing record's status from 'pending' to 'approved' or 'review'.
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name update_billing_record_status
   * @summary Update Billing Record Status
   * @request POST:/routes/billing/update-billing-record-status
   */
  update_billing_record_status = (data: { billingRecordId: string; status: string }, params: RequestParams = {}) =>
    this.request<{ success: boolean; message: string }, any>({
      path: `/billing/update-billing-record-status`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Approve a billing line item by creating OR updating a billingRecord and updating the staffattendance record's billingApproval tracking.
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name approve_billing_line_item
   * @summary Approve Billing Line Item
   * @request POST:/routes/billing/approve-billing-line-item
   */
  approve_billing_line_item = (data: ApproveBillingLineItemRequest, params: RequestParams = {}) =>
    this.request<ApproveBillingLineItemData, ApproveBillingLineItemError>({
      path: `/billing/approve-billing-line-item`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name approve_billing
   * @summary Approve Billing
   * @request POST:/routes/billing/approve
   */
  approve_billing = (data: ApproveBillingRequest, params: RequestParams = {}) =>
    this.request<ApproveBillingData, ApproveBillingError>({
      path: `/billing/approve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Fetch all billing records with status 'in_review' and group them by appointmentId.
   *
   * @tags dbtn/module:billing_review, dbtn/hasAuth
   * @name get_in_review_items
   * @summary Get In Review Items
   * @request GET:/in-review-items
   */
  get_in_review_items = (params: RequestParams = {}) =>
    this.request<GetInReviewItemsData, any>({
      path: `/in-review-items`,
      method: "GET",
      ...params,
    });

  /**
   * @description Mark a billing line item for review by creating a billingRecord with 'in_review' status. This is identical to approve_billing_line_item but sets status to 'in_review'.
   *
   * @tags dbtn/module:billing_review, dbtn/hasAuth
   * @name mark_billing_for_review
   * @summary Mark Billing For Review
   * @request POST:/routes/mark-for-review
   */
  mark_billing_for_review = (data: MarkForReviewRequest, params: RequestParams = {}) =>
    this.request<MarkBillingForReviewData, MarkBillingForReviewError>({
      path: `/mark-for-review`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Split a billing line item in the lineItems array: - REMOVE the original item from lineItems array - ADD two new items with split times to the same array Array grows from N items to N+1 items
   *
   * @tags dbtn/module:billing_review, dbtn/hasAuth
   * @name split_billing_line_item
   * @summary Split Billing Line Item
   * @request POST:/split-billing-item
   */
  split_billing_line_item = (data: SplitBillingRequest, params: RequestParams = {}) =>
    this.request<SplitBillingLineItemData, SplitBillingLineItemError>({
      path: `/split-billing-item`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Split a billing record into separate records for each staff member
   *
   * @tags dbtn/module:billing_review, dbtn/hasAuth
   * @name split_billing_by_staff
   * @summary Split Billing By Staff
   * @request POST:/split-by-staff
   */
  split_billing_by_staff = (
    data: { lineItemId: string; staffSplits: Array<{ staffName: string; staffId: string; startTime: string; endTime: string; distance?: number }> },
    params: RequestParams = {}
  ) =>
    this.request<{ success: boolean; message: string; error?: string; newRecordIds?: string[] }, any>({
      path: `/split-by-staff`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Apply suggested billing splits for an appointment with client time overrides
   *
   * @tags dbtn/module:billing, dbtn/hasAuth
   * @name apply_suggested_splits
   * @summary Apply Suggested Billing Splits
   * @request POST:/billing/apply-suggested-splits
   */
  apply_suggested_splits = (
    data: { appointmentId: string; suggestedSplits: any[]; travelPeriodIndex?: number },
    params: RequestParams = {},
  ) =>
    this.request<
      { success: boolean; message: string; appliedSplits?: any[] | null },
      any
    >({
      path: `/billing/apply-suggested-splits`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update the staff:client ratio of a billing line item and recalculate prices. Uses fullHourRate, fullKmRate, and fullExpenses as the base values. Ratio format: "staff:client" (e.g., "1:2" means 1 staff to 2 clients) Cost ratio calculation: staff / client - "1:1" = 1.0 (full price) - "1:2" = 0.5 (half price) - "2:1" = 2.0 (double price)
   *
   * @tags dbtn/module:billing_review, dbtn/hasAuth
   * @name update_billing_ratio
   * @summary Update Billing Ratio
   * @request POST:/routes/update-ratio
   */
  update_billing_ratio = (data: UpdateRatioRequest, params: RequestParams = {}) =>
    this.request<UpdateBillingRatioData, UpdateBillingRatioError>({
      path: `/update-ratio`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Sync a single approved leave request to Xero. Only syncs approved leave requests that haven't been synced yet. Requires admin access.
   *
   * @tags dbtn/module:xero_leave_sync
   * @name sync_single_leave_request
   * @summary Sync Single Leave Request
   * @request POST:/routes/xero-leave-sync/sync-leave-request
   */
  sync_single_leave_request = (data: SyncLeaveRequest, params: RequestParams = {}) =>
    this.request<SyncSingleLeaveRequestData, SyncSingleLeaveRequestError>({
      path: `/xero-leave-sync/sync-leave-request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Bulk sync multiple leave requests to Xero. Can either: - Sync specific leave request IDs - Sync all approved unsynced leave (if sync_all_approved=True) Requires admin access.
   *
   * @tags dbtn/module:xero_leave_sync
   * @name bulk_sync_leave_requests
   * @summary Bulk Sync Leave Requests
   * @request POST:/routes/xero-leave-sync/bulk-sync-leave
   */
  bulk_sync_leave_requests = (data: BulkSyncRequest, params: RequestParams = {}) =>
    this.request<BulkSyncLeaveRequestsData, BulkSyncLeaveRequestsError>({
      path: `/xero-leave-sync/bulk-sync-leave`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get sync status for a leave request. Returns whether the leave has been synced to Xero and any sync errors.
   *
   * @tags dbtn/module:xero_leave_sync
   * @name get_leave_sync_status
   * @summary Get Leave Sync Status
   * @request GET:/routes/xero-leave-sync/sync-status/{leave_request_id}
   */
  get_leave_sync_status = ({ leaveRequestId, ...query }: GetLeaveSyncStatusParams, params: RequestParams = {}) =>
    this.request<GetLeaveSyncStatusData, GetLeaveSyncStatusError>({
      path: `/xero-leave-sync/sync-status/${leaveRequestId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Sync multiple consecutive leave requests as a single grouped entry in Xero.
   * This is used when approving multi-day leave to avoid creating separate line items on the payslip.
   *
   * @tags dbtn/module:xero_leave_sync
   * @name sync_grouped_leave_requests
   * @summary Sync Grouped Leave Requests
   * @request POST:/routes/xero-leave-sync/sync-grouped-leave
   */
  sync_grouped_leave_requests = (data: { leave_request_ids: string[] }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/xero-leave-sync/sync-grouped-leave`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get daily digest email configuration
   * @tags daily-digest
   * @name get_daily_digest_config
   * @summary Get Daily Digest Config
   * @request GET:/daily-digest/config
   */
  get_daily_digest_config = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/config`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update daily digest email configuration
   * @tags daily-digest
   * @name update_daily_digest_config
   * @summary Update Daily Digest Config
   * @request POST:/daily-digest/config
   */
  update_daily_digest_config = (data: { emailRecipients: string[] }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/config`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Generate daily digest for a specific date
   * @tags daily-digest
   * @name generate_daily_digest
   * @summary Generate Daily Digest
   * @request GET:/daily-digest/generate
   */
  generate_daily_digest = (date?: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/generate${date ? `?date=${date}` : ''}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Generate daily digest for a date range
   * @tags daily-digest
   * @name generate_daily_digest_range
   * @summary Generate Daily Digest for Date Range
   * @request GET:/daily-digest/generate
   */
  generate_daily_digest_range = (startDate: string, endDate: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/generate?start_date=${startDate}&end_date=${endDate}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Send daily digest email
   * @tags daily-digest
   * @name send_daily_digest_email
   * @summary Send Daily Digest Email
   * @request POST:/daily-digest/send-email
   */
  send_daily_digest_email = (date?: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/send-email${date ? `?date=${date}` : ''}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Send daily digest email for date range
   * @tags daily-digest
   * @name send_daily_digest_email_range
   * @summary Send Daily Digest Email for Date Range
   * @request POST:/daily-digest/send-email
   */
  send_daily_digest_email_range = (startDate: string, endDate: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/daily-digest/send-email?start_date=${startDate}&end_date=${endDate}`,
      method: "POST",
      ...params,
    });

  // Community Events API
  /**
   * @description Create a new community event
   * @tags community-events
   * @name create_community_event
   * @request POST:/routes/community-events
   */
  create_community_event = (data: CommunityEventCreate, params: RequestParams = {}) =>
    this.request<CommunityEventResponse, any>({
      path: `/community-events`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List all community events
   * @tags community-events
   * @name list_community_events
   * @request GET:/routes/community-events
   */
  /**
   * @name pending_billing_count
   * Lightweight count of shifts in a range still awaiting billing approval (pre-payroll checklist).
   */
  pending_billing_count = (query: { start_date: string; end_date: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/shift-approval/pending-billing-count`, method: "GET", query, ...params });

  /**
   * @name list_oc_movies
   */
  list_oc_movies = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies`, method: "GET", ...params });

  /**
   * @name get_oc_movie_alert_subscribers
   */
  get_oc_movie_alert_subscribers = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-alert-subscribers`, method: "GET", ...params });

  /**
   * @name list_surveys
   */
  list_surveys = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/surveys`, method: "GET", ...params });

  /**
   * @name create_survey
   */
  create_survey = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/surveys`, method: "POST", body: data, type: ContentType.Json, ...params });

  /**
   * @name update_survey
   */
  update_survey = (surveyId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/surveys/${surveyId}`, method: "PUT", body: data, type: ContentType.Json, ...params });

  /**
   * @name delete_survey
   */
  delete_survey = (surveyId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/surveys/${surveyId}`, method: "DELETE", ...params });

  /**
   * @name list_survey_responses
   */
  list_survey_responses = (surveyId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/surveys/${surveyId}/responses`, method: "GET", ...params });

  /**
   * @name list_survey_library_videos
   */
  list_survey_library_videos = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/survey-video-library`, method: "GET", ...params });

  /**
   * @name add_survey_library_video
   */
  add_survey_library_video = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/survey-video-library`, method: "POST", body: data, type: ContentType.Json, ...params });

  /**
   * @name rename_survey_library_video
   */
  rename_survey_library_video = (videoId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/survey-video-library/${videoId}`, method: "PUT", body: data, type: ContentType.Json, ...params });

  /**
   * @name delete_survey_library_video
   */
  delete_survey_library_video = (videoId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/survey-video-library/${videoId}`, method: "DELETE", ...params });

  /**
   * @name payroll_reconciliation
   */
  payroll_reconciliation = (query: { fortnight_start: string; fortnight_end: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/payroll-reconciliation`, method: "GET", query, ...params });

  /**
   * @name payroll_reconciliation_history
   */
  payroll_reconciliation_history = (query: { fortnight_start: string; limit?: number }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/payroll-reconciliation/history`, method: "GET", query, ...params });

  /**
   * @name staff_day_appointments
   */
  staff_day_appointments = (query: { staff_id: string; start_date: string; end_date: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/admin-timesheet/staff-day-appointments`, method: "GET", query, ...params });

  /**
   * @name payroll_fortnight_holidays
   */
  payroll_fortnight_holidays = (query: { fortnight_start: string; fortnight_end: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/payroll-fortnight-holidays`, method: "GET", query, ...params });

  /**
   * @name payroll_entries_staleness
   */
  payroll_entries_staleness = (query: { fortnight_start: string; fortnight_end: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/payroll-entries-staleness`, method: "GET", query, ...params });

  /**
   * @name set_guardian_note
   * Admins only: save/edit the redacted guardian-visible copy of a shift note. Pass text:null to remove.
   */
  set_guardian_note = (noteId: string, data: { text?: string | null }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/notes/${noteId}/guardian-note`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @name mark_news_article_read
   * Record that the signed-in user opened a news article (read receipt).
   */
  mark_news_article_read = (newsId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/news/${newsId}/mark-read`, method: "POST", ...params });

  /**
   * @name get_news_read_stats
   * Admins: per-article read receipt stats.
   */
  get_news_read_stats = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/news/admin/read-stats`, method: "GET", ...params });

  /**
   * @name get_oc_movies_interest
   */
  get_oc_movies_interest = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-interest`, method: "GET", ...params });

  /**
   * @name book_oc_movie_interests
   * One-tap booking: merge all 'requested' interests for a movie session into one pending group appointment.
   */
  book_oc_movie_interests = (movieId: string, params: RequestParams = {}) =>
    this.request<{ appointmentId: string; clientCount: number; clientNames: string[] }, any>({
      path: `/oc-movies/${movieId}/book-interests`,
      method: "POST",
      ...params,
    });

  /**
   * @name get_shift_confirmations_admin_overview
   * Admin at-a-glance view of a day's shift-confirmation statuses.
   */
  get_shift_confirmations_admin_overview = (query?: { date?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/shift-confirmations/admin-overview`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @name nudge_shift_confirmation
   * Admin: re-send the confirmation push to one staffer for a date.
   */
  nudge_shift_confirmation = (body: { staffId: string; date?: string }, params: RequestParams = {}) =>
    this.request<{ success: boolean; pendingCount: number; pushSent: boolean }, any>({
      path: `/shift-confirmations/nudge`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @name get_shift_confirmations_for_appointment
   * Admin: per-staff confirmation status for one appointment (hover popup pill).
   */
  get_shift_confirmations_for_appointment = (query: { appointment_id: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/shift-confirmations/for-appointment`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @name get_payable_preview
   * Admin: lunch-adjusted payable minutes for the booked/clocked windows of one SA.
   */
  get_payable_preview = (query: { entry_id: string; start?: string; end?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/payable-preview`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @name get_event_staffing_gaps
   * Admin: event minimumStaffing + time periods below it for an appointment.
   */
  get_event_staffing_gaps = (query: { appointment_id: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/events/staffing-gaps`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @name get_pending_shift_confirmations
   * Admin: all pending confirmations in a date range (diary amber-dot overlay).
   */
  get_pending_shift_confirmations = (query: { start_date: string; end_date: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/shift-confirmations/pending`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @name create_oc_movie
   */
  create_oc_movie = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies`, method: "POST", body: data, type: ContentType.Json, ...params });

  /**
   * @name update_oc_movie
   */
  update_oc_movie = (movieId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies/${movieId}`, method: "PUT", body: data, type: ContentType.Json, ...params });

  /**
   * @name delete_oc_movie
   */
  delete_oc_movie = (movieId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies/${movieId}`, method: "DELETE", ...params });

  /**
   * @name list_cinema_locations
   */
  list_cinema_locations = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-cinemas`, method: "GET", ...params });

  /**
   * @name update_cinema_location
   */
  update_cinema_location = (cinemaId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-cinemas/${cinemaId}`, method: "PUT", body: data, type: ContentType.Json, ...params });

  /**
   * @name list_cinema_brands
   */
  list_cinema_brands = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-brands`, method: "GET", ...params });

  /**
   * @name update_cinema_brand
   */
  update_cinema_brand = (brandId: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-brands/${brandId}`, method: "PUT", body: data, type: ContentType.Json, ...params });

  /**
   * @name search_movie_poster
   */
  search_movie_poster = (query: { title: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-poster-search`, method: "GET", query, ...params });

  /**
   * @name scrape_oc_movies
   */
  scrape_oc_movies = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/oc-movies-scrape`, method: "POST", ...params });

  /**
   * @name get_community_events_interest
   * Per community event: distinct clients with a requested/scheduled appointment overlapping the event window.
   */
  get_community_events_interest = (params: RequestParams = {}) =>
    this.request<{ interests: Record<string, { count: number; clients: { id: string; name: string }[] }> }, any>({
      path: `/community-events-interest`,
      method: "GET",
      ...params,
    });

  /**
   * @name book_community_event_interests
   * One-tap booking: merge all 'requested' interests for an event into one pending group appointment.
   */
  book_community_event_interests = (eventId: string, params: RequestParams = {}) =>
    this.request<{ appointmentId: string; clientCount: number; clientNames: string[] }, any>({
      path: `/community-events/${eventId}/book-interests`,
      method: "POST",
      ...params,
    });

  list_community_events = (query?: { active_only?: boolean; start_date?: string; end_date?: string }, params: RequestParams = {}) =>
    this.request<CommunityEventsListResponse, any>({
      path: `/community-events${query ? `?${new URLSearchParams(Object.entries(query).filter(([_, v]) => v !== undefined).map(([k, v]) => [k, String(v)])).toString()}` : ''}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get community events by date range (optimized for diary)
   * @tags community-events
   * @name get_community_events_by_date_range
   * @request GET:/routes/community-events-by-date-range
   */
  get_community_events_by_date_range = (startDate: string, endDate: string, params: RequestParams = {}) =>
    this.request<CommunityEventsListResponse, any>({
      path: `/community-events-by-date-range?start_date=${startDate}&end_date=${endDate}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get a specific community event
   * @tags community-events
   * @name get_community_event
   * @request GET:/routes/community-events/{event_id}
   */
  get_community_event = (eventId: string, params: RequestParams = {}) =>
    this.request<CommunityEventResponse, any>({
      path: `/community-events/${eventId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update a community event
   * @tags community-events
   * @name update_community_event
   * @request PUT:/routes/community-events/{event_id}
   */
  update_community_event = (eventId: string, data: CommunityEventUpdate, params: RequestParams = {}) =>
    this.request<CommunityEventResponse, any>({
      path: `/community-events/${eventId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a community event
   * @tags community-events
   * @name delete_community_event
   * @request DELETE:/routes/community-events/{event_id}
   */
  delete_community_event = (eventId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/community-events/${eventId}`,
      method: "DELETE",
      ...params,
    });


  // ---------------------------------------------------------------------------
  // LMS — Learning Management System (added manually — backend at app/apis/lms).
  // ---------------------------------------------------------------------------
  /**
   * @description List every active LMS training entry (admin manage page).
   * @name list_lms_entries
   * @request GET:/routes/lms/list
   */
  list_lms_entries = (params: RequestParams = {}) =>
    this.request<{ entries: any[] }, any>({
      path: `/lms/list`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new LMS training entry (admin only).
   * @name create_lms_entry
   * @request POST:/routes/lms/create
   */
  create_lms_entry = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/lms/create`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update an LMS training entry (admin only).
   * @name update_lms_entry
   * @request PUT:/routes/lms/{entry_id}
   */
  update_lms_entry = (
    { entryId }: { entryId: string },
    data: any,
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/lms/${entryId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Soft-delete an LMS training entry (admin only).
   * @name delete_lms_entry
   * @request DELETE:/routes/lms/{entry_id}
   */
  delete_lms_entry = (
    { entryId }: { entryId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/lms/${entryId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Staff endpoint — returns LMS entries the current
   * staff member still needs. Entries linked to qualifications the
   * staff already holds (and that aren't expiring soon) are hidden.
   * @name get_my_training
   * @request GET:/routes/lms/my-training
   */
  get_my_training = (params: RequestParams = {}) =>
    this.request<{ entries: any[] }, any>({
      path: `/lms/my-training`,
      method: "GET",
      ...params,
    });

  /**
   * @description Admin uploads an LMS thumbnail image. Returns the
   * public Firebase Storage URL to be stored on the entry's
   * `thumbnailUrl` field via create/update.
   * @name upload_lms_thumbnail
   * @request POST:/routes/lms/thumbnail-upload
   */
  upload_lms_thumbnail = (
    data: { file: File },
    params: RequestParams = {},
  ) =>
    this.request<{ url: string }, any>({
      path: `/lms/thumbnail-upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });



  /**
   * @description Staff uploads a completion certificate (image|pdf)
   * for an LMS entry. The brain client converts the data object into
   * multipart/form-data internally — pass the File and form strings as
   * a plain object.
   * @name submit_lms_completion
   * @request POST:/routes/lms/{entry_id}/submit-completion
   */
  submit_lms_completion = (
    { entryId }: { entryId: string },
    data: {
      file: File;
      expiryDate?: string;
      certificateNumber?: string;
      notes?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/lms/${entryId}/submit-completion`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Staff: list my own completion submissions.
   * @name list_my_lms_submissions
   * @request GET:/routes/lms/my-submissions
   */
  list_my_lms_submissions = (params: RequestParams = {}) =>
    this.request<{ submissions: any[] }, any>({
      path: `/lms/my-submissions`,
      method: "GET",
      ...params,
    });

  /**
   * @description Admin: list submissions awaiting review.
   * @name list_pending_lms_submissions
   * @request GET:/routes/lms/submissions/pending
   */
  list_pending_lms_submissions = (params: RequestParams = {}) =>
    this.request<{ submissions: any[] }, any>({
      path: `/lms/submissions/pending`,
      method: "GET",
      ...params,
    });

  /**
   * @description Admin: list every submission. Optional ?status_filter=approved|rejected|pending
   * @name list_all_lms_submissions
   * @request GET:/routes/lms/submissions/all
   */
  list_all_lms_submissions = (
    query?: { status_filter?: string },
    params: RequestParams = {},
  ) =>
    this.request<{ submissions: any[] }, any>({
      path: `/lms/submissions/all`,
      method: "GET",
      query,
      ...params,
    });

  /**
   * @description Admin: approve a pending submission. Creates one
   * qualification doc per linkedQualification on the staff record.
   * @name approve_lms_submission
   * @request POST:/routes/lms/submissions/{submission_id}/approve
   */
  approve_lms_submission = (
    { submissionId }: { submissionId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/lms/submissions/${submissionId}/approve`,
      method: "POST",
      ...params,
    });

  /**
   * @description Admin: reject a pending submission.
   * @name reject_lms_submission
   * @request POST:/routes/lms/submissions/{submission_id}/reject
   */
  reject_lms_submission = (
    { submissionId }: { submissionId: string },
    data: { reason?: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/lms/submissions/${submissionId}/reject`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });




  // ---------------------------------------------------------------------------
  // KM Rate Catalog (added manually — backend at app/apis/km_rate_catalog).
  // ---------------------------------------------------------------------------
  /**
   * @description List KM rate catalog entries. Optionally filter by type ('abt' or 'pt').
   * @name list_km_rates
   * @request GET:/routes/km-rate-catalog/list
   */
  list_km_rates = (
    query: { type?: "abt" | "pt" } = {},
    params: RequestParams = {},
  ) =>
    this.request<
      {
        entries: Array<{
          id: string;
          type: "abt" | "pt";
          km_code: string;
          km_rate: number;
          km_description: string;
          registration_group_number?: string | null;
          registration_group_name?: string | null;
          support_category_number?: string | null;
          support_category_name?: string | null;
          pricebooks: string[];
          is_active: boolean;
          created_at?: string | null;
          updated_at?: string | null;
        }>;
      },
      any
    >({
      path: `/km-rate-catalog/list`,
      method: "GET",
      query,
      ...params,
    });

  /**
   * @description Create a new KM rate catalog entry.
   * @name create_km_rate
   * @request POST:/routes/km-rate-catalog
   */
  create_km_rate = (
    data: {
      type: "abt" | "pt";
      km_code: string;
      km_rate: number;
      km_description?: string;
      registration_group_number?: string;
      registration_group_name?: string;
      support_category_number?: string;
      support_category_name?: string;
      pricebooks?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/km-rate-catalog`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update a KM rate catalog entry.
   * @name update_km_rate
   * @request PUT:/routes/km-rate-catalog/{entry_id}
   */
  update_km_rate = (
    { entryId }: { entryId: string },
    data: {
      km_code?: string;
      km_rate?: number;
      km_description?: string;
      registration_group_number?: string;
      registration_group_name?: string;
      support_category_number?: string;
      support_category_name?: string;
      is_active?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/km-rate-catalog/${entryId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a KM rate catalog entry (only if no price books are attached).
   * @name delete_km_rate
   * @request DELETE:/routes/km-rate-catalog/{entry_id}
   */
  delete_km_rate = (
    { entryId }: { entryId: string },
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; id: string }, any>({
      path: `/km-rate-catalog/${entryId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Attach a price book to a catalog entry. Auto-detaches the price book from any other entry of the same type.
   * @name attach_pricebook_to_km_rate
   * @request POST:/routes/km-rate-catalog/{entry_id}/attach/{pricebook_id}
   */
  attach_pricebook_to_km_rate = (
    { entryId, pricebookId }: { entryId: string; pricebookId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/km-rate-catalog/${entryId}/attach/${pricebookId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Detach a price book from a catalog entry.
   * @name detach_pricebook_from_km_rate
   * @request POST:/routes/km-rate-catalog/{entry_id}/detach/{pricebook_id}
   */
  detach_pricebook_from_km_rate = (
    { entryId, pricebookId }: { entryId: string; pricebookId: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/km-rate-catalog/${entryId}/detach/${pricebookId}`,
      method: "POST",
      ...params,
    });

  /**
   * @description Walk every price book and report any whose inline km_code (ABT) or provider_travel_km_code (PT) references a code we can't resolve against an active catalog entry.
   * @name detect_pricebook_drift
   * @request GET:/routes/km-rate-catalog/drift
   */
  detect_pricebook_drift = (params: RequestParams = {}) =>
    this.request<
      {
        drift_count: number;
        rows: Array<{
          pricebook_id: string;
          pricebook_name: string;
          kind: "abt" | "pt";
          inline_code: string;
          issue: "no_match" | "inactive_match";
        }>;
      },
      any
    >({
      path: `/km-rate-catalog/drift`,
      method: "GET",
      ...params,
    });

  // ---------------------------------------------------------------------------
  // Pull-from-Xero (Xero = source of truth)
  // ---------------------------------------------------------------------------
  /**
   * @description Pull a single invoice's payload (line items, status, totals,
   * reference) from Xero into Firestore. Locks the row against re-push so
   * manual Xero edits are preserved.
   * @name pull_invoice_from_xero
   * @request POST:/xero/pull-from-xero
   */
  pull_invoice_from_xero = (
    body: { invoice_id: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/xero/pull-from-xero`,
      method: "POST",
      body,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Bulk refresh: pull every Xero-synced invoice's payload
   * into Firestore. BillingRecords untouched, push-sync locked per row.
   * @name pull_all_invoices_from_xero
   * @request POST:/xero/pull-all-from-xero
   */
  pull_all_invoices_from_xero = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/xero/pull-all-from-xero`,
      method: "POST",
      ...params,
    });

  // ---------------------------------------------------------------------------
  // Billing Debug (added manually — backend at app/apis/billing_debug).
  // ---------------------------------------------------------------------------
  /**
   * @description Inspect every shift on a single day with the LIVE billing
   * recompute and the STORED billingRecord snapshot side-by-side. Bypasses
   * approval gate. Admin-only diagnostic.
   * @name inspect_billing_day
   * @request GET:/routes/billing-debug/inspect-day
   */
  inspect_billing_day = (
    query: { date: string; client_id?: string },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/billing-debug/inspect-day`,
      method: "GET",
      query,
      ...params,
    });

  // ---------------------------------------------------------------------------
  // Clock variance thresholds (added manually — backend at app/apis/admin_settings).
  // ---------------------------------------------------------------------------
  /**
   * @description Clock Details colour thresholds.
   * @name get_clock_variance
   * @request GET:/admin-settings/clock-variance
   */
  get_clock_variance = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/admin-settings/clock-variance`,
      method: "GET",
      ...params,
    });

  /**
   * @description Save Clock Details colour thresholds.
   * @name set_clock_variance
   * @request POST:/admin-settings/clock-variance
   */
  set_clock_variance = (
    data: { greenMins: number; amberMins: number; greenMeters: number; amberMeters: number },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/admin-settings/clock-variance`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
